import { type InsuranceCorporateIdentity } from "../types";

export function MercedesBenzBkkLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask0_31_1526)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M256.766 449.965C218.539 449.98 181.167 438.656 149.377 417.427C117.587 396.197 92.8077 366.016 78.1746 330.7C63.5415 295.385 59.7118 256.523 67.17 219.03C74.6283 181.538 93.0392 147.1 120.074 120.074C138.02 102.125 159.325 87.8874 182.774 78.173C206.223 68.4585 231.355 63.4577 256.736 63.4561C282.117 63.4544 307.25 68.452 330.7 78.1635C354.15 87.875 375.458 102.11 393.406 120.056C411.354 138.002 425.592 159.308 435.307 182.757C445.021 206.205 450.022 231.338 450.024 256.719C450.025 282.1 445.028 307.233 435.316 330.683C425.605 354.133 411.369 375.44 393.423 393.388C375.514 411.382 354.215 425.647 330.759 435.358C307.302 445.069 282.153 450.034 256.766 449.965ZM448.848 256.731C448.882 294.729 437.646 331.883 416.561 363.493C395.476 395.104 365.489 419.751 330.394 434.316C295.298 448.881 256.672 452.71 219.4 445.318C182.128 437.926 147.886 419.646 121.006 392.79C94.1251 365.934 75.8138 331.708 68.3881 294.443C60.9624 257.178 64.756 218.548 79.2891 183.44C93.8222 148.331 118.442 118.322 150.033 97.2078C181.625 76.0939 218.768 64.8241 256.766 64.8241C281.997 64.8011 306.985 69.7538 330.3 79.3986C353.614 89.0435 374.798 103.191 392.639 121.032C410.48 138.873 424.628 160.057 434.273 183.372C443.918 206.687 448.871 231.675 448.848 256.906"
          fill="white"
        />
      </g>
      <mask
        id="mask1_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask1_31_1526)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M256.766 88.223C223.437 88.2161 190.854 98.093 163.138 116.605C135.423 135.116 113.819 161.431 101.06 192.222C88.3006 223.012 84.9586 256.894 91.4566 289.584C97.9545 322.273 114.001 352.302 137.565 375.872C161.13 399.442 191.156 415.494 223.844 421.999C256.532 428.503 290.415 425.168 321.208 412.415C352.001 399.662 378.32 378.064 396.838 350.353C415.355 322.641 425.239 290.06 425.239 256.731C425.193 212.06 407.429 169.232 375.845 137.641C344.262 106.051 301.437 88.2785 256.766 88.223ZM426.811 256.731C426.811 290.363 416.838 323.239 398.153 351.203C379.468 379.166 352.911 400.961 321.839 413.832C290.768 426.702 256.577 430.069 223.592 423.508C190.606 416.947 160.307 400.752 136.526 376.971C112.745 353.19 96.5498 322.89 89.9886 289.905C83.4274 256.92 86.7949 222.729 99.6651 191.658C112.535 160.586 134.33 134.029 162.294 115.344C190.258 96.6593 223.134 86.6863 256.766 86.6863C301.865 86.6863 345.116 104.602 377.006 136.491C408.895 168.381 426.811 211.632 426.811 256.731Z"
          fill="white"
        />
      </g>
      <mask
        id="mask2_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="285"
        y="239"
        width="2"
        height="2"
      >
        <path
          d="M285.404 240.212L286.277 240.771C285.786 240.375 285.451 239.818 285.334 239.199L285.404 240.212Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_31_1526)">
        <path
          d="M285.578 241.19L284.67 239.583L286.067 238.815L287.01 240.352L285.578 241.19Z"
          fill="url(#paint1_linear_31_1526)"
        />
      </g>
      <mask
        id="mask3_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="64"
        y="64"
        width="386"
        height="386"
      >
        <path
          d="M87.3848 256.731C87.3848 223.239 97.3159 190.499 115.922 162.651C134.529 134.803 160.975 113.097 191.917 100.279C222.859 87.4604 256.907 84.1047 289.756 90.6362C322.605 97.1676 352.78 113.293 376.464 136.973C400.149 160.653 416.281 190.824 422.819 223.672C429.357 256.519 426.009 290.568 413.196 321.513C400.384 352.457 378.684 378.908 350.84 397.52C322.996 416.132 290.258 426.07 256.766 426.077C211.849 426.077 168.772 408.236 137.008 376.479C105.244 344.721 87.3941 301.648 87.3848 256.731ZM64.3001 256.731C64.3001 294.789 75.5851 331.992 96.7281 363.636C117.871 395.28 147.923 419.945 183.083 434.511C218.243 449.076 256.933 452.889 294.26 445.467C331.587 438.045 365.875 419.721 392.788 392.812C419.701 365.904 438.031 331.619 445.46 294.294C452.889 256.968 449.083 218.278 434.524 183.115C419.965 147.952 395.306 117.896 363.665 96.7475C332.025 75.5987 294.824 64.307 256.766 64.3C205.727 64.3 156.778 84.5728 120.684 120.66C84.591 156.746 64.3094 205.692 64.3001 256.731Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask3_31_1526)">
        <path
          d="M256.731 -128.131L641.593 256.696L256.731 641.558L-128.096 256.696L256.731 -128.131Z"
          fill="url(#paint2_linear_31_1526)"
        />
      </g>
      <mask
        id="mask4_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="64"
        y="64"
        width="386"
        height="386"
      >
        <path
          d="M75.8599 256.731C75.853 220.95 86.4571 185.97 106.331 156.215C126.205 126.461 154.456 103.268 187.512 89.5707C220.568 75.873 256.943 72.2855 292.037 79.2618C327.132 86.2382 359.37 103.465 384.673 128.764C409.977 154.063 427.21 186.297 434.193 221.39C441.176 256.483 437.596 292.859 423.905 325.918C410.213 358.976 387.026 387.232 357.275 407.111C327.525 426.991 292.547 437.602 256.766 437.602C208.796 437.593 162.792 418.535 128.869 384.618C94.9452 350.701 75.8784 304.701 75.8599 256.731ZM64.335 256.731C64.335 294.79 75.6209 331.995 96.7655 363.64C117.91 395.285 147.964 419.949 183.126 434.514C218.288 449.078 256.979 452.889 294.307 445.464C331.635 438.039 365.923 419.712 392.835 392.8C419.747 365.888 438.074 331.6 445.499 294.272C452.924 256.944 449.113 218.253 434.549 183.091C419.984 147.929 395.32 117.875 363.675 96.7305C332.03 75.5859 294.825 64.3 256.766 64.3C205.73 64.3 156.785 84.574 120.697 120.662C84.6089 156.75 64.335 205.695 64.335 256.731Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask4_31_1526)">
        <path
          d="M256.731 -128.131L641.593 256.696L256.731 641.558L-128.096 256.696L256.731 -128.131Z"
          fill="url(#paint3_linear_31_1526)"
        />
      </g>
      <mask
        id="mask5_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="256"
        y="64"
        width="193"
        height="386"
      >
        <path
          d="M256.766 65.2779C281.732 64.5952 306.582 68.923 329.848 78.0057C353.114 87.0884 374.323 100.742 392.224 118.159C410.124 135.577 424.352 156.405 434.067 179.414C443.783 202.423 448.788 227.145 448.788 252.121C448.788 277.097 443.783 301.819 434.067 324.828C424.352 347.837 410.124 368.665 392.224 386.083C374.323 403.5 353.114 417.153 329.848 426.236C306.582 435.319 281.732 439.647 256.766 438.964V449.057C307.01 447.884 354.803 427.101 389.923 391.151C425.044 355.201 444.707 306.937 444.707 256.679C444.707 206.42 425.044 158.156 389.923 122.206C354.803 86.2559 307.01 65.4727 256.766 64.3V65.2779Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask5_31_1526)">
        <path
          d="M449.162 64.3H256.731V449.162H449.162V64.3Z"
          fill="url(#paint4_linear_31_1526)"
        />
      </g>
      <mask
        id="mask6_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="85"
        y="225"
        width="172"
        height="212"
      >
        <path
          d="M85.6386 265.113C79.946 357.626 166.627 436.24 256.766 436.24V426.147C231.882 426.128 207.307 420.631 184.786 410.046C162.266 399.461 142.351 384.048 126.458 364.9C110.564 345.753 99.0806 323.342 92.8227 299.257C86.5648 275.173 85.686 250.006 90.2486 225.544C87.5943 238.579 86.0521 251.816 85.6386 265.113Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask6_31_1526)">
        <path
          d="M168.408 137.116L362.097 330.839L168.408 524.563L-25.3147 330.839L168.408 137.116Z"
          fill="url(#paint5_linear_31_1526)"
        />
      </g>
      <mask
        id="mask7_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask7_31_1526)">
        <path
          d="M433.097 286.067C433.516 281.422 433.76 277.86 433.76 274.961C434.107 270.573 433.003 266.193 430.617 262.493C429.069 260.378 427.889 258.016 427.125 255.509C426.015 250.648 425.407 245.686 425.309 240.701H426.252C426.357 245.601 426.942 250.478 427.998 255.264C428.709 257.639 429.807 259.881 431.246 261.9C433.709 265.752 434.86 270.297 434.529 274.856C434.529 277.79 434.319 281.387 433.865 286.032L433.097 286.067Z"
          fill="#DEDFDC"
        />
      </g>
      <mask
        id="mask8_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask8_31_1526)">
        <path
          d="M425.483 240.736H426.461V241.504C426.579 246.115 427.164 250.702 428.207 255.194C428.878 257.439 429.904 259.561 431.246 261.481L431.455 261.795C433.389 264.69 434.489 268.061 434.633 271.539C434.633 272.493 434.633 273.541 434.633 274.682C434.633 277.581 434.424 281.178 434.005 285.788H433.062C433.062 285.543 433.062 285.299 433.062 285.054C433.481 280.794 433.656 277.476 433.656 274.787C433.715 273.623 433.715 272.458 433.656 271.294C433.483 268.097 432.445 265.007 430.652 262.354L430.233 261.69C428.944 259.797 427.966 257.71 427.334 255.509C427.09 254.671 426.88 253.693 426.671 252.575C426.018 248.694 425.622 244.774 425.483 240.841"
          fill="#DBDDDA"
        />
      </g>
      <mask
        id="mask9_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask9_31_1526)">
        <path
          d="M425.483 240.666H426.461C426.427 240.921 426.427 241.179 426.461 241.434C426.582 246.01 427.167 250.562 428.207 255.02C428.878 257.253 429.904 259.364 431.246 261.271V261.585C433.14 264.476 434.247 267.81 434.459 271.259C434.459 272.167 434.459 273.215 434.459 274.333C434.459 277.266 434.249 280.759 433.83 285.404H432.887C432.853 285.16 432.853 284.913 432.887 284.67C433.271 280.444 433.446 277.161 433.446 274.472C433.446 273.215 433.446 272.097 433.446 270.98C433.24 267.8 432.205 264.729 430.443 262.074L430.024 261.411C428.729 259.533 427.75 257.457 427.125 255.264C426.88 254.426 426.671 253.448 426.461 252.331C425.781 248.488 425.372 244.601 425.239 240.701"
          fill="#D8DAD7"
        />
      </g>
      <mask
        id="mask10_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask10_31_1526)">
        <path
          d="M425.483 240.561H426.461C426.427 240.804 426.427 241.051 426.461 241.295C426.583 245.847 427.168 250.376 428.207 254.81C428.888 257.022 429.901 259.119 431.211 261.027C431.222 261.131 431.222 261.236 431.211 261.341C433.111 264.198 434.198 267.518 434.354 270.945C434.354 271.888 434.354 272.901 434.354 274.053C434.354 276.917 434.354 280.444 433.76 285.019H432.887V284.286C433.269 280.924 433.444 277.542 433.411 274.158C433.411 272.901 433.411 271.783 433.411 270.666C433.173 267.514 432.14 264.474 430.408 261.83C430.281 261.601 430.141 261.379 429.989 261.166C428.734 259.291 427.758 257.244 427.09 255.09C426.845 254.251 426.636 253.308 426.426 252.191C425.814 248.339 425.417 244.457 425.239 240.561"
          fill="#D5D8D5"
        />
      </g>
      <mask
        id="mask11_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask11_31_1526)">
        <path
          d="M425.483 240.456H426.391C426.374 240.701 426.374 240.946 426.391 241.19C426.504 245.711 427.102 250.207 428.173 254.601C428.838 256.797 429.852 258.872 431.176 260.747C431.247 260.844 431.306 260.95 431.351 261.062C433.247 263.894 434.334 267.191 434.494 270.596C434.494 271.539 434.494 272.552 434.494 273.669C434.479 277.309 434.281 280.946 433.9 284.565H432.992C433.009 284.333 433.009 284.099 432.992 283.867C433.341 279.711 433.516 276.463 433.516 273.809C433.516 272.552 433.516 271.469 433.516 270.316C433.306 267.186 432.283 264.164 430.547 261.55L430.128 260.887C428.86 259.032 427.883 256.995 427.23 254.845C426.985 254.007 426.776 253.064 426.566 251.981C425.952 248.165 425.556 244.317 425.379 240.456"
          fill="#D1D5D3"
        />
      </g>
      <mask
        id="mask12_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask12_31_1526)">
        <path
          d="M425.518 240.387H426.426C426.426 240.631 426.426 240.876 426.426 241.12C426.555 245.605 427.152 250.065 428.207 254.426C428.873 256.612 429.888 258.675 431.211 260.538C431.222 260.642 431.222 260.748 431.211 260.852C433.077 263.674 434.161 266.939 434.354 270.316C434.354 271.259 434.354 272.272 434.354 273.355C434.354 276.971 434.167 280.584 433.795 284.181H432.887C432.887 283.937 432.887 283.727 432.887 283.483C433.237 279.362 433.411 276.114 433.376 273.494C433.435 272.389 433.435 271.282 433.376 270.177C433.166 267.068 432.142 264.069 430.408 261.481L429.989 260.852C428.712 259.02 427.745 256.99 427.125 254.845C426.88 254.007 426.671 253.064 426.461 251.981C425.815 248.193 425.419 244.367 425.274 240.526"
          fill="#CED2D1"
        />
      </g>
      <mask
        id="mask13_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask13_31_1526)">
        <path
          d="M425.518 240.282H426.426C426.426 240.526 426.426 240.771 426.426 240.98C426.55 245.445 427.159 249.883 428.242 254.216C428.972 256.37 430.033 258.396 431.386 260.223C431.392 260.316 431.392 260.41 431.386 260.503C433.249 263.297 434.323 266.543 434.494 269.897C434.55 270.921 434.55 271.947 434.494 272.971C434.494 275.765 434.494 279.257 433.97 283.727H433.097V283.029C433.435 279.722 433.598 276.399 433.586 273.075C433.644 271.97 433.644 270.863 433.586 269.758C433.378 266.67 432.354 263.693 430.617 261.131L430.198 260.503C428.928 258.679 427.961 256.663 427.334 254.531C427.09 253.693 426.88 252.785 426.671 251.702C426.009 247.95 425.6 244.158 425.448 240.352"
          fill="#CBD0CF"
        />
      </g>
      <mask
        id="mask14_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask14_31_1526)">
        <path
          d="M425.518 240.212H426.426C426.426 240.456 426.426 240.666 426.426 240.91C426.551 245.341 427.16 249.744 428.242 254.042C428.923 256.189 429.936 258.216 431.246 260.049C431.239 260.142 431.239 260.235 431.246 260.328C433.11 263.096 434.184 266.32 434.354 269.653C434.41 270.653 434.41 271.656 434.354 272.656C434.354 275.45 434.354 278.908 433.83 283.343H432.957V282.679C433.341 278.593 433.446 275.415 433.446 272.796C433.446 271.574 433.446 270.491 433.446 269.513C433.187 266.442 432.154 263.486 430.443 260.922L430.024 260.293C428.787 258.475 427.823 256.487 427.16 254.391C426.915 253.553 426.706 252.645 426.461 251.562C425.862 247.839 425.477 244.084 425.309 240.317"
          fill="#C7CDCC"
        />
      </g>
      <mask
        id="mask15_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask15_31_1526)">
        <path
          d="M425.518 240.107H426.426C426.409 240.34 426.409 240.573 426.426 240.806C426.537 245.205 427.158 249.576 428.277 253.832C428.946 255.967 429.948 257.982 431.246 259.804L431.42 260.084C433.266 262.837 434.351 266.03 434.564 269.339C434.564 270.247 434.564 271.259 434.564 272.342C434.588 275.841 434.425 279.338 434.075 282.819H433.167C433.184 282.598 433.184 282.376 433.167 282.156C433.516 278.104 433.656 274.926 433.621 272.342C433.621 271.155 433.621 270.072 433.621 269.094C433.395 266.043 432.371 263.104 430.652 260.573L430.233 259.944C428.997 258.139 428.032 256.162 427.369 254.077C427.125 253.274 426.88 252.331 426.671 251.283C426.026 247.587 425.618 243.855 425.448 240.107"
          fill="#C4CACA"
        />
      </g>
      <mask
        id="mask16_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask16_31_1526)">
        <path
          d="M425.518 240.002H426.391C426.372 240.223 426.372 240.445 426.391 240.666C426.527 245.04 427.148 249.386 428.242 253.623C428.918 255.744 429.92 257.747 431.211 259.56C431.232 259.652 431.232 259.747 431.211 259.839C433.051 262.57 434.136 265.739 434.354 269.024C434.354 269.932 434.354 270.91 434.354 271.993C434.397 275.492 434.234 278.99 433.865 282.47H432.992C433.009 282.249 433.009 282.027 432.992 281.806C433.33 278.57 433.47 275.316 433.411 272.063C433.411 270.875 433.411 269.793 433.411 268.815C433.17 265.793 432.16 262.884 430.478 260.363L430.058 259.734C428.819 257.954 427.875 255.984 427.265 253.902C426.969 252.999 426.736 252.078 426.566 251.143C425.852 247.491 425.42 243.79 425.274 240.072"
          fill="#C1C7C8"
        />
      </g>
      <mask
        id="mask17_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask17_31_1526)">
        <path
          d="M425.518 239.932H426.391C426.372 240.153 426.372 240.375 426.391 240.596C426.525 244.936 427.146 249.247 428.242 253.448C428.928 255.547 429.917 257.536 431.176 259.35V259.63C433 262.342 434.084 265.484 434.319 268.745C434.319 269.653 434.319 270.631 434.319 271.678C434.362 275.176 434.211 278.674 433.865 282.156H432.992C432.992 281.946 432.992 281.736 432.992 281.527C433.306 277.546 433.446 274.542 433.411 271.853C433.411 270.666 433.411 269.618 433.202 268.64C432.944 265.644 431.935 262.761 430.268 260.258C430.127 260.057 429.999 259.847 429.884 259.63C428.651 257.865 427.696 255.922 427.055 253.867C426.811 253.064 426.566 252.156 426.356 251.108C425.667 247.464 425.235 243.777 425.064 240.072"
          fill="#BEC5C6"
        />
      </g>
      <mask
        id="mask18_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask18_31_1526)">
        <path
          d="M425.588 239.828H426.461C426.461 240.037 426.461 240.247 426.461 240.491C426.577 244.798 427.198 249.077 428.312 253.239C429.005 255.313 429.993 257.278 431.246 259.071L431.42 259.35C433.228 262.042 434.3 265.161 434.529 268.396C434.529 269.304 434.529 270.247 434.529 271.329C434.594 274.828 434.443 278.327 434.075 281.806H433.202C433.202 281.597 433.202 281.387 433.202 281.178C433.495 277.985 433.624 274.78 433.586 271.574C433.586 270.386 433.586 269.339 433.376 268.396C433.125 265.42 432.115 262.558 430.443 260.084C430.443 259.874 430.163 259.665 430.058 259.455C428.852 257.693 427.911 255.763 427.265 253.728C426.97 252.837 426.736 251.926 426.566 251.003C425.888 247.394 425.468 243.741 425.309 240.072"
          fill="#BAC2C3"
        />
      </g>
      <mask
        id="mask19_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask19_31_1526)">
        <path
          d="M425.588 239.723H426.461C426.461 239.933 426.461 240.142 426.461 240.352C426.585 244.635 427.206 248.889 428.312 253.029C429.013 255.09 430 257.041 431.246 258.826L431.42 259.106C433.214 261.779 434.285 264.871 434.529 268.081C434.529 268.954 434.529 269.932 434.529 270.98C434.584 274.419 434.456 277.858 434.145 281.283H433.271C433.254 281.073 433.254 280.863 433.271 280.654C433.551 276.708 433.725 273.669 433.656 271.12C433.656 269.967 433.656 268.919 433.446 267.942C433.167 264.983 432.159 262.139 430.512 259.665C430.372 259.463 430.244 259.253 430.128 259.036C428.91 257.288 427.957 255.37 427.299 253.343C427.055 252.54 426.811 251.667 426.601 250.654C425.883 247.097 425.451 243.489 425.309 239.863"
          fill="#B7BFC1"
        />
      </g>
      <mask
        id="mask20_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask20_31_1526)">
        <path
          d="M425.588 239.653H426.461C426.461 239.863 426.461 240.072 426.461 240.282C426.56 244.538 427.205 248.763 428.382 252.854C429.078 254.9 430.054 256.839 431.281 258.617V258.896C433.069 261.547 434.139 264.615 434.389 267.802C434.389 268.675 434.389 269.653 434.389 270.701C434.444 274.116 434.316 277.532 434.005 280.933H433.132C433.149 280.724 433.149 280.514 433.132 280.305C433.416 277.158 433.532 273.999 433.481 270.84C433.481 269.699 433.411 268.652 433.271 267.697C432.987 264.761 431.979 261.941 430.338 259.49L429.954 258.896C428.734 257.167 427.791 255.258 427.16 253.239C426.915 252.435 426.671 251.562 426.461 250.549C425.753 247.003 425.321 243.406 425.169 239.793"
          fill="#B4BDBF"
        />
      </g>
      <mask
        id="mask21_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask21_31_1526)">
        <path
          d="M425.588 239.548H426.461C426.461 239.758 426.461 239.968 426.461 240.177C426.56 244.399 427.206 248.589 428.382 252.645C429.063 254.675 430.04 256.593 431.281 258.338V258.617C433.059 261.259 434.129 264.314 434.389 267.488C434.389 268.361 434.389 269.304 434.599 270.351C434.671 273.744 434.543 277.137 434.214 280.514H433.341C433.36 280.317 433.36 280.118 433.341 279.921C433.626 276.798 433.742 273.661 433.691 270.526C433.691 269.373 433.691 268.361 433.481 267.418C433.201 264.502 432.192 261.704 430.547 259.28L430.163 258.687C428.977 256.963 428.037 255.082 427.369 253.099C427.09 252.227 426.857 251.341 426.671 250.445C425.952 246.899 425.508 243.303 425.344 239.688"
          fill="#B1BABC"
        />
      </g>
      <mask
        id="mask22_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask22_31_1526)">
        <path
          d="M425.588 239.479H426.426C426.407 239.676 426.407 239.875 426.426 240.072C426.526 244.259 427.172 248.415 428.347 252.435C429.02 254.458 429.998 256.365 431.246 258.093V258.372C433.008 260.996 434.078 264.024 434.354 267.173C434.354 268.058 434.424 269.001 434.564 270.002C434.651 273.37 434.534 276.741 434.214 280.095H433.341C433.341 279.885 433.341 279.711 433.341 279.501C433.608 276.389 433.701 273.264 433.621 270.142C433.61 269.102 433.54 268.065 433.411 267.033C433.145 264.142 432.148 261.366 430.512 258.966C430.405 258.756 430.276 258.557 430.128 258.372C428.943 256.661 428.002 254.792 427.334 252.819C427.09 252.051 426.845 251.178 426.636 250.2C425.885 246.753 425.43 243.248 425.274 239.723"
          fill="#AEB8BA"
        />
      </g>
      <mask
        id="mask23_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask23_31_1526)">
        <path
          d="M425.588 239.269H426.426C426.41 239.467 426.41 239.665 426.426 239.863C426.531 244.026 427.177 248.159 428.347 252.156C429.041 254.165 430.03 256.06 431.281 257.779C431.27 257.871 431.27 257.965 431.281 258.058C433.009 260.674 434.076 263.67 434.389 266.789C434.389 267.674 434.459 268.617 434.599 269.618C434.671 272.964 434.542 276.311 434.214 279.641H433.376C433.376 279.432 433.376 279.257 433.376 279.047C433.652 275.959 433.757 272.858 433.691 269.758C433.668 268.729 433.587 267.703 433.446 266.684C433.164 263.818 432.167 261.068 430.547 258.687C430.547 258.477 430.303 258.268 430.163 258.093C428.976 256.4 428.047 254.54 427.404 252.575C427.16 251.807 426.915 250.934 426.706 249.956C425.925 246.511 425.446 243.006 425.274 239.479"
          fill="#ABB5B8"
        />
      </g>
      <mask
        id="mask24_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask24_31_1526)">
        <path
          d="M425.588 239.269H426.461C426.461 239.479 426.461 239.653 426.461 239.863C426.631 243.988 427.287 248.08 428.417 252.051C429.106 254.034 430.083 255.905 431.316 257.604C431.316 257.604 431.316 257.814 431.316 257.918C433.194 260.444 434.418 263.396 434.878 266.51C434.878 267.383 434.878 268.291 435.087 269.304C435.153 272.625 435.048 275.947 434.773 279.257H433.9C433.865 279.072 433.865 278.883 433.9 278.698C434.167 275.633 434.26 272.554 434.179 269.478C434.148 268.461 434.055 267.446 433.9 266.44C433.629 263.582 432.631 260.841 431.001 258.477C430.886 258.271 430.757 258.073 430.617 257.883C428.931 255.452 427.744 252.71 427.125 249.816C426.322 246.377 425.854 242.868 425.728 239.339"
          fill="#A8B2B6"
        />
      </g>
      <mask
        id="mask25_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask25_31_1526)">
        <path
          d="M425.588 239.269H426.461C426.461 239.479 426.461 239.653 426.461 239.828C426.606 243.927 427.287 247.989 428.487 251.911C429.157 253.885 430.122 255.746 431.351 257.429V257.709C433.2 260.195 434.412 263.097 434.878 266.16C434.878 266.999 435.053 267.942 435.087 268.954C435.189 272.252 435.084 275.553 434.773 278.838H433.935C433.935 278.663 433.935 278.454 433.935 278.279C434.202 275.237 434.295 272.182 434.214 269.129C434.183 268.111 434.09 267.097 433.935 266.091C433.658 263.255 432.66 260.538 431.036 258.198C430.921 257.992 430.792 257.794 430.652 257.604C429.483 255.943 428.565 254.119 427.928 252.191C427.649 251.423 427.439 250.584 427.16 249.607C426.397 246.161 425.941 242.655 425.798 239.129"
          fill="#A5B0B3"
        />
      </g>
      <mask
        id="mask26_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask26_31_1526)">
        <path
          d="M425.588 239.269H426.461C426.461 239.479 426.461 239.653 426.461 239.828C426.611 243.904 427.292 247.942 428.487 251.842C429.197 253.718 430.174 255.482 431.386 257.08V257.36C433.111 259.896 434.168 262.827 434.459 265.881C434.459 266.719 434.459 267.627 434.668 268.64C434.784 271.914 434.691 275.192 434.389 278.454H433.551C433.551 278.279 433.551 278.07 433.551 277.895C433.809 274.876 433.89 271.844 433.795 268.815C433.795 267.697 433.795 266.719 433.551 265.811C433.21 263.013 432.217 260.333 430.652 257.988C430.512 257.799 430.384 257.6 430.268 257.395C429.101 255.74 428.172 253.93 427.509 252.016C427.265 251.248 427.02 250.41 426.776 249.467C426.058 246.073 425.602 242.628 425.414 239.164"
          fill="#A2ADB1"
        />
      </g>
      <mask
        id="mask27_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask27_31_1526)">
        <path
          d="M425.588 239.025H426.461C426.461 239.199 426.461 239.374 426.461 239.583C426.612 243.625 427.293 247.629 428.487 251.492C429.227 253.355 430.201 255.115 431.386 256.731C431.392 256.824 431.392 256.917 431.386 257.01C433.108 259.525 434.176 262.43 434.494 265.462C434.494 266.3 434.494 267.208 434.738 268.186C434.851 271.436 434.769 274.69 434.494 277.93H433.621C433.621 277.755 433.621 277.581 433.621 277.406C433.87 274.409 433.963 271.402 433.9 268.396C433.869 267.401 433.776 266.41 433.621 265.427C433.29 262.648 432.296 259.989 430.722 257.674L430.338 257.08C429.184 255.43 428.256 253.633 427.579 251.737C427.323 251.015 427.078 250.177 426.845 249.222C426.102 245.843 425.635 242.41 425.448 238.955"
          fill="#9FAAAF"
        />
      </g>
      <mask
        id="mask28_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask28_31_1526)">
        <path
          d="M425.588 238.92H426.391C426.391 238.92 426.391 239.269 426.391 239.444C426.542 243.451 427.224 247.42 428.417 251.248C429.146 253.205 430.145 255.05 431.386 256.731V257.01C433.09 259.506 434.146 262.386 434.459 265.392C434.459 266.23 434.459 267.138 434.738 268.116C434.854 271.343 434.761 274.575 434.459 277.79H433.656C433.656 277.616 433.656 277.441 433.656 277.266C433.922 274.294 433.992 271.307 433.865 268.326C433.833 267.331 433.739 266.34 433.586 265.357C433.255 262.605 432.273 259.971 430.722 257.674L430.338 257.115C429.203 255.472 428.287 253.687 427.614 251.807C427.358 251.062 427.113 250.224 426.88 249.292C426.133 245.961 425.666 242.573 425.483 239.164"
          fill="#9CA8AC"
        />
      </g>
      <mask
        id="mask29_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask29_31_1526)">
        <path
          d="M425.588 238.815H426.391C426.391 238.815 426.391 239.164 426.566 239.339C426.723 243.322 427.404 247.268 428.592 251.073C429.294 252.972 430.245 254.769 431.42 256.417V256.661C433.108 259.143 434.174 261.993 434.529 264.973C434.529 265.811 434.738 266.684 434.773 267.662C434.9 270.865 434.83 274.072 434.564 277.266H433.76C433.76 277.092 433.76 276.917 433.76 276.742C434.009 273.792 434.079 270.83 433.97 267.872C433.97 266.789 433.97 265.811 433.691 264.938C433.354 262.198 432.372 259.577 430.827 257.29C430.687 257.1 430.558 256.902 430.443 256.696C429.3 255.082 428.384 253.32 427.719 251.457C427.439 250.759 427.23 249.921 426.95 249.013C426.175 245.708 425.684 242.343 425.483 238.955"
          fill="#99A5AA"
        />
      </g>
      <mask
        id="mask30_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask30_31_1526)">
        <path
          d="M425.623 238.745H426.426C426.426 238.92 426.426 239.094 426.426 239.269C426.573 243.222 427.267 247.136 428.487 250.899C429.191 252.779 430.13 254.562 431.281 256.207V256.452C432.95 258.913 434.004 261.74 434.354 264.694C434.354 265.497 434.564 266.405 434.633 267.383C434.76 270.562 434.69 273.746 434.424 276.917H433.621C433.621 276.742 433.621 276.568 433.621 276.393C433.86 273.466 433.919 270.527 433.795 267.592C433.795 266.51 433.795 265.567 433.516 264.694C433.182 261.975 432.2 259.376 430.652 257.115L430.268 256.556C429.133 254.951 428.216 253.201 427.544 251.353C427.299 250.619 427.055 249.816 426.811 248.908C426.035 245.618 425.567 242.262 425.414 238.885"
          fill="#96A2A7"
        />
      </g>
      <mask
        id="mask31_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask31_31_1526)">
        <path
          d="M425.623 238.64H426.426C426.426 238.815 426.426 238.955 426.426 239.129C426.574 243.048 427.267 246.927 428.487 250.654C429.184 252.516 430.123 254.277 431.281 255.893V256.137C432.951 258.573 434.005 261.377 434.354 264.31C434.354 265.113 434.564 266.021 434.633 266.964C434.85 270.115 434.85 273.277 434.633 276.428H433.83C433.83 276.254 433.83 276.079 433.83 275.939C434.012 273.02 434.012 270.092 433.83 267.173C433.83 266.126 433.83 265.148 433.551 264.275C433.216 261.577 432.234 259.001 430.687 256.766L430.303 256.207C429.179 254.612 428.275 252.874 427.614 251.038C427.369 250.305 427.125 249.502 426.88 248.594C426.029 245.386 425.525 242.096 425.379 238.78"
          fill="#939FA5"
        />
      </g>
      <mask
        id="mask32_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask32_31_1526)">
        <path
          d="M425.623 238.536H426.426C426.426 238.536 426.426 238.85 426.426 239.025C426.578 242.912 427.284 246.757 428.522 250.445C429.219 252.284 430.158 254.023 431.316 255.613C431.316 255.613 431.316 255.823 431.525 255.858C433.169 258.281 434.222 261.056 434.599 263.96C434.599 264.798 434.808 265.672 434.878 266.58C435.095 269.719 435.095 272.87 434.878 276.009H434.075C434.075 276.009 434.075 275.695 434.075 275.52C434.259 272.624 434.259 269.72 434.075 266.824C434.075 265.776 434.075 264.833 433.795 263.96C433.444 261.283 432.449 258.731 430.897 256.521L430.547 255.963C429.437 254.372 428.533 252.647 427.858 250.829C427.614 250.095 427.369 249.327 427.125 248.419C426.263 245.236 425.748 241.969 425.588 238.675"
          fill="#8F9DA2"
        />
      </g>
      <mask
        id="mask33_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask33_31_1526)">
        <path
          d="M425.623 238.466H426.426C426.426 238.466 426.426 238.78 426.426 238.955C426.588 242.818 427.293 246.639 428.522 250.305C429.222 252.136 430.149 253.873 431.281 255.474V255.718C433.097 258.061 434.33 260.802 434.878 263.716C434.878 264.519 435.087 265.392 435.157 266.335C435.379 269.439 435.379 272.556 435.157 275.66H434.354C434.354 275.66 434.354 275.345 434.354 275.171C434.538 272.298 434.538 269.417 434.354 266.545C434.354 265.497 434.249 264.554 434.04 263.716C433.668 261.071 432.688 258.548 431.176 256.347L430.792 255.788C429.695 254.214 428.792 252.514 428.103 250.724C427.87 250.026 427.625 249.222 427.369 248.314C426.549 245.124 426.046 241.86 425.868 238.571"
          fill="#8C9AA0"
        />
      </g>
      <mask
        id="mask34_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask34_31_1526)">
        <path
          d="M425.623 238.361H426.391C426.391 238.536 426.566 238.675 426.566 238.815C426.714 242.648 427.432 246.438 428.696 250.06C429.399 251.873 430.313 253.596 431.42 255.194V255.439C433.075 257.801 434.119 260.537 434.459 263.401C434.459 264.205 434.668 265.043 434.738 265.986C434.943 269.067 434.943 272.159 434.738 275.241H433.97C433.97 275.241 433.97 274.926 433.97 274.787C434.192 271.939 434.192 269.078 433.97 266.23C433.97 265.183 433.795 264.275 433.656 263.436C433.269 260.818 432.315 258.315 430.862 256.102L430.478 255.544C429.374 253.986 428.47 252.297 427.788 250.514C427.488 249.741 427.243 248.948 427.055 248.14C426.244 244.983 425.741 241.755 425.553 238.501"
          fill="#89979D"
        />
      </g>
      <mask
        id="mask35_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask35_31_1526)">
        <path
          d="M425.623 238.291H426.391C426.391 238.291 426.566 238.571 426.601 238.745C426.756 242.544 427.474 246.298 428.731 249.886C429.432 251.684 430.359 253.386 431.49 254.95C431.49 254.95 431.49 255.124 431.49 255.194C433.222 257.498 434.383 260.179 434.878 263.017C434.878 263.821 435.087 264.659 435.157 265.602C435.38 268.648 435.38 271.706 435.157 274.752H434.389C434.389 274.752 434.389 274.472 434.389 274.298C434.576 271.472 434.576 268.637 434.389 265.811C434.389 264.798 434.389 263.89 434.075 263.017C433.691 260.414 432.724 257.93 431.246 255.753L430.897 255.229C429.79 253.692 428.897 252.012 428.242 250.235C427.998 249.537 427.753 248.768 427.509 247.895C426.646 244.759 426.119 241.539 425.937 238.291"
          fill="#86959B"
        />
      </g>
      <mask
        id="mask36_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask36_31_1526)">
        <path
          d="M425.693 238.186H426.461C426.461 238.186 426.461 238.466 426.671 238.64C426.833 242.415 427.551 246.146 428.801 249.711C429.511 251.488 430.426 253.175 431.525 254.74V254.985C433.128 257.323 434.168 260.001 434.564 262.808C434.564 263.576 434.773 264.449 434.843 265.357C435.05 268.392 435.05 271.438 434.843 274.472H434.075C434.075 274.472 434.075 274.158 434.075 274.018C434.282 271.217 434.282 268.403 434.075 265.602C434.075 264.589 434.075 263.646 433.795 262.843C433.402 260.263 432.435 257.805 430.966 255.648L430.582 255.125C429.536 253.569 428.658 251.907 427.963 250.165C427.66 249.413 427.403 248.644 427.195 247.86C426.331 244.737 425.816 241.528 425.658 238.291"
          fill="#839298"
        />
      </g>
      <mask
        id="mask37_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask37_31_1526)">
        <path
          d="M425.693 238.082H426.461C426.461 238.082 426.671 238.361 426.671 238.501C426.827 242.242 427.545 245.939 428.801 249.467C429.512 251.232 430.426 252.908 431.525 254.461V254.705C433.122 257.021 434.161 259.675 434.564 262.458C434.699 263.291 434.792 264.131 434.843 264.973C435.068 267.984 435.068 271.007 434.843 274.018H434.075C434.075 274.018 434.075 273.739 434.075 273.599C434.264 270.82 434.264 268.031 434.075 265.252C434.075 264.24 434.075 263.332 433.76 262.493C433.359 259.981 432.391 257.593 430.932 255.509C430.932 255.299 430.687 255.159 430.582 254.985C429.485 253.349 428.582 251.591 427.893 249.746C427.614 249.083 427.404 248.314 427.125 247.441C426.323 244.343 425.832 241.172 425.658 237.977"
          fill="#808F96"
        />
      </g>
      <mask
        id="mask38_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask38_31_1526)">
        <path
          d="M425.693 238.012H426.461C426.461 238.012 426.671 238.291 426.671 238.431C426.832 242.138 427.55 245.799 428.801 249.292C429.512 251.035 430.426 252.688 431.525 254.216C431.532 254.298 431.532 254.38 431.525 254.461C433.122 256.751 434.162 259.382 434.564 262.144C434.711 262.976 434.816 263.816 434.878 264.659C435.105 267.646 435.105 270.647 434.878 273.634H434.11C434.11 273.634 434.11 273.355 434.11 273.215C434.301 270.459 434.301 267.694 434.11 264.938C434.11 263.925 434.11 263.052 433.795 262.214C433.389 259.703 432.422 257.316 430.966 255.229L430.617 254.705C429.52 253.163 428.606 251.499 427.893 249.746C427.595 248.992 427.339 248.223 427.125 247.441C426.293 244.382 425.778 241.246 425.588 238.082"
          fill="#7D8C93"
        />
      </g>
      <mask
        id="mask39_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask39_31_1526)">
        <path
          d="M425.693 237.907H426.426C426.426 237.907 426.636 238.151 426.636 238.326C426.797 242.017 427.54 245.658 428.836 249.118C429.547 250.85 430.461 252.491 431.56 254.007C431.567 254.088 431.567 254.17 431.56 254.251C433.13 256.539 434.158 259.155 434.564 261.9C434.726 262.718 434.832 263.546 434.878 264.379C435.105 267.332 435.105 270.297 434.878 273.25H434.11C434.11 273.25 434.11 272.971 434.11 272.831C434.322 270.099 434.322 267.355 434.11 264.624C434.056 263.72 433.939 262.822 433.76 261.935C433.353 259.424 432.386 257.037 430.932 254.95L430.582 254.426C429.509 252.936 428.629 251.317 427.963 249.606C427.684 248.908 427.439 248.175 427.195 247.336C426.365 244.301 425.85 241.188 425.658 238.047"
          fill="#7A8A91"
        />
      </g>
      <mask
        id="mask40_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask40_31_1526)">
        <path
          d="M425.693 237.802H426.426C426.426 237.802 426.636 238.047 426.636 238.186C426.816 241.84 427.558 245.445 428.836 248.873C429.549 250.586 430.451 252.215 431.525 253.727C431.532 253.809 431.532 253.891 431.525 253.972C433.093 256.239 434.131 258.829 434.564 261.55C434.701 262.371 434.794 263.199 434.843 264.03C435.091 266.947 435.091 269.879 434.843 272.796H434.11C434.11 272.796 434.11 272.517 434.11 272.377C434.322 269.669 434.322 266.948 434.11 264.24C434.11 263.262 433.9 262.389 433.76 261.55C433.348 259.047 432.394 256.663 430.966 254.566L430.617 254.042C429.565 252.564 428.686 250.971 427.998 249.292C427.699 248.562 427.443 247.816 427.23 247.057C426.416 244.042 425.901 240.953 425.693 237.837"
          fill="#78878E"
        />
      </g>
      <mask
        id="mask41_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask41_31_1526)">
        <path
          d="M425.693 237.732H426.426C426.426 237.732 426.636 237.977 426.636 238.117C426.832 241.701 427.574 245.234 428.836 248.594C429.55 250.284 430.452 251.889 431.525 253.378C431.532 253.46 431.532 253.541 431.525 253.623C433.093 255.864 434.131 258.431 434.564 261.131C434.564 261.9 434.808 262.703 434.843 263.576C435.075 266.482 435.075 269.401 434.843 272.307H434.11C434.11 272.307 434.11 272.028 434.11 271.923C434.304 269.226 434.304 266.518 434.11 263.821C434.039 262.93 433.922 262.045 433.76 261.166C433.348 258.663 432.394 256.279 430.966 254.182L430.617 253.658C429.543 252.225 428.63 250.68 427.893 249.048C427.595 248.318 427.338 247.572 427.125 246.813C426.28 243.85 425.753 240.806 425.553 237.732"
          fill="#75858C"
        />
      </g>
      <mask
        id="mask42_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask42_31_1526)">
        <path
          d="M425.693 237.628H426.461C426.461 237.628 426.671 237.872 426.706 238.012C426.879 241.602 427.634 245.141 428.941 248.489C429.661 250.166 430.563 251.758 431.63 253.239V253.448C433.18 255.669 434.206 258.213 434.633 260.887C434.782 261.684 434.886 262.488 434.948 263.297C435.195 266.178 435.195 269.076 434.948 271.958H434.214C434.214 271.958 434.214 271.713 434.214 271.574C434.429 268.9 434.429 266.214 434.214 263.541C434.144 262.663 434.027 261.788 433.865 260.922C433.461 258.416 432.507 256.03 431.071 253.937L430.722 253.413C429.682 251.953 428.804 250.384 428.103 248.733C427.809 248.014 427.553 247.279 427.334 246.533C426.465 243.612 425.937 240.6 425.763 237.558"
          fill="#728289"
        />
      </g>
      <mask
        id="mask43_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask43_31_1526)">
        <path
          d="M425.693 237.558H426.461C426.461 237.558 426.706 237.802 426.706 237.907C426.878 241.497 427.633 245.036 428.941 248.384C429.663 250.042 430.552 251.622 431.595 253.099C431.595 253.099 431.595 253.099 431.595 253.308C433.15 255.501 434.178 258.023 434.599 260.677C434.599 261.411 434.878 262.214 434.983 263.087C435.217 265.946 435.217 268.819 434.983 271.678H434.249C434.249 271.678 434.04 271.434 434.04 271.294C434.252 268.644 434.252 265.982 434.04 263.332C433.956 262.453 433.828 261.578 433.656 260.712C433.243 258.284 432.288 255.98 430.862 253.972C430.766 253.795 430.648 253.631 430.512 253.483C429.472 252.042 428.604 250.483 427.928 248.838C427.635 248.13 427.378 247.407 427.16 246.673C426.261 243.768 425.71 240.767 425.518 237.732"
          fill="#6F7F87"
        />
      </g>
      <mask
        id="mask44_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask44_31_1526)">
        <path
          d="M425.693 237.453H426.461C426.461 237.453 426.706 237.663 426.706 237.802C426.877 241.34 427.644 244.823 428.976 248.105C429.686 249.739 430.564 251.296 431.595 252.75V252.959C433.219 255.105 434.341 257.587 434.878 260.223C434.878 260.957 435.122 261.76 435.227 262.598C435.482 265.433 435.482 268.285 435.227 271.12H434.459C434.459 271.12 434.249 270.875 434.284 270.77C434.483 268.143 434.483 265.505 434.284 262.878C434.284 261.935 434.075 261.097 433.935 260.293C433.501 257.882 432.547 255.594 431.141 253.588C431.045 253.411 430.928 253.247 430.792 253.099C429.786 251.673 428.92 250.152 428.207 248.559C427.914 247.839 427.658 247.105 427.439 246.359C426.532 243.48 425.981 240.501 425.798 237.488"
          fill="#6C7D84"
        />
      </g>
      <mask
        id="mask45_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask45_31_1526)">
        <path
          d="M425.693 237.348H426.391C426.391 237.348 426.671 237.558 426.671 237.697C426.836 241.198 427.592 244.646 428.906 247.895C429.636 249.516 430.525 251.06 431.56 252.505V252.715C433.183 254.826 434.317 257.271 434.878 259.874C434.878 260.607 435.122 261.376 435.227 262.249C435.464 265.061 435.464 267.888 435.227 270.7H434.529C434.529 270.7 434.319 270.456 434.319 270.386C434.519 267.782 434.519 265.167 434.319 262.563C434.236 261.696 434.107 260.833 433.935 259.979C433.485 257.594 432.532 255.332 431.141 253.343C431.045 253.167 430.928 253.003 430.792 252.854C429.771 251.438 428.904 249.916 428.207 248.314C427.928 247.651 427.684 246.952 427.439 246.184C426.586 243.317 426.047 240.366 425.833 237.383"
          fill="#697A81"
        />
      </g>
      <mask
        id="mask46_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask46_31_1526)">
        <path
          d="M425.693 237.278H426.391C426.391 237.278 426.671 237.488 426.671 237.593C426.829 241.079 427.61 244.509 428.976 247.721C429.694 249.318 430.572 250.839 431.595 252.261V252.47C433.096 254.628 434.12 257.08 434.599 259.665C434.757 260.426 434.873 261.195 434.948 261.97C435.202 264.769 435.202 267.586 434.948 270.386H434.284C434.284 270.386 434.075 270.142 434.075 270.037C434.276 267.457 434.276 264.864 434.075 262.284C434.075 261.376 433.865 260.538 433.691 259.734C433.221 257.383 432.283 255.15 430.932 253.169C430.932 253.169 430.722 252.889 430.617 252.68C429.604 251.271 428.738 249.761 428.033 248.175C427.753 247.546 427.509 246.882 427.23 246.044C426.339 243.233 425.788 240.325 425.588 237.383"
          fill="#66777F"
        />
      </g>
      <mask
        id="mask47_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask47_31_1526)">
        <path
          d="M425.728 237.174H426.426C426.426 237.174 426.671 237.383 426.671 237.488C426.865 240.935 427.645 244.325 428.976 247.511C429.708 249.102 430.585 250.621 431.595 252.051V252.261C433.076 254.352 434.099 256.732 434.599 259.246C434.754 260.007 434.871 260.777 434.948 261.55C435.205 264.315 435.205 267.098 434.948 269.862H434.249C434.249 269.862 434.04 269.653 434.04 269.548C434.259 266.992 434.259 264.421 434.04 261.865C434.04 260.957 433.795 260.119 433.656 259.35C433.198 257.022 432.271 254.812 430.932 252.854L430.617 252.365C429.615 250.967 428.761 249.469 428.068 247.895C427.788 247.267 427.544 246.568 427.265 245.8C426.316 243.014 425.752 240.112 425.588 237.174"
          fill="#63747C"
        />
      </g>
      <mask
        id="mask48_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask48_31_1526)">
        <path
          d="M425.728 237.069H426.426C426.426 237.069 426.671 237.069 426.706 237.348C426.897 240.762 427.677 244.118 429.011 247.267C429.73 248.842 430.607 250.34 431.63 251.737V251.946C433.126 254.029 434.151 256.413 434.633 258.931C434.794 259.692 434.911 260.462 434.983 261.236C435.282 263.973 435.34 266.731 435.157 269.478H434.459C434.459 269.478 434.214 269.269 434.459 269.164C434.681 266.631 434.681 264.083 434.459 261.55C434.459 260.642 434.214 259.804 434.075 259.071C433.615 256.759 432.675 254.57 431.316 252.645L431.001 252.156C430.012 250.774 429.159 249.301 428.452 247.756C428.173 247.127 427.928 246.428 427.649 245.695C426.702 242.931 426.127 240.054 425.937 237.139"
          fill="#607279"
        />
      </g>
      <mask
        id="mask49_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask49_31_1526)">
        <path
          d="M425.728 236.999H426.426C426.426 236.999 426.706 237.174 426.706 237.278C426.913 240.671 427.704 244.003 429.046 247.127C429.772 248.687 430.65 250.172 431.665 251.562V251.772C433.129 253.872 434.151 256.249 434.668 258.757C434.668 259.455 434.948 260.223 435.053 261.027C435.294 263.745 435.294 266.48 435.053 269.199H434.354C434.354 269.199 434.11 269.024 434.145 268.919C434.348 266.397 434.348 263.863 434.145 261.341C434.145 260.433 433.9 259.665 433.76 258.896C433.294 256.593 432.368 254.407 431.036 252.47C431.036 252.47 430.827 252.191 430.722 251.981C429.74 250.607 428.887 249.146 428.173 247.616C427.893 246.987 427.649 246.324 427.369 245.59C426.359 242.877 425.759 240.029 425.588 237.139"
          fill="#5D6F76"
        />
      </g>
      <mask
        id="mask50_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask50_31_1526)">
        <path
          d="M425.728 236.894H426.426C426.426 236.894 426.706 237.069 426.706 237.174C426.915 240.533 427.707 243.83 429.046 246.917C429.774 248.458 430.639 249.931 431.63 251.318V251.527C433.106 253.617 434.118 255.999 434.599 258.512C434.599 259.211 434.878 259.944 434.983 260.782C435.296 263.471 435.366 266.183 435.192 268.884H434.494C434.494 268.884 434.249 268.675 434.249 268.605C434.455 266.106 434.455 263.595 434.249 261.096C434.158 260.274 434.018 259.458 433.83 258.652C433.348 256.38 432.41 254.229 431.071 252.331L430.757 251.842C429.779 250.484 428.937 249.033 428.242 247.511C427.927 246.856 427.658 246.179 427.439 245.485C426.555 242.768 426.004 239.954 425.798 237.104"
          fill="#5A6C73"
        />
      </g>
      <mask
        id="mask51_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask51_31_1526)">
        <path
          d="M425.728 236.824H426.391C426.391 236.824 426.671 236.824 426.671 237.069C426.873 240.399 427.678 243.665 429.046 246.708C429.782 248.234 430.647 249.694 431.63 251.073V251.283C433.086 253.32 434.098 255.64 434.599 258.093C434.599 258.791 434.878 259.525 434.983 260.328C435.296 262.994 435.366 265.682 435.192 268.361H434.529C434.529 268.361 434.284 268.361 434.284 268.081C434.432 265.601 434.374 263.113 434.11 260.642C434.016 259.832 433.876 259.027 433.691 258.233C433.209 255.982 432.27 253.854 430.932 251.981C430.844 251.819 430.738 251.667 430.617 251.527C429.635 250.185 428.793 248.745 428.103 247.232C427.823 246.603 427.544 245.905 427.299 245.241C426.393 242.55 425.819 239.759 425.588 236.929"
          fill="#576971"
        />
      </g>
      <mask
        id="mask52_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask52_31_1526)">
        <path
          d="M425.728 236.72H426.391C426.391 236.72 426.671 236.72 426.671 236.964C426.875 240.26 427.68 243.491 429.046 246.498C429.782 248.002 430.647 249.439 431.63 250.794V251.003C433.058 253.031 434.067 255.322 434.599 257.744C434.599 258.442 434.878 259.176 434.983 259.944C435.307 262.585 435.401 265.249 435.262 267.907H434.878C434.878 267.907 434.633 267.732 434.633 267.627C434.789 265.17 434.719 262.703 434.424 260.258C434.33 259.448 434.19 258.643 434.005 257.849C433.52 255.626 432.594 253.524 431.281 251.667L430.966 251.213C430.017 249.874 429.176 248.461 428.452 246.987C428.145 246.34 427.877 245.675 427.649 244.997C426.72 242.36 426.145 239.612 425.937 236.824"
          fill="#55666E"
        />
      </g>
      <mask
        id="mask53_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask53_31_1526)">
        <path
          d="M425.728 236.615H426.391C426.391 236.615 426.671 236.615 426.671 236.859C426.874 240.137 427.692 243.348 429.081 246.324C429.829 247.817 430.706 249.242 431.7 250.584C431.7 250.584 431.7 250.584 431.7 250.794C433.139 252.793 434.16 255.062 434.703 257.464C434.703 258.163 434.983 258.861 435.087 259.665C435.398 262.283 435.48 264.924 435.332 267.557H434.878C434.878 267.557 434.633 267.557 434.633 267.278C434.736 264.843 434.666 262.404 434.424 259.979C434.424 259.106 434.145 258.337 434.005 257.604C433.505 255.408 432.58 253.332 431.281 251.492L430.966 251.038C430.009 249.716 429.168 248.314 428.452 246.848C428.151 246.21 427.883 245.557 427.649 244.892C426.666 242.267 426.066 239.515 425.868 236.72"
          fill="#52636B"
        />
      </g>
      <mask
        id="mask54_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask54_31_1526)">
        <path
          d="M425.798 236.545H426.461C426.461 236.545 426.741 236.545 426.741 236.754C426.955 240.001 427.785 243.177 429.185 246.114C429.932 247.575 430.772 248.986 431.7 250.34V250.514C433.121 252.494 434.131 254.738 434.668 257.115C434.808 257.814 434.948 258.547 435.087 259.315C435.427 261.897 435.521 264.504 435.367 267.103H434.878C434.878 267.103 434.599 267.103 434.633 266.859C434.78 264.447 434.698 262.026 434.389 259.63C434.296 258.854 434.156 258.084 433.97 257.325C433.533 255.111 432.654 253.009 431.386 251.143L431.071 250.689C430.121 249.375 429.28 247.985 428.557 246.533C428.25 245.898 427.981 245.245 427.753 244.577C426.739 242.009 426.126 239.3 425.937 236.545"
          fill="#4F6068"
        />
      </g>
      <mask
        id="mask55_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask55_31_1526)">
        <path
          d="M425.798 236.44H426.461C426.461 236.44 426.741 236.44 426.741 236.65C426.957 239.862 427.787 243.004 429.185 245.905C429.907 247.357 430.748 248.747 431.7 250.061V250.27C433.159 252.203 434.238 254.395 434.878 256.731C434.878 257.395 435.192 258.128 435.297 258.896C435.652 261.464 435.757 264.061 435.611 266.649H434.878C434.878 266.649 434.599 266.649 434.599 266.405C434.718 264.074 434.636 261.737 434.354 259.42C434.354 258.582 434.075 257.814 433.935 257.08C433.429 254.919 432.503 252.878 431.211 251.073L430.897 250.619C429.946 249.324 429.116 247.945 428.417 246.498C428.116 245.872 427.848 245.231 427.614 244.577C426.563 242.055 425.938 239.376 425.763 236.65"
          fill="#4C5E65"
        />
      </g>
      <mask
        id="mask56_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask56_31_1526)">
        <path
          d="M425.798 236.37H426.461C426.461 236.37 426.741 236.37 426.741 236.58C426.966 239.769 427.796 242.886 429.185 245.765C429.918 247.163 430.771 248.496 431.735 249.746V249.956C433.128 251.9 434.136 254.093 434.703 256.417C434.886 257.118 435.026 257.829 435.122 258.547C435.477 261.08 435.582 263.642 435.437 266.195H434.878C434.878 266.195 434.599 266.195 434.599 265.951C434.712 263.619 434.618 261.282 434.319 258.966C434.212 258.19 434.06 257.42 433.865 256.661C433.352 254.524 432.426 252.507 431.141 250.724L430.827 250.305C429.889 249.014 429.059 247.647 428.347 246.219L427.509 244.333C426.539 241.789 425.939 239.119 425.728 236.405"
          fill="#495B63"
        />
      </g>
      <mask
        id="mask57_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask57_31_1526)">
        <path
          d="M425.798 236.266H426.391C426.391 236.266 426.706 236.266 426.706 236.44C426.933 239.595 427.763 242.678 429.15 245.52C429.885 246.943 430.726 248.309 431.665 249.606C431.65 249.664 431.65 249.724 431.665 249.781C433.065 251.709 434.073 253.892 434.633 256.207C434.813 256.897 434.953 257.597 435.053 258.303C435.421 260.822 435.538 263.373 435.402 265.916H434.878C434.878 265.916 434.599 265.916 434.599 265.706C434.716 263.374 434.623 261.037 434.319 258.722C434.215 257.956 434.063 257.198 433.865 256.452C433.337 254.341 432.412 252.35 431.141 250.584L430.827 250.13C429.896 248.859 429.067 247.516 428.347 246.114C428.068 245.52 427.788 244.927 427.509 244.228C426.55 241.717 425.951 239.084 425.728 236.405"
          fill="#465860"
        />
      </g>
      <mask
        id="mask58_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask58_31_1526)">
        <path
          d="M425.798 236.161H426.391H426.706C426.927 239.288 427.77 242.339 429.185 245.136C429.928 246.544 430.768 247.897 431.7 249.187V249.362C433.081 251.27 434.078 253.429 434.633 255.718C434.817 256.407 434.957 257.107 435.053 257.814C435.438 260.309 435.555 262.837 435.402 265.357H434.878C434.878 265.357 434.599 265.357 434.599 265.148C434.728 262.815 434.622 260.475 434.284 258.163C434.177 257.398 434.025 256.64 433.83 255.893C433.302 253.804 432.378 251.835 431.106 250.096L430.792 249.676C429.874 248.409 429.045 247.078 428.312 245.695C428.033 245.136 427.753 244.508 427.474 243.844C426.549 241.337 425.962 238.718 425.728 236.056"
          fill="#43555D"
        />
      </g>
      <mask
        id="mask59_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask59_31_1526)">
        <path
          d="M425.798 236.091H426.426H426.741C426.966 239.195 427.809 242.223 429.22 244.997C429.955 246.386 430.796 247.717 431.735 248.978C433.102 250.868 434.098 253.002 434.668 255.264C434.852 255.941 434.992 256.63 435.087 257.325C435.47 259.796 435.599 262.301 435.472 264.798H434.878C434.878 264.798 434.564 264.798 434.599 264.589C434.716 262.256 434.611 259.917 434.284 257.604C434.284 256.801 434.005 256.067 433.83 255.369C433.277 253.306 432.367 251.356 431.141 249.607L430.862 249.187C429.943 247.939 429.125 246.62 428.417 245.241C428.138 244.682 427.858 244.054 427.579 243.39C426.515 240.968 425.877 238.381 425.693 235.742"
          fill="#41535A"
        />
      </g>
      <mask
        id="mask60_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask60_31_1526)">
        <path
          d="M425.798 235.986H426.426H426.741C426.986 239.053 427.828 242.043 429.22 244.787C429.964 246.152 430.793 247.47 431.7 248.733V248.908C433.061 250.777 434.056 252.886 434.633 255.124C434.633 255.753 434.948 256.452 435.087 257.185C435.486 259.62 435.615 262.091 435.472 264.554H434.878C434.878 264.554 434.599 264.554 434.599 264.344C434.734 262.009 434.605 259.666 434.214 257.36C434.114 256.628 433.963 255.904 433.76 255.194C433.207 253.153 432.297 251.226 431.071 249.502C430.966 249.37 430.873 249.23 430.792 249.083C429.901 247.84 429.084 246.546 428.347 245.206L427.509 243.39C426.525 240.97 425.913 238.415 425.693 235.812"
          fill="#3E5058"
        />
      </g>
      <mask
        id="mask61_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask61_31_1526)">
        <path
          d="M425.798 235.777H426.426C426.426 235.777 426.741 235.777 426.776 235.777C427.021 238.815 427.876 241.773 429.29 244.473C430.042 245.83 430.882 247.137 431.805 248.384C431.805 248.384 431.805 248.384 431.805 248.559C433.166 250.402 434.162 252.488 434.738 254.705C434.913 255.334 435.053 255.998 435.192 256.731C435.604 259.141 435.745 261.589 435.611 264.03H434.983C434.983 264.03 434.703 264.03 434.703 263.855C434.829 261.59 434.7 259.317 434.319 257.08C434.218 256.334 434.054 255.599 433.83 254.88C433.35 252.921 432.522 251.063 431.386 249.397L431.106 248.978C430.199 247.758 429.382 246.474 428.661 245.136C428.382 244.577 428.103 243.984 427.823 243.355C426.714 240.965 426.029 238.401 425.798 235.777Z"
          fill="#3B4D55"
        />
      </g>
      <mask
        id="mask62_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask62_31_1526)">
        <path
          d="M425.798 235.777H426.391H426.741C426.976 238.788 427.845 241.716 429.29 244.368C430.022 245.707 430.851 246.991 431.77 248.21C433.092 250.045 434.074 252.103 434.668 254.286C434.668 254.915 434.983 255.578 435.157 256.312C435.538 258.702 435.666 261.125 435.542 263.541H434.948L434.878 263.716C434.967 261.473 434.839 259.228 434.494 257.01C434.375 256.279 434.212 255.556 434.005 254.845C433.467 252.841 432.554 250.957 431.316 249.292C431.211 249.161 431.117 249.021 431.036 248.873C430.138 247.66 429.321 246.388 428.592 245.066L427.753 243.285C426.686 240.91 426.025 238.371 425.798 235.777Z"
          fill="#384A52"
        />
      </g>
      <mask
        id="mask63_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask63_31_1526)">
        <path
          d="M425.798 235.777H426.391H426.741C426.991 238.763 427.859 241.665 429.29 244.298C430.058 245.695 430.862 246.813 431.735 248.105C433.062 249.917 434.055 251.951 434.668 254.112C434.668 254.74 434.983 255.404 435.122 256.102C435.533 258.406 435.686 260.749 435.576 263.087H434.983H434.668C434.775 260.868 434.646 258.644 434.284 256.452C434.166 255.732 434.003 255.02 433.795 254.321C433.25 252.341 432.338 250.482 431.106 248.838L430.827 248.419C429.948 247.224 429.143 245.976 428.417 244.682C428.138 244.089 427.858 243.565 427.579 242.936C426.523 240.619 425.873 238.139 425.658 235.602"
          fill="#35474F"
        />
      </g>
      <mask
        id="mask64_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask64_31_1526)">
        <path
          d="M425.798 235.777H426.391H426.741C426.986 238.731 427.855 241.6 429.29 244.193C430.058 245.555 430.862 246.708 431.735 247.965C433.062 249.752 434.055 251.763 434.668 253.902C434.86 254.544 435.012 255.197 435.122 255.858C435.535 258.162 435.699 260.504 435.611 262.843H435.018C435.018 262.843 434.668 262.843 434.703 262.843C434.803 260.645 434.662 258.444 434.284 256.277C434.166 255.557 434.003 254.846 433.795 254.147C433.328 252.2 432.512 250.354 431.386 248.698L431.106 248.279C430.231 247.094 429.427 245.858 428.696 244.577C428.417 244.054 428.138 243.46 427.858 242.866C426.793 240.63 426.097 238.236 425.798 235.777Z"
          fill="#32444C"
        />
      </g>
      <mask
        id="mask65_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask65_31_1526)">
        <path
          d="M425.833 235.532H426.426H426.776C427.046 238.453 427.926 241.285 429.36 243.844C430.163 245.171 430.932 246.289 431.805 247.336C431.805 247.336 431.805 247.336 431.805 247.546C433.126 249.305 434.109 251.295 434.703 253.413C434.912 254.041 435.075 254.683 435.192 255.334C435.625 257.635 435.789 259.979 435.681 262.319H435.087H434.738C434.818 260.133 434.677 257.945 434.319 255.788C434.205 255.09 434.042 254.402 433.83 253.727C433.273 251.797 432.387 249.978 431.211 248.349L430.932 247.895C430.04 246.787 429.223 245.62 428.487 244.403C428.258 243.867 428.06 243.319 427.893 242.761C426.848 240.564 426.198 238.199 425.972 235.777"
          fill="#2F4149"
        />
      </g>
      <mask
        id="mask66_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask66_31_1526)">
        <path
          d="M425.833 235.427H426.426H426.776C427.055 238.324 427.935 241.131 429.36 243.669C430.163 244.997 430.932 246.079 431.805 247.336C433.172 249.105 434.213 251.104 434.878 253.239C435.086 253.867 435.25 254.508 435.367 255.159C435.804 257.461 435.98 259.804 435.891 262.144H435.297H434.948C435.037 259.992 434.885 257.837 434.494 255.718C434.494 254.985 434.179 254.286 434.005 253.658C433.42 251.753 432.523 249.96 431.351 248.349C431.266 248.215 431.173 248.087 431.071 247.965C430.209 246.851 429.416 245.685 428.696 244.473C428.417 243.949 428.103 243.39 427.823 242.796C426.79 240.595 426.14 238.232 425.902 235.812"
          fill="#2C3E45"
        />
      </g>
      <mask
        id="mask67_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask67_31_1526)">
        <path
          d="M425.833 235.357H426.426H426.776C427.049 238.223 427.93 240.997 429.36 243.495C430.128 244.822 430.932 245.905 431.805 246.987C433.086 248.72 434.066 250.656 434.703 252.715C434.703 253.308 435.053 253.937 435.192 254.601C435.621 256.903 435.785 259.246 435.681 261.585H435.088H434.738C434.827 259.456 434.674 257.324 434.284 255.229C434.151 254.533 433.976 253.844 433.76 253.169C433.154 251.295 432.258 249.528 431.106 247.93C431.022 247.796 430.929 247.667 430.827 247.546C429.97 246.435 429.188 245.269 428.487 244.054C428.207 243.53 427.893 242.971 427.614 242.377C426.643 240.158 426.018 237.802 425.763 235.392"
          fill="#293B42"
        />
      </g>
      <mask
        id="mask68_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask68_31_1526)">
        <path
          d="M425.833 235.253H426.391H426.776C427.046 238.091 427.941 240.833 429.395 243.285C430.163 244.578 430.932 245.66 431.805 246.778C433.079 248.489 434.059 250.401 434.703 252.435C434.907 253.053 435.071 253.683 435.192 254.321C435.671 256.617 435.859 258.964 435.751 261.306H435.192H434.808C434.887 259.199 434.723 257.089 434.319 255.02C434.201 254.334 434.038 253.658 433.83 252.994C433.217 251.145 432.322 249.401 431.176 247.825C431.092 247.691 430.998 247.563 430.897 247.441C430.093 246.289 429.255 245.206 428.522 243.949C428.207 243.425 427.928 242.866 427.649 242.307C426.648 240.096 426.012 237.737 425.763 235.323"
          fill="#26383F"
        />
      </g>
      <mask
        id="mask69_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask69_31_1526)">
        <path
          d="M425.833 235.148H426.391H426.776C427.051 237.963 427.945 240.682 429.395 243.111C430.163 244.368 430.932 245.451 431.805 246.603C433.066 248.297 434.045 250.184 434.703 252.191C434.907 252.796 435.071 253.415 435.192 254.042C435.657 256.257 435.845 258.521 435.751 260.782H435.192H434.808C434.884 258.687 434.72 256.589 434.319 254.531C434.205 253.856 434.042 253.191 433.83 252.54C433.209 250.705 432.315 248.974 431.176 247.406L430.897 247.022C430.041 245.903 429.248 244.737 428.522 243.53C428.242 243.006 427.928 242.482 427.649 241.923C426.635 239.716 425.998 237.356 425.763 234.938"
          fill="#23353C"
        />
      </g>
      <mask
        id="mask70_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask70_31_1526)">
        <path
          d="M425.833 235.078H426.391H426.776C427.055 237.865 427.962 240.551 429.43 242.936C430.163 244.193 430.966 245.241 431.805 246.428V246.603C433.059 248.276 434.037 250.139 434.703 252.121C434.703 252.715 435.053 253.308 435.192 253.972C435.669 256.162 435.869 258.403 435.786 260.643H435.227H434.843C434.911 258.569 434.735 256.494 434.319 254.461C434.186 253.787 434.011 253.122 433.795 252.47C433.275 250.629 432.461 248.884 431.386 247.302L431.106 246.917C430.303 245.8 429.5 244.717 428.766 243.425C428.447 242.905 428.156 242.369 427.893 241.819C426.886 239.681 426.237 237.392 425.972 235.043"
          fill="#203239"
        />
      </g>
      <mask
        id="mask71_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask71_31_1526)">
        <path
          d="M425.868 234.973H426.461H426.845C427.119 237.723 428.014 240.375 429.465 242.726C430.233 243.949 431.036 244.997 431.84 246.219C433.081 247.875 434.059 249.712 434.738 251.667C434.913 252.226 435.088 252.854 435.262 253.483C435.736 255.65 435.947 257.866 435.891 260.084H435.332H434.948C434.998 258.033 434.822 255.984 434.424 253.972C434.424 253.273 434.075 252.61 433.9 252.016C433.284 250.229 432.401 248.545 431.281 247.022L431.001 246.638C430.198 245.52 429.395 244.473 428.662 243.146C428.343 242.638 428.051 242.113 427.788 241.574C426.667 239.499 425.978 237.218 425.763 234.869"
          fill="#1D2F36"
        />
      </g>
      <mask
        id="mask72_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask72_31_1526)">
        <path
          d="M425.868 234.904H426.461H426.845C427.104 237.634 428.027 240.26 429.535 242.552C430.268 243.739 431.071 244.787 431.909 246.044C433.142 247.686 434.13 249.497 434.843 251.423C434.843 251.981 435.192 252.575 435.332 253.239C435.804 255.382 436.015 257.575 435.961 259.769H435.402H435.018C435.075 257.74 434.888 255.712 434.459 253.728C434.319 253.075 434.132 252.433 433.9 251.807C433.283 250.041 432.4 248.381 431.281 246.882C431.199 246.746 431.106 246.618 431.001 246.498C430.162 245.375 429.381 244.21 428.661 243.006C428.347 242.517 428.068 241.993 427.788 241.469C426.716 239.414 426.04 237.174 425.798 234.869"
          fill="#192B32"
        />
      </g>
      <mask
        id="mask73_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask73_31_1526)">
        <path
          d="M425.868 234.799H426.461H426.845C427.14 237.5 428.061 240.095 429.535 242.377C430.268 243.53 431.071 244.612 431.875 245.87C433.097 247.481 434.063 249.272 434.738 251.178C434.954 251.759 435.129 252.354 435.262 252.959C435.767 255.074 435.99 257.247 435.926 259.42H435.367H434.983C435.074 257.349 434.922 255.274 434.529 253.239C434.377 252.585 434.179 251.943 433.935 251.318C433.32 249.573 432.436 247.935 431.316 246.463L431.036 246.254C430.233 245.171 429.465 244.123 428.696 242.936C428.417 242.447 428.103 241.958 427.823 241.399C426.778 239.373 426.115 237.171 425.868 234.904"
          fill="#16252B"
        />
      </g>
      <mask
        id="mask74_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask74_31_1526)">
        <path
          d="M425.868 234.694H426.391C426.531 234.676 426.671 234.676 426.811 234.694C427.121 237.359 428.041 239.916 429.5 242.168C430.233 243.32 431.036 244.368 431.84 245.485C433.062 247.071 434.028 248.839 434.703 250.724C434.915 251.294 435.09 251.878 435.227 252.47C435.729 254.562 435.952 256.711 435.891 258.861H434.878C434.925 256.877 434.725 254.894 434.284 252.959C434.166 252.312 433.978 251.68 433.725 251.073C433.189 249.36 432.4 247.735 431.386 246.254L431.141 245.905C430.373 244.822 429.57 243.809 428.836 242.622C428.522 242.133 428.242 241.644 427.963 241.12C426.917 239.106 426.254 236.915 426.007 234.659"
          fill="#121F25"
        />
      </g>
      <mask
        id="mask75_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask75_31_1526)">
        <path
          d="M425.868 234.624H426.391H426.811C427.117 237.263 428.051 239.79 429.535 241.993C430.268 243.111 431.071 244.158 431.875 245.276C433.084 246.858 434.049 248.612 434.738 250.48C434.954 251.048 435.129 251.632 435.262 252.226C435.779 254.292 436.014 256.418 435.961 258.547H435.018C435.047 256.586 434.848 254.629 434.424 252.715C434.249 252.051 434.075 251.423 433.865 250.864C433.245 249.225 432.411 247.675 431.386 246.254L431.141 245.905C430.373 244.857 429.57 243.844 428.836 242.692C428.522 242.203 428.242 241.714 427.963 241.19C426.878 239.196 426.179 237.016 425.903 234.764"
          fill="#0E191D"
        />
      </g>
      <mask
        id="mask76_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask76_31_1526)">
        <path
          d="M425.868 234.519H426.391H426.811C427.134 237.132 428.067 239.633 429.535 241.819C430.268 242.936 431.071 243.949 431.875 245.032C433.071 246.596 434.035 248.325 434.738 250.165C434.948 250.689 435.122 251.283 435.297 251.877C435.83 253.916 436.065 256.021 435.996 258.128H435.088C435.129 256.188 434.918 254.251 434.459 252.366C434.459 251.667 434.11 251.108 433.9 250.515C433.242 248.844 432.361 247.269 431.281 245.835L431.001 245.486C430.233 244.438 429.465 243.425 428.696 242.307C428.377 241.836 428.086 241.346 427.823 240.841C426.738 238.885 426.038 236.739 425.763 234.519"
          fill="#091216"
        />
      </g>
      <mask
        id="mask77_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask77_31_1526)">
        <path
          d="M425.902 234.415H426.426H426.845C427.162 237.002 428.11 239.473 429.604 241.609C430.338 242.657 431.106 243.669 431.909 244.787C433.127 246.293 434.126 247.962 434.878 249.746C435.096 250.294 435.282 250.854 435.437 251.423C435.949 253.442 436.195 255.52 436.17 257.604H435.262C435.265 255.689 435.054 253.78 434.633 251.911C434.478 251.308 434.292 250.714 434.075 250.13C433.42 248.486 432.551 246.936 431.49 245.52L431.211 245.171C430.443 244.123 429.674 243.146 428.906 242.028C428.592 241.574 428.312 241.085 427.998 240.561C426.905 238.619 426.193 236.485 425.902 234.275"
          fill="#04090C"
        />
      </g>
      <mask
        id="mask78_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask78_31_1526)">
        <path
          d="M435.227 257.325C435.288 254.788 434.861 252.262 433.97 249.886C433.242 248.141 432.291 246.497 431.141 244.997C429.995 243.558 428.934 242.054 427.963 240.491C426.867 238.603 426.166 236.512 425.902 234.345H426.845C427.51 238.173 429.269 241.727 431.909 244.578C433.118 246.165 434.116 247.902 434.878 249.746C435.8 252.224 436.227 254.858 436.135 257.499L435.227 257.325Z"
          fill="black"
        />
      </g>
      <mask
        id="mask79_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask79_31_1526)">
        <path
          d="M64.6843 252.924C64.6993 248.801 65.3351 244.704 66.5702 240.771C67.314 238.645 68.5049 236.704 70.0626 235.078C71.9131 233.435 73.4187 231.44 74.4918 229.21C75.565 226.979 76.1843 224.558 76.3139 222.086H77.2918C76.9861 225.245 76.0478 228.309 74.5328 231.097C73.5307 232.799 72.3225 234.37 70.9357 235.777C69.4634 237.282 68.3424 239.095 67.6528 241.085C66.4548 244.941 65.8426 248.956 65.8368 252.994L64.6843 252.924Z"
          fill="#EDEEEC"
        />
      </g>
      <mask
        id="mask80_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask80_31_1526)">
        <path
          d="M77.3966 222.401C77.0674 225.565 76.1306 228.637 74.6376 231.446C74.3306 231.994 73.9678 232.509 73.5549 232.983C72.7319 234.015 71.8455 234.995 70.9007 235.916C70.5166 236.335 70.1673 236.755 69.8181 237.209C68.874 238.446 68.1314 239.825 67.6179 241.295C67.3734 241.958 67.1988 242.727 66.9543 243.565C66.5575 245.302 66.2775 247.064 66.1161 248.838C66.1161 250.13 65.8717 251.597 65.8368 253.169H64.8589C64.8589 251.423 64.9637 249.851 65.1732 248.454C65.3377 246.652 65.6413 244.866 66.0812 243.111C66.2665 242.39 66.4879 241.679 66.7448 240.98C67.3055 239.347 68.1444 237.823 69.2244 236.475C69.5254 236.06 69.8645 235.674 70.2372 235.323C71.1103 234.38 71.9834 233.507 72.8215 232.494C74.9074 229.47 76.1162 225.929 76.3139 222.261H76.6632L77.3966 222.401Z"
          fill="#EAECEA"
        />
      </g>
      <mask
        id="mask81_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask81_31_1526)">
        <path
          d="M77.3617 222.505C77.0685 225.673 76.1422 228.749 74.6376 231.551C74.3293 232.112 73.9791 232.649 73.5899 233.157C72.7668 234.189 71.8804 235.169 70.9357 236.091C70.5515 236.545 70.2023 236.929 69.853 237.418C68.9018 238.651 68.1586 240.031 67.6528 241.504C67.3878 242.259 67.1662 243.029 66.9893 243.809C66.5925 245.546 66.3125 247.308 66.1511 249.083C66.1511 250.41 66.1511 251.842 65.8717 253.448H64.8938C64.8938 251.702 65.1034 250.13 65.2081 248.698C65.376 246.885 65.6795 245.088 66.1162 243.32C66.3257 242.552 66.5352 241.818 66.7448 241.19C67.2975 239.553 68.1372 238.027 69.2244 236.685C69.5357 236.267 69.8741 235.87 70.2372 235.497C71.1103 234.589 71.9834 233.716 72.8215 232.703C74.9016 229.586 76.1076 225.968 76.3139 222.226H76.6283L77.3617 222.505Z"
          fill="#E8EAE8"
        />
      </g>
      <mask
        id="mask82_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask82_31_1526)">
        <path
          d="M77.3617 222.61C77.0548 225.786 76.1294 228.871 74.6376 231.691C74.3382 232.257 73.9875 232.795 73.5899 233.297C72.7168 234.449 71.8088 235.323 70.9706 236.266C70.5826 236.673 70.221 237.104 69.8879 237.558C68.9504 238.805 68.1977 240.181 67.6528 241.644C67.4083 242.307 67.2337 243.076 66.9893 243.949C66.5928 245.698 66.3128 247.471 66.1511 249.257C66.1511 250.549 66.1511 252.016 65.8717 253.623H65.5923H64.8938C64.8938 251.877 65.1034 250.34 65.2081 248.873C65.3729 247.06 65.6765 245.262 66.1162 243.495C66.3014 242.774 66.5229 242.063 66.7797 241.364C67.3375 239.705 68.2023 238.165 69.3292 236.824C69.6429 236.453 69.9813 236.103 70.3419 235.777C71.2347 234.884 72.0743 233.939 72.8565 232.948C74.9365 229.83 76.1426 226.212 76.3489 222.471H76.6981L77.3617 222.61Z"
          fill="#E5E8E6"
        />
      </g>
      <mask
        id="mask83_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask83_31_1526)">
        <path
          d="M77.3267 222.715C77.0045 225.899 76.08 228.992 74.6027 231.83C74.2901 232.389 73.94 232.926 73.5549 233.437C72.7356 234.484 71.8613 235.486 70.9357 236.44L69.8181 237.732C68.8674 238.971 68.1135 240.35 67.583 241.819C67.3064 242.57 67.0847 243.34 66.9194 244.123C66.5229 245.872 66.2429 247.646 66.0812 249.432C66.0812 250.759 65.8717 252.226 65.8018 253.797H64.8589C64.8589 252.086 65.0335 250.48 65.1732 249.048C65.3386 247.211 65.6421 245.39 66.0812 243.6C66.2908 242.796 66.5003 242.098 66.7099 241.469C67.282 239.823 68.1326 238.287 69.2244 236.929L70.2372 235.777C71.147 234.887 71.9876 233.93 72.7517 232.913C74.8226 229.791 76.0277 226.176 76.2441 222.436H76.5235L77.3267 222.715Z"
          fill="#E2E6E4"
        />
      </g>
      <mask
        id="mask84_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask84_31_1526)">
        <path
          d="M77.3267 222.82C76.9797 226.005 76.0692 229.103 74.6376 231.97C74.3502 232.543 73.9987 233.082 73.5899 233.576C72.7706 234.623 71.8962 235.626 70.9706 236.58L69.853 237.872C68.8699 239.103 68.1132 240.498 67.6179 241.993C67.3734 242.692 67.1988 243.46 66.9543 244.298C66.5507 246.093 66.2707 247.913 66.1162 249.746C66.1162 251.073 65.9066 252.54 65.8368 254.147H64.8938C64.8938 252.435 65.0684 250.829 65.2081 249.362C65.3746 247.494 65.6663 245.638 66.0812 243.809C66.2908 243.006 66.5003 242.307 66.7099 241.644C67.2444 239.971 68.0983 238.417 69.2244 237.069C69.5736 236.65 69.8879 236.266 70.2372 235.916C71.1302 235.011 71.9698 234.055 72.7517 233.053C74.7863 229.913 75.9881 226.308 76.2441 222.575H76.5584L77.3267 222.82Z"
          fill="#DFE3E2"
        />
      </g>
      <mask
        id="mask85_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask85_31_1526)">
        <path
          d="M77.2918 222.925C76.971 226.182 76.0597 229.353 74.6027 232.284C74.3155 232.869 73.9641 233.419 73.5549 233.926C72.7534 234.998 71.8782 236.013 70.9357 236.964L69.8181 238.256C68.835 239.487 68.0782 240.882 67.583 242.377C67.3111 243.13 67.0894 243.9 66.9194 244.682C66.535 246.351 66.255 248.042 66.0812 249.746C66.0812 251.073 65.8717 252.575 65.8018 254.147H64.8589C64.8589 252.435 64.8589 250.654 65.1732 249.362C65.3459 247.529 65.6376 245.709 66.0463 243.914C66.2558 243.111 66.4654 242.412 66.6749 241.749C67.2534 240.095 68.1032 238.548 69.1895 237.174L70.2022 235.986C71.104 235.077 71.944 234.109 72.7168 233.087C74.7256 229.936 75.9253 226.337 76.2092 222.61H76.5235L77.2918 222.925Z"
          fill="#DCE1E1"
        />
      </g>
      <mask
        id="mask86_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask86_31_1526)">
        <path
          d="M77.2918 223.029C76.9357 226.242 76.0383 229.371 74.6376 232.284C74.3365 232.853 73.9981 233.401 73.6248 233.926C72.8233 234.998 71.948 236.013 71.0055 236.964L69.8879 238.256C68.9049 239.487 68.1481 240.882 67.6528 242.377C67.3926 243.146 67.1711 243.927 66.9892 244.717C66.587 246.487 66.3185 248.285 66.186 250.095C66.186 251.458 65.9765 252.924 65.9066 254.496H64.9287C64.9287 252.785 64.9287 251.004 65.2081 249.711C65.3636 247.876 65.6555 246.055 66.0812 244.263C66.2908 243.46 66.5003 242.761 66.7099 242.098C67.2883 240.444 68.1381 238.898 69.2244 237.523L70.2372 236.335C71.1389 235.426 71.9789 234.458 72.7517 233.437C74.7464 230.278 75.9448 226.683 76.2441 222.96H76.5584L77.2918 223.029Z"
          fill="#DADFDF"
        />
      </g>
      <mask
        id="mask87_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask87_31_1526)">
        <path
          d="M77.2569 223.169C76.8874 226.334 75.9902 229.415 74.6027 232.284C74.3096 232.858 73.9709 233.407 73.5899 233.926C72.7883 234.998 71.9131 236.013 70.9706 236.964L69.853 238.256C68.8688 239.492 68.1012 240.885 67.583 242.377C67.3067 243.141 67.0849 243.923 66.9194 244.717C66.5171 246.487 66.2486 248.285 66.1162 250.095C66.1162 251.458 65.9066 252.924 65.8717 254.531H65.5923H64.8938C64.8938 252.82 64.8938 251.213 65.1732 249.711C65.3287 247.876 65.6205 246.055 66.0463 244.263C66.2558 243.46 66.4654 242.761 66.6749 242.098C67.2502 240.435 68.1131 238.887 69.2244 237.523L70.2372 236.335C71.1389 235.426 71.979 234.458 72.7517 233.437C74.7413 230.276 75.9393 226.682 76.2441 222.96H76.5584L77.2569 223.169Z"
          fill="#D7DDDD"
        />
      </g>
      <mask
        id="mask88_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask88_31_1526)">
        <path
          d="M77.2569 223.274C76.9088 226.488 76.011 229.619 74.6027 232.529C74.3096 233.102 73.9709 233.651 73.5899 234.17C72.7973 235.26 71.9216 236.288 70.9706 237.243C70.5864 237.662 70.2023 238.082 69.853 238.536C68.8583 239.803 68.0903 241.232 67.583 242.761C67.3067 243.525 67.0849 244.307 66.9194 245.101C66.5198 246.872 66.2513 248.669 66.1162 250.48C66.1162 251.842 65.9066 253.343 65.8717 254.915H64.8938C64.8938 253.204 64.8938 251.422 65.1732 250.095C65.329 248.249 65.6208 246.416 66.0463 244.612C66.2558 243.809 66.4654 243.076 66.6749 242.447C67.2431 240.771 68.1065 239.209 69.2244 237.837L70.2721 236.65C71.1825 235.736 72.023 234.755 72.7866 233.716C74.7579 230.547 75.9544 226.957 76.279 223.239H76.5584L77.2569 223.274Z"
          fill="#D4DADB"
        />
      </g>
      <mask
        id="mask89_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask89_31_1526)">
        <path
          d="M77.222 223.379C76.8566 226.596 75.972 229.734 74.6027 232.668C74.3145 233.256 73.9756 233.816 73.5899 234.345C72.7973 235.435 71.9216 236.463 70.9706 237.418C70.5864 237.837 70.2023 238.256 69.853 238.71C68.8756 239.924 68.1083 241.294 67.583 242.761C67.3067 243.525 67.0849 244.307 66.9194 245.101C66.5345 246.886 66.2662 248.695 66.1162 250.514C66.1162 251.877 65.9066 253.378 65.8717 254.95H64.8938C64.8938 253.239 64.8938 251.457 65.1732 250.13C65.329 248.284 65.6208 246.451 66.0463 244.647C66.2558 243.856 66.4654 243.122 66.6749 242.447C67.2431 240.771 68.1065 239.209 69.2244 237.837L70.2721 236.65C71.1841 235.728 72.0357 234.748 72.8215 233.716C74.7488 230.526 75.9418 226.947 76.3139 223.239H76.5933L77.222 223.379Z"
          fill="#D2D8D9"
        />
      </g>
      <mask
        id="mask90_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask90_31_1526)">
        <path
          d="M77.222 223.483C76.8628 226.714 75.978 229.863 74.6027 232.808C74.3145 233.395 73.9756 233.956 73.5899 234.484C72.7883 235.579 71.9132 236.617 70.9706 237.593C70.5864 238.012 70.2023 238.431 69.853 238.885C68.8507 240.121 68.0815 241.529 67.583 243.041C67.3228 243.809 67.1013 244.59 66.9194 245.381C66.5345 247.166 66.2662 248.974 66.1162 250.794C66.1162 252.191 65.9066 253.693 65.8717 255.264H64.8938C64.8938 253.553 64.8938 251.772 65.1732 250.41C65.3339 248.554 65.6139 246.711 66.0114 244.892C66.2209 244.1 66.4305 243.367 66.64 242.692C67.2082 241.015 68.0716 239.454 69.1895 238.082L70.2372 236.894C71.1478 235.968 71.9883 234.976 72.7517 233.926C74.6715 230.732 75.8639 227.155 76.2441 223.448H76.5933L77.222 223.483Z"
          fill="#CFD6D8"
        />
      </g>
      <mask
        id="mask91_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask91_31_1526)">
        <path
          d="M77.187 223.588C76.8058 226.821 75.9343 229.977 74.6027 232.948C74.3145 233.535 73.9756 234.096 73.5899 234.624C72.8194 235.733 71.9547 236.773 71.0055 237.732C70.6058 238.151 70.2326 238.594 69.8879 239.059C68.8914 240.313 68.123 241.731 67.6179 243.25C67.3281 244.021 67.1061 244.816 66.9543 245.625C66.5668 247.41 66.2985 249.218 66.1511 251.038C66.1511 252.435 65.9415 253.937 65.9066 255.509H64.9287C64.9287 253.832 64.9287 252.016 65.2081 250.654C65.3689 248.799 65.6488 246.956 66.0463 245.136C66.2558 244.333 66.4654 243.6 66.6749 242.971C67.2521 241.277 68.1143 239.695 69.2244 238.291L70.2721 237.139C71.1843 236.204 72.0359 235.213 72.8215 234.17C74.7362 230.974 75.9282 227.398 76.3139 223.693H77.2569L77.187 223.588Z"
          fill="#CDD4D6"
        />
      </g>
      <mask
        id="mask92_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask92_31_1526)">
        <path
          d="M77.187 223.693C76.7906 226.934 75.9198 230.1 74.6027 233.087C74.3208 233.671 73.9938 234.231 73.6248 234.764C72.875 235.878 72.0214 236.919 71.0754 237.872C70.6658 238.282 70.2919 238.726 69.9578 239.199C68.4505 241.119 67.4211 243.369 66.9543 245.765C66.5632 247.548 66.3064 249.357 66.186 251.178C66.186 252.61 66.0114 254.112 65.9415 255.648C65.9415 255.648 65.6621 255.648 65.6971 255.648H64.9986C64.9986 253.972 64.9986 252.156 65.2431 250.759C65.4038 248.904 65.6838 247.06 66.0812 245.241C66.2908 244.403 66.5003 243.669 66.7099 243.041C67.2661 241.341 68.1434 239.765 69.2942 238.396C69.6435 237.977 69.9927 237.558 70.342 237.208C71.2428 236.283 72.0717 235.291 72.8215 234.24C74.7112 231.033 75.9014 227.462 76.3139 223.763H76.5933L77.187 223.693Z"
          fill="#CAD2D4"
        />
      </g>
      <mask
        id="mask93_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask93_31_1526)">
        <path
          d="M77.1521 223.798C76.7839 227.056 75.912 230.237 74.5677 233.227C74.2725 233.803 73.946 234.363 73.5899 234.904C72.8283 236.03 71.9631 237.082 71.0055 238.047C70.6213 238.466 70.2372 238.885 69.853 239.374C68.8495 240.628 68.0697 242.046 67.548 243.565C67.2719 244.34 67.0502 245.133 66.8845 245.94C66.494 247.746 66.2372 249.579 66.1161 251.423C66.1161 252.82 66.1161 254.356 65.8717 255.928H65.6272H64.9287C64.9287 254.217 64.9287 252.435 65.1732 251.038C65.3287 249.171 65.6088 247.316 66.0114 245.486C66.2209 244.694 66.4305 243.961 66.64 243.285C67.2201 241.586 68.0949 240.002 69.2244 238.606L70.2721 237.418C71.1815 236.488 72.011 235.484 72.7517 234.415C74.6666 231.143 75.8575 227.499 76.2441 223.728H77.222L77.1521 223.798Z"
          fill="#C7CFD2"
        />
      </g>
      <mask
        id="mask94_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask94_31_1526)">
        <path
          d="M77.1521 223.937C76.7632 227.199 75.9045 230.386 74.6027 233.402C74.3129 233.981 73.9863 234.541 73.6248 235.078C72.8633 236.204 71.998 237.256 71.0404 238.221C70.6563 238.675 70.2721 239.059 69.8879 239.548C68.8939 240.809 68.1151 242.225 67.583 243.739C67.3069 244.514 67.0851 245.308 66.9194 246.114C66.5289 247.92 66.2721 249.753 66.1511 251.597C66.1511 252.994 66.1511 254.531 65.9415 256.102H65.6971H64.9986C64.9986 254.391 64.9986 252.61 65.2431 251.213C65.3695 249.342 65.6499 247.485 66.0812 245.66C66.2908 244.857 66.5003 244.123 66.7099 243.425C67.2817 241.722 68.1573 240.136 69.2942 238.745L70.342 237.593C71.2514 236.663 72.0808 235.658 72.8215 234.589C74.7023 231.29 75.8906 227.642 76.3139 223.868H76.5933L77.1521 223.937Z"
          fill="#C4CDD0"
        />
      </g>
      <mask
        id="mask95_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask95_31_1526)">
        <path
          d="M77.1172 224.042C76.7401 227.306 75.881 230.495 74.5677 233.507C74.2778 234.097 73.9512 234.668 73.5899 235.218C72.8188 236.348 71.9543 237.411 71.0055 238.396C70.6213 238.815 70.2372 239.234 69.853 239.723C68.8517 240.991 68.0724 242.42 67.548 243.949C67.2677 244.735 67.0459 245.54 66.8845 246.359C66.4968 248.165 66.2401 249.998 66.1162 251.842C66.1162 253.273 66.1162 254.81 65.9066 256.347H65.6621H64.9637C64.9637 254.67 64.9637 252.854 65.2081 251.423C65.3397 249.543 65.6082 247.675 66.0114 245.835C66.2209 244.997 66.4654 244.263 66.64 243.6C67.2118 241.896 68.0874 240.311 69.2244 238.92C69.5736 238.501 69.9229 238.082 70.2721 237.732C71.1901 236.798 72.0202 235.781 72.7517 234.694C74.6369 231.384 75.8254 227.723 76.2441 223.937H76.4886L77.1172 224.042Z"
          fill="#C2CBCE"
        />
      </g>
      <mask
        id="mask96_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask96_31_1526)">
        <path
          d="M77.1172 224.147C76.7245 227.415 75.8782 230.612 74.6027 233.646C74.3339 234.248 74.0064 234.821 73.6248 235.358C72.8838 236.5 72.0296 237.565 71.0754 238.536L69.8879 239.863C68.8867 241.131 68.1073 242.56 67.583 244.089C67.3026 244.874 67.0808 245.68 66.9194 246.498C66.5292 248.316 66.2724 250.161 66.1511 252.016C66.1511 253.448 66.1511 254.985 65.9415 256.556H65.6971H64.9986C64.9986 254.88 64.9986 253.064 65.2431 251.632C65.397 249.822 65.6771 248.025 66.0812 246.254C66.2516 245.498 66.4614 244.752 66.7099 244.019C67.2759 242.299 68.1387 240.691 69.2593 239.269C69.5929 238.849 69.9546 238.452 70.3419 238.082C71.26 237.147 72.09 236.13 72.8215 235.043C74.6961 231.716 75.8837 228.046 76.3139 224.252H76.5584H77.2918L77.1172 224.147Z"
          fill="#BFC9CC"
        />
      </g>
      <mask
        id="mask97_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask97_31_1526)">
        <path
          d="M77.0823 224.252C76.6759 227.528 75.8301 230.735 74.5677 233.786C74.2892 234.387 73.9743 234.97 73.6248 235.532C72.8748 236.679 72.0214 237.754 71.0754 238.745L69.8879 240.072C68.861 241.324 68.0791 242.757 67.583 244.298C67.306 245.088 67.0728 245.892 66.8845 246.708C66.5114 248.529 66.2548 250.372 66.1162 252.226C66.1162 253.658 66.1162 255.194 65.9066 256.766H65.6621H64.9986C64.9986 255.09 64.9986 253.274 65.2431 251.842C65.3646 249.961 65.6332 248.093 66.0463 246.254C66.2167 245.498 66.4265 244.752 66.6749 244.019C67.2398 242.284 68.1286 240.672 69.2942 239.269L70.3419 238.047C71.2685 237.107 72.0991 236.078 72.8215 234.973C74.6811 231.615 75.8674 227.925 76.3139 224.112H76.5933L77.0823 224.252Z"
          fill="#BCC6CA"
        />
      </g>
      <mask
        id="mask98_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask98_31_1526)">
        <path
          d="M77.0823 224.356C76.694 227.644 75.8598 230.863 74.6027 233.926C74.3233 234.589 73.974 235.148 73.6946 235.672C72.9221 236.811 72.0578 237.886 71.1103 238.885L69.9578 240.177C68.9117 241.434 68.1173 242.881 67.6179 244.438C67.3334 245.234 67.1115 246.051 66.9543 246.882C66.5777 248.702 66.3326 250.546 66.2209 252.4C66.2209 253.867 66.0114 255.404 66.0114 256.975H65.0684C65.0684 255.299 65.0684 253.483 65.278 252.016C65.4176 250.126 65.686 248.247 66.0812 246.393C66.2558 245.59 66.5003 244.857 66.7099 244.158C67.2725 242.444 68.162 240.855 69.3291 239.479C69.6784 239.025 70.0276 238.64 70.3769 238.256C71.3034 237.317 72.134 236.287 72.8565 235.183C74.7187 231.813 75.905 228.111 76.3489 224.287H76.5933L77.0823 224.356Z"
          fill="#BAC4C8"
        />
      </g>
      <mask
        id="mask99_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask99_31_1526)">
        <path
          d="M77.0473 224.461C76.65 227.758 75.8162 230.988 74.5677 234.065C74.2966 234.67 73.9815 235.253 73.6248 235.812C72.8861 236.977 72.0319 238.065 71.0753 239.06L69.9229 240.387C68.8754 241.643 68.0808 243.089 67.583 244.647C67.2981 245.432 67.0763 246.238 66.9194 247.057C66.543 248.888 66.2979 250.744 66.186 252.61C66.186 254.042 66.0114 255.613 65.9765 257.15H65.732H65.0335C65.0335 255.474 65.0335 253.658 65.2431 252.191C65.3909 250.311 65.671 248.444 66.0812 246.603C66.2516 245.848 66.4614 245.102 66.7099 244.368C67.2643 242.629 68.1541 241.015 69.3292 239.618C69.6492 239.187 69.9993 238.778 70.3769 238.396C71.2951 237.449 72.1251 236.42 72.8565 235.323C74.7187 231.952 75.905 228.251 76.3489 224.426H76.5933L77.0473 224.461Z"
          fill="#B7C2C6"
        />
      </g>
      <mask
        id="mask100_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask100_31_1526)">
        <path
          d="M77.0473 224.566C76.6324 227.871 75.7992 231.11 74.5677 234.205C74.2966 234.809 73.9815 235.393 73.6248 235.951C72.8948 237.123 72.04 238.212 71.0753 239.199L69.9229 240.526C68.8754 241.782 68.0808 243.229 67.583 244.787C67.2981 245.571 67.0763 246.377 66.9194 247.197C66.5629 249.043 66.318 250.909 66.186 252.785C66.186 254.251 66.0114 255.788 65.9765 257.36H65.732H65.0335C65.0335 255.683 65.0335 253.867 65.2431 252.365C65.3704 250.46 65.6506 248.568 66.0812 246.708C66.2401 245.938 66.4501 245.18 66.7099 244.438C67.2643 242.699 68.1541 241.085 69.3292 239.688C69.6492 239.257 69.9993 238.848 70.3769 238.466C71.3037 237.514 72.1342 236.473 72.8565 235.358C74.6062 231.931 75.7186 228.216 76.1393 224.391H76.3838L77.0473 224.566Z"
          fill="#B5C0C4"
        />
      </g>
      <mask
        id="mask101_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask101_31_1526)">
        <path
          d="M77.0124 224.706C76.6087 228.009 75.7872 231.248 74.5677 234.345C74.3042 234.953 73.9887 235.537 73.6248 236.091C72.9127 237.275 72.0563 238.366 71.0753 239.339L69.9229 240.666C68.8774 241.929 68.0725 243.373 67.548 244.927C67.2635 245.723 67.0417 246.54 66.8845 247.371C66.528 249.218 66.2831 251.084 66.1511 252.959C66.1511 254.426 66.1511 255.998 66.1511 257.534H65.9066H65.0335C65.0335 255.858 65.0335 254.042 65.2431 252.54C65.3687 250.627 65.6254 248.725 66.0114 246.848C66.1702 246.078 66.3802 245.319 66.64 244.577C67.2072 242.844 68.0958 241.233 69.2593 239.828C69.6085 239.409 69.9578 238.99 70.3419 238.605C71.2547 237.742 72.0849 236.795 72.8215 235.777C74.5625 232.337 75.663 228.609 76.0695 224.776H76.3139L77.0124 224.706Z"
          fill="#B2BDC2"
        />
      </g>
      <mask
        id="mask102_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask102_31_1526)">
        <path
          d="M77.0124 224.811C76.5913 228.111 75.7704 231.347 74.5677 234.45C74.3074 235.075 74.004 235.682 73.6597 236.266C72.9208 237.442 72.0668 238.541 71.1103 239.548L69.9578 240.841C68.8987 242.12 68.0928 243.59 67.583 245.171C67.3073 245.97 67.0857 246.787 66.9194 247.616C66.5622 249.474 66.3173 251.351 66.186 253.239C66.186 254.705 66.0114 256.312 66.0114 257.849C66.0114 257.849 65.7669 257.849 65.8018 257.849H65.1034C65.1034 256.172 65.1034 254.356 65.3129 252.854C65.4385 250.942 65.6952 249.04 66.0812 247.162C66.2446 246.393 66.4546 245.635 66.7099 244.892C67.2828 243.143 68.1836 241.519 69.3641 240.107L70.4467 238.885C71.3809 237.936 72.2013 236.881 72.8914 235.742C74.6057 232.279 75.7048 228.545 76.1393 224.706H76.3838L77.0124 224.811Z"
          fill="#B0BBC0"
        />
      </g>
      <mask
        id="mask103_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask103_31_1526)">
        <path
          d="M76.9775 224.915C76.576 228.238 75.7666 231.499 74.5677 234.624C74.308 235.239 74.0045 235.834 73.6597 236.405C72.9386 237.594 72.0832 238.695 71.1103 239.688C70.7261 240.142 70.307 240.561 69.9229 241.05C68.8704 242.321 68.0649 243.778 67.548 245.346C67.2724 246.145 67.0507 246.962 66.8845 247.79C66.5259 249.648 66.281 251.526 66.1511 253.413C66.1511 254.915 66.1511 256.487 66.1511 258.023H65.9415H65.243C65.243 256.347 65.243 254.531 65.4526 252.994C65.5782 251.081 65.8349 249.179 66.2209 247.302C66.3751 246.531 66.5852 245.772 66.8496 245.031C67.4225 243.283 68.3233 241.659 69.5038 240.247L70.4118 239.269C71.346 238.32 72.1664 237.265 72.8565 236.126C74.568 232.652 75.6555 228.905 76.0695 225.055H76.3139L76.9775 224.915Z"
          fill="#ADB9BE"
        />
      </g>
      <mask
        id="mask104_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask104_31_1526)">
        <path
          d="M76.9775 225.02C76.5675 228.353 75.7585 231.624 74.5677 234.764C74.308 235.378 74.0046 235.974 73.6597 236.545C72.9623 237.813 72.1055 238.987 71.1103 240.037C70.7261 240.491 70.307 240.91 69.9229 241.399C68.8777 242.676 68.073 244.131 67.548 245.695C67.2724 246.494 67.0507 247.311 66.8845 248.14C66.5244 249.996 66.2911 251.875 66.186 253.762C66.186 255.264 66.186 256.836 66.0114 258.372H65.8018H65.1034C65.1034 256.696 65.1034 254.88 65.1034 253.343C65.256 251.42 65.5242 249.507 65.9066 247.616C66.0608 246.845 66.2709 246.086 66.5352 245.346C67.0865 243.577 67.9893 241.938 69.1895 240.526C69.5387 240.107 69.9229 239.723 70.2721 239.339C71.2059 238.385 72.0156 237.317 72.6819 236.161C74.3826 232.671 75.4695 228.914 75.8949 225.055H76.1743L76.9775 225.02Z"
          fill="#ABB7BC"
        />
      </g>
      <mask
        id="mask105_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask105_31_1526)">
        <path
          d="M76.9426 225.299C76.5202 228.641 75.7115 231.923 74.5328 235.078C74.2731 235.693 73.9696 236.288 73.6248 236.859C72.9273 238.127 72.0706 239.301 71.0753 240.352C70.6912 240.806 70.2721 241.225 69.8879 241.714C68.8357 242.998 68.0305 244.466 67.5131 246.044C67.2333 246.854 67.0115 247.683 66.8496 248.524C66.4875 250.392 66.2541 252.282 66.1511 254.182C66.1511 255.683 66.1511 257.255 66.1511 258.826H65.9415H65.243C65.243 257.15 65.243 255.334 65.243 253.797C65.386 251.875 65.6426 249.962 66.0114 248.07C66.2209 247.232 66.3955 246.463 66.64 245.765C67.2162 244 68.1295 242.363 69.3291 240.945C69.6435 240.526 70.0276 240.107 70.3769 239.723C71.3403 238.787 72.1637 237.716 72.8215 236.545C74.5006 233 75.5748 229.199 75.9996 225.299H76.2441H76.9426Z"
          fill="#A8B5BA"
        />
      </g>
      <mask
        id="mask106_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask106_31_1526)">
        <path
          d="M76.9426 225.299C76.5238 228.65 75.7271 231.942 74.5677 235.113C74.308 235.728 74.0045 236.323 73.6597 236.894C72.9723 238.169 72.1146 239.343 71.1103 240.387C70.7261 240.841 70.307 241.26 69.9229 241.749C68.871 243.039 68.0552 244.505 67.5131 246.079C67.2333 246.889 67.0115 247.718 66.8496 248.559C66.4875 250.426 66.2541 252.317 66.1511 254.216C66.1511 255.718 66.1511 257.325 66.1511 258.861H65.9415H65.243C65.243 257.22 65.243 255.369 65.243 253.797C65.3884 251.863 65.645 249.939 66.0114 248.035C66.2209 247.197 66.3955 246.428 66.64 245.73C67.2162 243.965 68.1295 242.328 69.3291 240.91C69.6507 240.48 70.0007 240.072 70.3769 239.688C71.3403 238.752 72.1637 237.681 72.8215 236.51C74.4751 232.982 75.537 229.207 75.9647 225.334H76.2092L76.9426 225.299Z"
          fill="#A6B2B8"
        />
      </g>
      <mask
        id="mask107_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask107_31_1526)">
        <path
          d="M76.9076 225.299C76.4808 228.66 75.6844 231.963 74.5328 235.148C74.2731 235.763 73.9696 236.358 73.6248 236.929C72.9558 238.206 72.1092 239.382 71.1103 240.422C70.7261 240.876 70.307 241.295 69.9229 241.784C68.871 243.074 68.0552 244.54 67.5131 246.114C67.2333 246.924 67.0115 247.752 66.8496 248.594C66.4856 250.473 66.2522 252.375 66.1511 254.286C66.1511 255.788 66.1511 257.395 66.1511 258.931H65.9415H65.243C65.243 257.29 65.243 255.439 65.243 253.867C65.3566 251.932 65.6016 250.007 65.9765 248.105C66.1355 247.324 66.3455 246.554 66.6051 245.8C67.1708 244.037 68.0721 242.401 69.2593 240.98C69.6085 240.526 69.9927 240.142 70.3419 239.758C71.2955 238.8 72.1176 237.719 72.7866 236.545C74.434 232.99 75.4954 229.193 75.9298 225.299H76.1393H76.9076Z"
          fill="#A3B0B6"
        />
      </g>
      <mask
        id="mask108_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask108_31_1526)">
        <path
          d="M76.9076 225.474C76.4683 228.829 75.6842 232.129 74.5677 235.323C74.2884 235.986 73.974 236.615 73.6946 237.139C73.0285 238.417 72.1816 239.594 71.1801 240.631C70.796 241.085 70.3769 241.504 69.9927 241.993C68.9355 243.254 68.1187 244.698 67.583 246.254C67.3031 247.064 67.0814 247.892 66.9194 248.733C66.5576 250.613 66.3242 252.515 66.2209 254.426C66.2209 255.963 66.2209 257.569 66.2209 259.106H66.0114H65.2081C65.2081 257.464 65.2081 255.613 65.3827 254.007C65.4815 252.059 65.7267 250.121 66.1162 248.21C66.2752 247.428 66.4852 246.658 66.7448 245.905C67.3104 244.131 68.2115 242.483 69.399 241.05C69.7482 240.596 70.1324 240.212 70.4816 239.828C71.4352 238.87 72.2573 237.789 72.9263 236.615C74.5496 233.029 75.5985 229.211 76.0345 225.299H76.2441L76.9076 225.474Z"
          fill="#A1AEB4"
        />
      </g>
      <mask
        id="mask109_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask109_31_1526)">
        <path
          d="M76.8727 225.579C76.471 228.948 75.698 232.263 74.5677 235.462C74.2534 236.126 73.974 236.754 73.6946 237.278C73.0015 238.549 72.1444 239.723 71.1452 240.771C70.734 241.201 70.3491 241.656 69.9927 242.133C68.9405 243.345 68.1233 244.742 67.583 246.254C67.3067 247.067 67.0736 247.895 66.8845 248.733C66.5382 250.602 66.3165 252.493 66.2209 254.391C66.2209 255.963 66.2209 257.534 66.2209 259.071H66.0114H65.3129C65.3129 257.429 65.3129 255.578 65.4875 253.972C65.5844 252.024 65.8296 250.086 66.2209 248.175C66.3459 247.525 66.5091 246.884 66.7099 246.254C67.2786 244.475 68.1924 242.825 69.399 241.399L70.4816 240.177C71.4355 239.228 72.2471 238.145 72.8914 236.964C74.5184 233.392 75.5675 229.585 75.9996 225.684H76.2092L76.8727 225.579Z"
          fill="#9EACB2"
        />
      </g>
      <mask
        id="mask110_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask110_31_1526)">
        <path
          d="M76.8727 225.684C76.4671 229.052 75.6942 232.367 74.5677 235.567C74.3253 236.206 74.0334 236.825 73.6946 237.418C73.0134 238.688 72.1679 239.862 71.1801 240.91C70.796 241.364 70.3769 241.784 69.9927 242.272C68.9084 243.554 68.0893 245.038 67.583 246.638C67.3034 247.46 67.0817 248.3 66.9194 249.153C66.5729 251.046 66.3397 252.959 66.2209 254.88C66.2209 256.452 66.2209 258.023 66.2209 259.56H66.0114H65.2081C65.2081 257.918 65.2081 256.067 65.2081 254.461C65.3071 252.501 65.5523 250.552 65.9415 248.629C66.1407 247.82 66.3974 247.026 66.7099 246.254C67.2529 244.482 68.1566 242.841 69.3641 241.434C69.7482 240.98 70.0975 240.596 70.4467 240.142C71.4156 239.184 72.2392 238.09 72.8914 236.894C74.4757 233.309 75.5117 229.507 75.9647 225.614H76.1742L76.8727 225.684Z"
          fill="#9CAAB0"
        />
      </g>
      <mask
        id="mask111_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask111_31_1526)">
        <path
          d="M76.8378 225.788C76.4196 229.189 75.647 232.537 74.5328 235.777C74.2979 236.419 74.0057 237.038 73.6597 237.628C72.988 238.903 72.1416 240.078 71.1452 241.12L69.9578 242.482C68.8735 243.763 68.0544 245.247 67.548 246.847C67.2685 247.669 67.0468 248.509 66.8845 249.362C66.5365 251.254 66.3148 253.168 66.2209 255.09C66.2209 256.626 66.2209 258.268 66.2209 259.804H66.0114H65.3129C65.3129 258.163 65.3129 256.312 65.3129 254.67C65.4119 252.711 65.6571 250.761 66.0463 248.838C66.2014 248.045 66.4115 247.263 66.6749 246.498C67.2437 244.709 68.1572 243.048 69.3641 241.609L70.4467 240.352C71.4084 239.388 72.2312 238.295 72.8914 237.104C74.4586 233.489 75.4938 229.665 75.9647 225.753H76.1742L76.8378 225.788Z"
          fill="#99A7AE"
        />
      </g>
      <mask
        id="mask112_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask112_31_1526)">
        <path
          d="M76.8378 225.893C76.4028 229.257 75.6306 232.568 74.5328 235.777C74.2979 236.419 74.0057 237.038 73.6597 237.628C72.9969 238.908 72.1497 240.085 71.1452 241.12L69.9578 242.482C68.8667 243.777 68.0366 245.272 67.5131 246.882C67.2336 247.704 67.0119 248.544 66.8496 249.397C66.4997 251.301 66.2781 253.226 66.186 255.159C66.186 256.731 66.186 258.337 66.186 259.874H65.4875C65.4875 258.233 65.4875 256.382 65.4875 254.74C65.5918 252.783 65.8252 250.835 66.186 248.908C66.3411 248.114 66.5512 247.333 66.8146 246.568C67.3834 244.778 68.2969 243.117 69.5038 241.679L70.6213 240.421C71.5909 239.46 72.4039 238.352 73.0311 237.139C74.5924 233.512 75.616 229.676 76.0695 225.753H76.279L76.8378 225.893Z"
          fill="#96A5AC"
        />
      </g>
      <mask
        id="mask113_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask113_31_1526)">
        <path
          d="M76.8029 225.998C76.3633 229.403 75.6032 232.759 74.5328 236.021C74.2946 236.656 74.0146 237.274 73.6946 237.872C73.0202 239.146 72.1741 240.321 71.1801 241.364L69.9578 242.761C68.8667 244.057 68.0366 245.551 67.5131 247.162C67.2336 247.983 67.0118 248.824 66.8496 249.676C66.4997 251.58 66.278 253.505 66.186 255.439C66.186 257.01 66.186 258.652 66.186 260.153H65.1383C65.1383 258.512 65.1383 256.661 65.1383 255.02C65.245 253.051 65.4783 251.091 65.8368 249.152C65.9919 248.359 66.2019 247.577 66.4654 246.813C67.0343 245.016 67.9609 243.353 69.1895 241.923L70.307 240.666C71.2687 239.697 72.0808 238.591 72.7168 237.383C74.2483 233.734 75.2707 229.891 75.7552 225.963H75.9647L76.8029 225.998Z"
          fill="#94A3AA"
        />
      </g>
      <mask
        id="mask114_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask114_31_1526)">
        <path
          d="M76.8029 226.103C76.369 229.52 75.6088 232.888 74.5328 236.161C74.2884 236.824 73.974 237.453 73.6946 238.047C73.0289 239.326 72.182 240.502 71.1801 241.539C70.761 241.958 70.3769 242.447 69.9578 242.936C68.8473 244.218 68.0148 245.716 67.5131 247.336C67.2336 248.158 67.0118 248.998 66.8496 249.851C66.4999 251.767 66.2783 253.703 66.186 255.648C66.186 257.22 66.186 258.861 66.186 260.398H65.1383C65.1383 258.757 65.1383 256.906 65.1383 255.229C65.2429 253.26 65.4762 251.3 65.8368 249.362C65.9919 248.568 66.2019 247.787 66.4654 247.022C67.0235 245.21 67.9511 243.534 69.1895 242.098L70.307 240.841C71.2608 239.865 72.072 238.76 72.7168 237.558C74.2467 233.898 75.2576 230.042 75.7202 226.103H75.9298H76.6632H76.8029Z"
          fill="#91A0A8"
        />
      </g>
      <mask
        id="mask115_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask115_31_1526)">
        <path
          d="M76.7679 226.242C76.3398 229.669 75.5915 233.048 74.5328 236.335C74.2943 236.981 74.0143 237.611 73.6946 238.221C73.0505 239.514 72.2013 240.693 71.1801 241.714L69.9578 243.111C68.8546 244.398 68.023 245.894 67.5131 247.511C67.2294 248.343 67.0076 249.196 66.8496 250.061C66.4999 251.976 66.2783 253.913 66.186 255.858C66.186 257.43 66.186 259.071 66.186 260.608H65.1732C65.1732 258.966 65.1732 257.115 65.1732 255.439C65.3167 253.524 65.5968 251.621 66.0114 249.746C66.1665 248.953 66.3765 248.171 66.64 247.406C67.1982 245.594 68.1257 243.918 69.3641 242.482L70.4816 241.225C71.4437 240.243 72.2557 239.125 72.8914 237.907C74.4219 234.213 75.4213 230.321 75.8599 226.347H76.0695H76.7679V226.242Z"
          fill="#8F9EA6"
        />
      </g>
      <mask
        id="mask116_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask116_31_1526)">
        <path
          d="M76.768 226.347C76.3325 229.773 75.5843 233.151 74.5328 236.44C74.2943 237.086 74.0143 237.716 73.6946 238.326C73.038 239.602 72.2031 240.778 71.215 241.818L69.9927 243.215C68.8963 244.515 68.0763 246.024 67.583 247.651C67.2983 248.485 67.065 249.337 66.8845 250.2C66.5522 252.118 66.3306 254.054 66.2209 255.998C66.2209 257.569 66.2209 259.245 66.2209 260.747C66.2209 260.747 66.2209 260.747 66.2209 260.922H65.2081C65.2081 259.28 65.2081 257.429 65.2081 255.718C65.3266 253.71 65.5951 251.714 66.0114 249.746C66.1708 248.942 66.3807 248.149 66.64 247.371C67.1982 245.559 68.1257 243.883 69.3641 242.447L70.4816 241.19C71.458 240.155 72.2707 238.977 72.8914 237.697C74.3948 233.995 75.3932 230.107 75.8599 226.138H76.0695L76.768 226.347Z"
          fill="#8C9CA3"
        />
      </g>
      <mask
        id="mask117_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask117_31_1526)">
        <path
          d="M76.733 226.452C76.287 229.887 75.539 233.276 74.4979 236.58C74.2534 237.278 73.9391 237.907 73.6946 238.466C73.0465 239.747 72.2108 240.924 71.215 241.958C70.7796 242.399 70.3714 242.865 69.9927 243.355C68.8973 244.666 68.0564 246.171 67.5131 247.79C67.2294 248.623 67.0076 249.475 66.8496 250.34C66.4945 252.266 66.2843 254.215 66.2209 256.172C66.2209 257.779 66.2209 259.42 66.2209 260.957H66.0114H65.3129C65.3129 259.35 65.3129 257.464 65.3129 255.753C65.4179 253.761 65.6512 251.778 66.0114 249.816C66.1663 249.011 66.3764 248.218 66.64 247.441C67.2421 245.73 68.1536 244.143 69.3292 242.761L70.4467 241.504C71.4288 240.474 72.2421 239.296 72.8565 238.012C74.3546 234.297 75.3415 230.397 75.7901 226.417H75.9996L76.733 226.452Z"
          fill="#8A99A1"
        />
      </g>
      <mask
        id="mask118_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask118_31_1526)">
        <path
          d="M76.733 226.557C76.3031 230 75.5787 233.4 74.5677 236.72C74.3224 237.374 74.0427 238.015 73.7296 238.64C73.1059 239.936 72.2676 241.117 71.25 242.133L70.0276 243.53C68.9319 244.835 68.1015 246.342 67.583 247.965C67.3027 248.801 67.0695 249.652 66.8845 250.515C66.5487 252.443 66.3388 254.391 66.2558 256.347C66.2558 257.953 66.2558 259.63 66.2558 261.131H65.243C65.243 259.525 65.243 257.639 65.243 255.928C65.3383 253.937 65.5599 251.954 65.9066 249.991C66.1161 249.118 66.2908 248.314 66.5352 247.616C67.1409 245.816 68.1164 244.162 69.399 242.761L70.5166 241.504C71.5097 240.476 72.3347 239.297 72.9612 238.012C74.4219 234.275 75.3962 230.367 75.8599 226.382H76.0695L76.733 226.557Z"
          fill="#87979F"
        />
      </g>
      <mask
        id="mask119_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask119_31_1526)">
        <path
          d="M76.6981 226.661C76.2485 230.116 75.5126 233.527 74.4979 236.859C74.2639 237.513 73.9958 238.154 73.6946 238.78C73.0555 240.066 72.2188 241.245 71.215 242.272C70.796 242.726 70.3769 243.18 69.9927 243.669C68.89 244.989 68.0485 246.506 67.5131 248.14C67.2337 248.973 67.012 249.825 66.8496 250.689C66.486 252.684 66.2759 254.704 66.2209 256.731C66.2209 258.337 66.2209 260.014 66.2209 261.516C66.2209 261.516 66.2209 261.516 66.2209 261.69H65.2081C65.2081 260.084 65.2081 258.198 65.2081 256.452C65.3034 254.46 65.525 252.477 65.8717 250.514C66.0266 249.709 66.2367 248.916 66.5003 248.14C67.0616 246.311 68.0016 244.621 69.2593 243.18L70.3769 241.923C71.3646 240.898 72.1785 239.718 72.7866 238.431C74.2513 234.681 75.2369 230.762 75.7202 226.766L76.6981 226.661Z"
          fill="#85959D"
        />
      </g>
      <mask
        id="mask120_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask120_31_1526)">
        <path
          d="M76.6981 226.766C76.2548 230.23 75.5307 233.652 74.5328 236.999C74.3051 237.655 74.0369 238.297 73.7296 238.92C73.0992 240.211 72.2616 241.391 71.25 242.412C70.8309 242.866 70.4118 243.32 70.0276 243.809C68.9124 245.12 68.0695 246.639 67.548 248.279C67.2647 249.124 67.043 249.987 66.8845 250.864C66.5316 252.801 66.3215 254.763 66.2558 256.731C66.2558 258.337 66.2558 260.014 66.2558 261.551H65.243C65.243 259.944 65.243 258.058 65.243 256.312C65.3385 254.309 65.5601 252.315 65.9066 250.34C66.0616 249.535 66.2716 248.741 66.5352 247.965C67.1015 246.128 68.0408 244.428 69.2942 242.971L70.4118 241.714C71.3995 240.688 72.2135 239.509 72.8215 238.221C74.2697 234.457 75.2434 230.527 75.7202 226.522L76.6981 226.766Z"
          fill="#82939B"
        />
      </g>
      <mask
        id="mask121_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask121_31_1526)">
        <path
          d="M76.6632 226.871C76.2303 230.348 75.506 233.783 74.4979 237.139C74.2702 237.795 74.0019 238.436 73.6946 239.059C73.0525 240.344 72.2162 241.522 71.215 242.552C70.796 243.006 70.3769 243.46 69.9927 243.949C68.8775 245.259 68.0346 246.779 67.5131 248.419C67.234 249.265 67.0123 250.128 66.8496 251.003C66.497 252.953 66.2869 254.926 66.2209 256.906C66.2209 258.547 66.2209 260.398 66.2209 261.725H65.243C65.243 260.119 65.243 258.233 65.243 256.487C65.3211 254.483 65.5428 252.487 65.9066 250.515C66.0661 249.699 66.276 248.894 66.5352 248.105C67.1015 246.268 68.0408 244.568 69.2942 243.111L70.4118 241.853C71.3995 240.828 72.2135 239.648 72.8215 238.361C74.2487 234.58 75.2104 230.64 75.6853 226.627H75.8599L76.6632 226.871Z"
          fill="#809098"
        />
      </g>
      <mask
        id="mask122_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask122_31_1526)">
        <path
          d="M76.6632 227.011C76.2235 230.487 75.4993 233.921 74.4979 237.278C74.2699 237.946 74.0016 238.599 73.6946 239.234C73.0698 240.529 72.2316 241.71 71.215 242.726C70.796 243.18 70.3769 243.634 69.9927 244.123C68.8658 245.432 68.011 246.951 67.4782 248.594C67.199 249.439 66.9774 250.303 66.8146 251.178C66.4794 253.13 66.2694 255.101 66.186 257.08C66.186 258.722 66.186 260.573 66.186 261.935C66.186 261.935 66.186 261.935 66.186 262.109H65.243C65.243 260.503 65.243 258.617 65.243 256.836C65.304 254.819 65.5258 252.81 65.9066 250.829C66.0618 250.012 66.2718 249.207 66.5352 248.419C67.1064 246.563 68.0446 244.841 69.2942 243.355L70.4118 242.098C71.3968 241.078 72.2 239.896 72.7866 238.605C74.1935 234.809 75.1432 230.858 75.6155 226.836L76.6632 227.011Z"
          fill="#7D8E96"
        />
      </g>
      <mask
        id="mask123_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask123_31_1526)">
        <path
          d="M76.6283 227.115C76.1959 230.601 75.4835 234.047 74.4979 237.418C74.2765 238.077 74.0081 238.719 73.6946 239.339C73.0782 240.639 72.239 241.821 71.215 242.831L69.9578 244.228C68.8236 245.558 67.9684 247.102 67.4433 248.768C67.1639 249.602 66.9422 250.454 66.7797 251.318C66.441 253.28 66.2426 255.264 66.186 257.255C66.186 258.896 66.186 260.747 66.186 262.109H65.243C65.243 260.503 65.243 258.617 65.243 256.836C65.3096 254.821 65.5197 252.814 65.8717 250.829C66.0269 250.012 66.2369 249.207 66.5003 248.419C67.0589 246.561 68.0119 244.846 69.2942 243.39L70.4467 242.133C71.443 241.122 72.2477 239.939 72.8215 238.64C74.2367 234.834 75.1865 230.87 75.6504 226.836H75.8599L76.6283 227.115Z"
          fill="#7B8C94"
        />
      </g>
      <mask
        id="mask124_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask124_31_1526)">
        <path
          d="M76.6283 227.22C76.2143 230.766 75.5016 234.271 74.4979 237.697C74.2534 238.431 73.974 239.059 73.7296 239.653C73.1193 240.939 72.3056 242.119 71.3198 243.146C70.8658 243.6 70.4816 244.089 70.0276 244.577C68.917 245.91 68.0643 247.438 67.5131 249.083C67.238 249.918 67.0164 250.769 66.8496 251.632C66.5144 253.595 66.316 255.579 66.2558 257.569C66.2558 259.211 66.2558 261.062 66.2558 262.424C66.2558 262.424 66.2558 262.424 66.2558 262.633H65.3478C65.3478 261.027 65.3478 259.141 65.3478 257.36C65.4166 255.334 65.6267 253.315 65.9765 251.318C66.1438 250.504 66.3536 249.7 66.6051 248.908C67.1667 247.044 68.1326 245.327 69.4339 243.879L70.5864 242.587C71.5763 241.571 72.3801 240.389 72.9612 239.094C74.3399 235.267 75.2773 231.295 75.7552 227.255H75.9298L76.6283 227.22Z"
          fill="#788A92"
        />
      </g>
      <mask
        id="mask125_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask125_31_1526)">
        <path
          d="M76.5933 227.325C76.1643 230.866 75.4638 234.369 74.4979 237.802C74.2534 238.536 73.974 239.199 73.7296 239.758C73.1127 241.04 72.2997 242.219 71.3198 243.25C70.8658 243.669 70.4816 244.158 70.0276 244.647C68.917 245.98 68.0643 247.508 67.5131 249.153C67.23 250.009 67.0083 250.884 66.8496 251.772C66.5108 253.734 66.3124 255.718 66.2558 257.709C66.2558 259.35 66.2558 261.201 66.2558 262.598C66.2558 262.598 66.2558 262.598 66.2558 262.808H65.3478C65.3478 261.201 65.3478 259.315 65.3478 257.499C65.4146 255.473 65.6247 253.454 65.9765 251.457C66.1441 250.632 66.3539 249.816 66.6051 249.013C67.1878 247.158 68.1513 245.445 69.4339 243.984L70.6213 242.761C71.6063 241.741 72.4095 240.56 72.9962 239.269C74.3744 235.418 75.3117 231.422 75.7901 227.36L75.9647 227.185L76.5933 227.325Z"
          fill="#768890"
        />
      </g>
      <mask
        id="mask126_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask126_31_1526)">
        <path
          d="M76.5933 227.43C76.1495 230.968 75.4492 234.47 74.4979 237.907C74.2807 238.585 74.0242 239.25 73.7296 239.898C73.121 241.185 72.3071 242.364 71.3198 243.39C70.8658 243.844 70.4816 244.298 70.0276 244.822C68.8988 246.155 68.0443 247.698 67.5131 249.362C67.23 250.218 67.0083 251.094 66.8496 251.981C66.5092 253.955 66.3108 255.951 66.2558 257.953C66.2558 259.63 66.2558 261.446 66.2558 262.843C66.2558 262.843 66.2558 262.843 66.2558 263.052H65.3478C65.3478 261.446 65.3478 259.56 65.3478 257.744C65.4168 255.706 65.6268 253.676 65.9765 251.667C66.186 250.759 66.3606 249.956 66.6051 249.222C67.1954 247.36 68.1578 245.637 69.4339 244.158L70.5864 242.866C71.5763 241.85 72.3801 240.668 72.9612 239.374C74.3161 235.518 75.2414 231.524 75.7202 227.465V227.255L76.5933 227.43Z"
          fill="#74858E"
        />
      </g>
      <mask
        id="mask127_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask127_31_1526)">
        <path
          d="M76.5584 227.535C76.1308 231.076 75.4302 234.579 74.463 238.012C74.2458 238.69 73.9892 239.354 73.6946 240.002C73.0827 241.296 72.2561 242.477 71.25 243.495L69.9927 244.927C68.8267 246.345 67.9596 247.984 67.4433 249.746C67.1644 250.604 66.9427 251.479 66.7797 252.366C66.4411 254.34 66.2427 256.335 66.186 258.338C66.186 260.014 66.186 261.83 66.186 263.227C66.186 263.227 66.186 263.227 66.186 263.436H65.243C65.243 261.83 65.243 259.944 65.243 258.093C65.312 256.055 65.5221 254.025 65.8717 252.016C66.0271 251.188 66.2371 250.372 66.5003 249.572C67.0802 247.712 68.0306 245.99 69.2942 244.508L70.4467 243.215C71.4524 242.212 72.2583 241.027 72.8215 239.723C74.2021 235.864 75.1166 231.855 75.5456 227.779L75.7552 227.57L76.5584 227.535Z"
          fill="#71838C"
        />
      </g>
      <mask
        id="mask128_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask128_31_1526)">
        <path
          d="M76.5584 227.639C76.1169 231.175 75.4284 234.676 74.4979 238.116C74.3116 238.805 74.0541 239.472 73.7296 240.107C73.1172 241.392 72.3038 242.571 71.3198 243.6C70.8658 244.054 70.4816 244.542 70.0276 245.031C68.8879 246.428 68.0229 248.028 67.4782 249.746C67.1993 250.604 66.9777 251.479 66.8146 252.365C66.4918 254.353 66.2935 256.36 66.2209 258.372C66.2209 260.049 66.2209 261.865 66.2209 263.297C66.2209 263.297 66.2209 263.297 66.2209 263.506H65.278C65.278 261.935 65.278 260.014 65.278 258.163C65.3275 256.124 65.5377 254.092 65.9066 252.086C66.062 251.258 66.272 250.442 66.5352 249.641C67.1161 247.772 68.0662 246.038 69.3291 244.542L70.5166 243.25C71.5111 242.238 72.3155 241.055 72.8914 239.758C74.2191 235.872 75.1322 231.857 75.6155 227.779V227.569H76.3139L76.5584 227.639Z"
          fill="#6F8189"
        />
      </g>
      <mask
        id="mask129_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask129_31_1526)">
        <path
          d="M76.5235 227.779C76.0788 231.315 75.3903 234.815 74.463 238.256C74.2568 238.933 74.012 239.598 73.7296 240.247C73.1173 241.532 72.3038 242.711 71.3198 243.739L70.0276 245.171C68.897 246.522 68.032 248.074 67.4782 249.746C67.1993 250.604 66.9777 251.479 66.8146 252.365C66.4744 254.351 66.276 256.359 66.2209 258.372C66.2209 260.049 66.2209 261.865 66.2209 263.297C66.2209 263.297 66.2209 263.297 66.2209 263.506H65.3129C65.3129 261.935 65.3129 260.014 65.3129 258.163C65.3727 256.115 65.571 254.073 65.9066 252.051C66.062 251.223 66.272 250.407 66.5352 249.606C67.109 247.727 68.073 245.989 69.3641 244.508L70.5166 243.215C71.5082 242.201 72.3122 241.018 72.8914 239.723C74.1997 235.822 75.1009 231.796 75.5805 227.709V227.5L76.5235 227.779Z"
          fill="#6D7F87"
        />
      </g>
      <mask
        id="mask130_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask130_31_1526)">
        <path
          d="M76.5235 227.884C76.0968 231.42 75.4199 234.921 74.4979 238.361C74.2918 239.038 74.0469 239.703 73.7645 240.352C73.1788 241.723 72.3506 242.977 71.3198 244.054L70.0626 245.485C68.9094 246.82 68.0417 248.377 67.5131 250.061C67.2303 250.929 67.0086 251.816 66.8496 252.715C66.5248 254.702 66.3381 256.709 66.2908 258.722C66.2908 260.433 66.2908 262.214 66.2908 263.646C66.2908 263.646 66.2908 263.646 66.2908 263.89H65.4177C65.4177 262.319 65.4177 260.398 65.4177 258.512C65.4774 256.464 65.6758 254.422 66.0114 252.4C66.1668 251.573 66.3768 250.756 66.64 249.956C67.2138 248.076 68.1777 246.339 69.4688 244.857L70.6213 243.565C71.613 242.55 72.417 241.367 72.9962 240.072C74.2971 236.157 75.1981 232.12 75.6853 228.023C75.6698 227.991 75.6617 227.955 75.6617 227.919C75.6617 227.882 75.6698 227.847 75.6853 227.814H76.3489L76.5235 227.884Z"
          fill="#6A7C85"
        />
      </g>
      <mask
        id="mask131_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask131_31_1526)">
        <path
          d="M76.4886 227.989C76.0716 231.526 75.3946 235.028 74.463 238.466C74.2566 239.154 74.0117 239.83 73.7296 240.491C73.1551 241.86 72.3388 243.114 71.3198 244.193L70.0276 245.625C68.897 246.976 68.032 248.528 67.4782 250.2C67.1989 251.072 66.9658 251.958 66.7797 252.854C66.4707 254.855 66.2841 256.873 66.2209 258.896C66.2209 260.608 66.2209 262.389 66.2209 263.855C66.2209 263.855 66.2209 263.855 66.2209 264.1H65.3478C65.3478 262.528 65.3478 260.608 65.3478 258.722C65.406 256.662 65.6044 254.608 65.9415 252.575C65.9415 251.667 66.3257 250.829 66.5352 250.13C67.1045 248.238 68.0687 246.489 69.3641 244.997L70.5166 243.704C71.5082 242.69 72.3122 241.507 72.8914 240.212C74.1863 236.285 75.0757 232.236 75.5456 228.128C75.5301 228.096 75.522 228.06 75.522 228.024C75.522 227.987 75.5301 227.952 75.5456 227.919H76.3139L76.4886 227.989Z"
          fill="#687A83"
        />
      </g>
      <mask
        id="mask132_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask132_31_1526)">
        <path
          d="M76.4886 228.093C76.0623 231.627 75.3972 235.127 74.4979 238.571C74.3072 239.264 74.0619 239.941 73.7645 240.596C73.1944 241.978 72.3778 243.244 71.3547 244.333L70.0975 245.765C68.9318 247.097 68.0521 248.654 67.5131 250.34C67.2303 251.208 67.0086 252.095 66.8496 252.994C66.5406 254.995 66.354 257.013 66.2908 259.036C66.2908 260.747 66.2908 262.528 66.2908 263.995C66.2908 263.995 66.2908 263.995 66.2908 264.24H65.4177C65.4177 262.668 65.4177 260.747 65.4177 258.861C65.4758 256.801 65.6742 254.748 66.0114 252.715C66.167 251.875 66.377 251.047 66.64 250.235C67.2093 248.343 68.1734 246.593 69.4688 245.101L70.6213 243.809C71.6172 242.805 72.4115 241.62 72.9612 240.317C74.236 236.373 75.1249 232.314 75.6155 228.198C75.5999 228.165 75.5919 228.13 75.5919 228.093C75.5919 228.057 75.5999 228.021 75.6155 227.989H76.3139L76.4886 228.093Z"
          fill="#667880"
        />
      </g>
      <mask
        id="mask133_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask133_31_1526)">
        <path
          d="M76.4536 228.198C76.0005 231.727 75.3357 235.226 74.463 238.675C74.2566 239.364 74.0117 240.04 73.7296 240.701C73.168 242.087 72.3505 243.354 71.3198 244.438L70.0276 245.87C68.8553 247.21 67.9751 248.78 67.4433 250.48C67.1557 251.382 66.9339 252.304 66.7797 253.239C66.4692 255.251 66.2826 257.28 66.2209 259.315C66.2209 261.027 66.2209 262.808 66.2209 264.275C66.2209 264.275 66.2209 264.275 66.2209 264.519H65.3478C65.3478 262.947 65.3478 261.027 65.3478 259.106C65.4057 257.034 65.6041 254.969 65.9415 252.924C65.9415 252.016 66.3257 251.178 66.5352 250.445C67.1149 248.55 68.0911 246.8 69.399 245.311L70.5515 244.019C71.5473 243.015 72.3416 241.829 72.8914 240.526C74.1513 236.568 75.0284 232.498 75.5107 228.373C75.4812 228.294 75.4812 228.207 75.5107 228.128L76.4536 228.198Z"
          fill="#63757E"
        />
      </g>
      <mask
        id="mask134_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask134_31_1526)">
        <path
          d="M76.4536 228.303C76.0075 231.833 75.3427 235.332 74.463 238.78C74.273 239.469 74.0397 240.146 73.7645 240.806C73.2031 242.202 72.3859 243.481 71.3547 244.577L70.0626 246.254C68.8985 247.574 68.0188 249.119 67.4782 250.794C67.1954 251.662 66.9737 252.549 66.8146 253.448C66.5059 255.461 66.3193 257.49 66.2558 259.525C66.2558 261.271 66.2558 263.017 66.2558 264.519C66.2558 264.519 66.2558 264.694 66.2558 264.764H65.3828C65.3828 263.192 65.3828 261.271 65.3828 259.35C65.4553 257.301 65.6653 255.259 66.0114 253.239C66.186 252.331 66.3955 251.492 66.6051 250.759C67.1802 248.852 68.1566 247.089 69.4689 245.59L70.6213 244.298C71.6206 243.297 72.4154 242.111 72.9612 240.806C74.1975 236.829 75.0742 232.75 75.5805 228.617C75.562 228.579 75.5524 228.537 75.5524 228.495C75.5524 228.453 75.562 228.411 75.5805 228.373L76.4536 228.303Z"
          fill="#61737C"
        />
      </g>
      <mask
        id="mask135_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask135_31_1526)">
        <path
          d="M76.4187 228.408C75.982 232.064 75.329 235.69 74.463 239.269C74.2673 239.968 74.0341 240.656 73.7645 241.33C73.2031 242.726 72.3859 244.005 71.3547 245.101L70.0626 246.254C68.8771 247.585 67.9952 249.158 67.4782 250.864C67.1957 251.744 66.974 252.642 66.8146 253.553C66.5007 255.576 66.3257 257.618 66.2908 259.665C66.2908 261.411 66.2908 263.157 66.2908 264.659C66.2908 264.659 66.2908 264.833 66.2908 264.903H65.4177C65.4177 263.332 65.4177 261.411 65.4177 259.455C65.4852 257.374 65.6718 255.298 65.9765 253.239C65.9765 252.296 66.3606 251.492 66.5702 250.759C67.1453 248.852 68.1217 247.089 69.4339 245.59L70.5864 244.298C71.5857 243.297 72.3804 242.111 72.9263 240.806C74.1643 236.808 75.0295 232.704 75.5107 228.547C75.4922 228.509 75.4825 228.468 75.4825 228.425C75.4825 228.383 75.4922 228.341 75.5107 228.303L76.4187 228.408Z"
          fill="#5E7179"
        />
      </g>
      <mask
        id="mask136_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask136_31_1526)">
        <path
          d="M76.4187 228.547C75.9819 232.077 75.3287 235.576 74.463 239.025C74.2727 239.725 74.0394 240.413 73.7645 241.085C73.2115 242.486 72.3932 243.766 71.3547 244.857C70.9357 245.346 70.4816 245.8 70.0626 246.324C68.8777 247.661 67.9855 249.231 67.4433 250.934C67.1645 251.803 66.9428 252.69 66.7797 253.588C66.4658 255.611 66.2908 257.653 66.2558 259.7C66.2558 261.446 66.2558 263.192 66.2558 264.694C66.2558 264.694 66.2558 264.903 66.2558 264.938H65.4177C65.4177 263.402 65.4177 261.446 65.4177 259.525C65.4492 257.442 65.6359 255.364 65.9765 253.308C65.9765 252.366 66.3606 251.562 66.5702 250.829C67.1453 248.921 68.1217 247.159 69.4339 245.66L70.6213 244.333C71.6206 243.332 72.4154 242.146 72.9612 240.841C74.1881 236.914 75.0417 232.879 75.5107 228.792C75.5107 228.582 75.5107 228.547 75.5107 228.547H76.4187Z"
          fill="#5C6E77"
        />
      </g>
      <mask
        id="mask137_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask137_31_1526)">
        <path
          d="M76.3838 228.792C75.9522 232.319 75.3107 235.818 74.463 239.269C74.2727 239.97 74.0394 240.658 73.7645 241.33C73.2204 242.735 72.4011 244.017 71.3547 245.101C70.9357 245.59 70.4816 246.044 70.0626 246.568C68.8777 247.919 67.9858 249.5 67.4433 251.213C67.1608 252.093 66.9391 252.992 66.7797 253.902C66.4561 255.994 66.281 258.107 66.2558 260.223C66.2558 261.97 66.2558 263.716 66.2558 265.252C66.2558 265.252 66.2558 265.427 66.2558 265.532H65.3828C65.3828 263.96 65.3828 262.039 65.3828 260.084C65.4142 258.001 65.601 255.923 65.9415 253.867C65.9415 252.924 66.3257 252.121 66.5352 251.353C67.1298 249.475 68.1046 247.739 69.399 246.254L70.5864 244.927C71.5758 243.917 72.3692 242.733 72.9263 241.434C74.1579 237.306 75.0112 233.075 75.4758 228.792C75.4572 228.754 75.4476 228.712 75.4476 228.67C75.4476 228.627 75.4572 228.586 75.4758 228.547L76.3838 228.792Z"
          fill="#596C74"
        />
      </g>
      <mask
        id="mask138_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask138_31_1526)">
        <path
          d="M76.3838 228.792C75.9567 232.412 75.3153 236.004 74.463 239.548C74.2727 240.249 74.0394 240.937 73.7645 241.609C73.2203 243.024 72.4013 244.318 71.3547 245.416C70.9357 245.905 70.4816 246.324 70.0626 246.848C68.8657 248.203 67.9726 249.798 67.4433 251.527C67.1645 252.397 66.9428 253.283 66.7797 254.182C66.4706 256.182 66.2956 258.2 66.2558 260.223C66.2558 261.97 66.2558 263.716 66.2558 265.287C66.2558 265.287 66.2558 265.462 66.2558 265.567H65.3828C65.3828 263.995 65.3828 262.074 65.3828 260.084C65.4156 257.989 65.6023 255.9 65.9415 253.832C65.9415 252.889 66.3257 252.086 66.5352 251.318C67.116 249.437 68.1059 247.707 69.4339 246.254L70.6213 244.927C71.6107 243.917 72.4041 242.733 72.9612 241.434C74.1726 237.303 75.0141 233.072 75.4758 228.792C75.4572 228.754 75.4476 228.712 75.4476 228.67C75.4476 228.627 75.4572 228.586 75.4758 228.547L76.3838 228.792Z"
          fill="#576972"
        />
      </g>
      <mask
        id="mask139_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask139_31_1526)">
        <path
          d="M76.3489 228.792C75.9135 232.422 75.2722 236.025 74.4281 239.583C74.2324 240.282 73.9992 240.97 73.7296 241.644C73.2164 243.085 72.3939 244.396 71.3198 245.485C70.9007 245.974 70.4467 246.428 70.0276 246.952C68.8377 248.299 67.9452 249.882 67.4083 251.597C67.1266 252.489 66.9049 253.399 66.7448 254.321C66.431 256.356 66.256 258.409 66.2209 260.468C66.2209 262.284 66.2209 263.96 66.2209 265.532C66.2209 265.532 66.2209 265.706 66.2209 265.811H65.3828C65.3828 264.275 65.3828 262.319 65.3828 260.328C65.4125 258.233 65.5993 256.144 65.9415 254.077C65.9415 253.134 66.3257 252.296 66.5352 251.562C67.0969 249.631 68.0879 247.852 69.4339 246.359L70.6213 245.031C71.6139 244.025 72.4077 242.84 72.9612 241.539C74.1534 237.486 74.9947 233.338 75.4758 229.141C75.4758 228.931 75.4758 228.897 75.4758 228.897H76.2092L76.3489 228.792Z"
          fill="#54676F"
        />
      </g>
      <mask
        id="mask140_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask140_31_1526)">
        <path
          d="M76.3489 228.966C75.9242 232.608 75.2946 236.222 74.463 239.793C74.2534 240.561 74.009 241.26 73.7994 241.888C73.2817 243.317 72.4595 244.616 71.3897 245.695C70.9706 246.184 70.5166 246.638 70.0975 247.162C68.9006 248.517 68.0076 250.113 67.4782 251.842C67.1919 252.733 66.9701 253.643 66.8146 254.566C66.5028 256.612 66.3278 258.677 66.2908 260.747C66.2908 262.528 66.2908 264.24 66.2908 265.811C66.2908 265.811 66.2908 265.811 66.2908 266.091H65.4526C65.4526 264.554 65.4526 262.598 65.4526 260.608C65.4917 258.503 65.6667 256.403 65.9765 254.321C65.9765 253.378 66.3606 252.54 66.5702 251.807C67.1402 249.869 68.1298 248.08 69.4689 246.568L70.6563 245.241C71.6488 244.234 72.4427 243.049 72.9962 241.749C74.1674 237.681 74.9968 233.522 75.4758 229.316C75.4535 229.224 75.4535 229.128 75.4758 229.036L76.3489 228.966Z"
          fill="#52646D"
        />
      </g>
      <mask
        id="mask141_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask141_31_1526)">
        <path
          d="M76.3139 229.071C75.9018 232.726 75.2721 236.353 74.428 239.933C74.2185 240.701 73.974 241.399 73.7645 242.028C73.2276 243.46 72.4215 244.776 71.3897 245.905C70.9706 246.394 70.5166 246.813 70.0975 247.371C68.9009 248.719 67.9971 250.301 67.4433 252.016C67.1692 252.911 66.9476 253.82 66.7797 254.74C66.4678 256.787 66.2928 258.852 66.2558 260.922C66.2558 262.703 66.2558 264.414 66.2558 265.986C66.2558 265.986 66.2558 266.16 66.2558 266.265H65.4177C65.4177 264.729 65.4177 262.773 65.4177 260.747C65.4552 258.643 65.6302 256.543 65.9415 254.461C65.9415 253.518 66.3257 252.68 66.5352 251.946C67.0977 250.006 68.0882 248.215 69.4339 246.708L70.6213 245.381C71.6534 244.325 72.4508 243.064 72.9612 241.679C74.132 237.601 74.9499 233.429 75.4059 229.211C75.3708 229.121 75.3708 229.021 75.4059 228.932L76.3139 229.071Z"
          fill="#4F626B"
        />
      </g>
      <mask
        id="mask142_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask142_31_1526)">
        <path
          d="M76.3139 229.211C75.8896 232.873 75.2718 236.51 74.463 240.107C74.278 240.817 74.0565 241.516 73.7994 242.203C73.3008 243.705 72.4916 245.085 71.4246 246.254L70.0975 247.721C68.9082 249.074 68.0053 250.654 67.4433 252.366C67.1692 253.26 66.9476 254.169 66.7797 255.09C66.4626 257.147 66.2992 259.225 66.2908 261.306C66.2908 263.087 66.2908 264.798 66.2908 266.37C66.2908 266.37 66.2908 266.58 66.2908 266.649H65.4526C65.4526 265.113 65.4526 263.157 65.4526 261.131C65.4934 259.015 65.6684 256.904 65.9765 254.81C65.9765 253.902 66.3606 253.029 66.5702 252.261C67.1464 250.326 68.1354 248.538 69.4689 247.022L70.6563 245.695C71.6659 244.709 72.452 243.518 72.9612 242.203C74.1123 238.096 74.9299 233.903 75.4059 229.665C75.3903 229.572 75.3903 229.478 75.4059 229.386L76.3139 229.211Z"
          fill="#4D6068"
        />
      </g>
      <mask
        id="mask143_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask143_31_1526)">
        <path
          d="M76.279 229.316C75.8519 232.978 75.2341 236.615 74.428 240.212C74.2428 240.933 74.0213 241.644 73.7645 242.342C73.2568 243.799 72.4475 245.132 71.3897 246.254L70.0626 247.721C68.8461 249.081 67.9404 250.69 67.4083 252.435C67.1266 253.328 66.9049 254.238 66.7448 255.159C66.4438 257.218 66.2804 259.295 66.2558 261.376C66.2558 263.157 66.2558 264.868 66.2558 266.44C66.2558 266.44 66.2558 266.649 66.2558 266.754H65.4526C65.4526 265.218 65.4526 263.262 65.4526 261.201C65.4743 259.084 65.6494 256.972 65.9765 254.88C65.9765 253.937 66.3606 253.099 66.5702 252.331C67.1436 250.376 68.1458 248.575 69.5038 247.057L70.6912 245.73C71.7228 244.681 72.5099 243.417 72.9962 242.028C74.1468 237.923 74.9529 233.729 75.4059 229.49C75.3903 229.398 75.3903 229.303 75.4059 229.211L76.279 229.316Z"
          fill="#4B5D66"
        />
      </g>
      <mask
        id="mask144_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask144_31_1526)">
        <path
          d="M76.279 229.42C75.8654 233.082 75.2592 236.719 74.463 240.317C74.2777 241.038 74.0563 241.749 73.7994 242.447C73.2546 243.854 72.4489 245.146 71.4246 246.254C71.0055 246.743 70.5515 247.232 70.0975 247.686C68.8891 249.052 67.9844 250.659 67.4433 252.4C67.1653 253.305 66.9437 254.227 66.7797 255.159C66.4816 257.219 66.3183 259.295 66.2908 261.376C66.2908 263.192 66.2908 264.868 66.2908 266.475C66.2908 266.475 66.2908 266.684 66.2908 266.754H65.5224C65.5224 265.183 65.5224 263.262 65.5224 261.201C65.5443 259.073 65.7194 256.948 66.0463 254.845C66.0463 253.902 66.4305 253.064 66.64 252.296C67.2054 250.328 68.2082 248.513 69.5736 246.987C69.9927 246.568 70.3769 246.079 70.761 245.695C71.7847 244.626 72.5702 243.353 73.066 241.958C74.1907 237.835 74.9964 233.632 75.4758 229.386C75.4601 229.293 75.4601 229.199 75.4758 229.106L76.279 229.42Z"
          fill="#485B63"
        />
      </g>
      <mask
        id="mask145_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask145_31_1526)">
        <path
          d="M76.2441 229.525C76.2441 230.713 75.4408 236.51 74.463 240.491C74.2534 241.26 74.009 241.993 73.8343 242.622C73.3228 244.076 72.5141 245.408 71.4595 246.533L70.1324 248C68.916 249.36 68.0103 250.969 67.4782 252.715C67.2337 253.518 66.9892 254.426 66.7797 255.474C66.4766 257.544 66.3248 259.633 66.3257 261.725C66.3257 263.541 66.3257 265.218 66.3257 266.824C66.3257 266.824 66.3257 267.034 66.3257 267.138H65.5224C65.5224 265.602 65.5224 263.646 65.5224 261.585C65.5093 259.455 65.6846 257.328 66.0463 255.229C66.2209 254.286 66.4305 253.448 66.64 252.68C67.2117 250.732 68.2008 248.933 69.5387 247.406C69.9927 246.952 70.3769 246.498 70.7261 246.079C71.7575 245.016 72.5442 243.741 73.0311 242.342C74.159 238.21 74.9532 233.994 75.4059 229.735V229.455H76.1742L76.2441 229.525Z"
          fill="#465961"
        />
      </g>
      <mask
        id="mask146_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask146_31_1526)">
        <path
          d="M76.2441 229.63C76.2441 230.782 75.4408 236.615 74.463 240.631C74.2534 241.434 74.009 242.133 73.8343 242.761C73.3226 244.226 72.5141 245.57 71.4595 246.708L70.1324 248.175C68.916 249.535 68.0103 251.144 67.4782 252.889C67.2337 253.693 66.9893 254.601 66.7797 255.648C66.4766 257.718 66.3249 259.808 66.3257 261.9C66.3257 263.716 66.3257 265.567 66.3257 267.033C66.3257 267.033 66.3257 267.243 66.3257 267.348H65.5224C65.5224 265.811 65.5224 263.855 65.5224 261.76C65.517 259.632 65.6805 257.506 66.0114 255.404C66.0114 254.461 66.3955 253.588 66.5702 252.854C67.1475 250.891 68.1489 249.079 69.5038 247.546L70.6563 246.254C71.6957 245.184 72.4832 243.895 72.9612 242.482C74.0664 238.333 74.8602 234.107 75.3361 229.84C75.3108 229.748 75.3108 229.652 75.3361 229.56L76.2441 229.63Z"
          fill="#44565F"
        />
      </g>
      <mask
        id="mask147_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask147_31_1526)">
        <path
          d="M76.2092 229.735C76.2092 230.817 75.4059 236.72 74.4281 240.771C74.4281 241.574 74.009 242.272 73.7994 242.936C73.3103 244.411 72.4991 245.759 71.4246 246.882L70.0975 248.349C68.8575 249.765 67.94 251.433 67.4083 253.239C67.1988 254.042 66.9543 254.95 66.7448 255.998C66.4456 258.08 66.2822 260.18 66.2559 262.284C66.2559 264.1 66.2559 265.951 66.2559 267.418C66.2559 267.418 66.2559 267.627 66.2559 267.732H65.4875C65.4875 266.195 65.4875 264.24 65.4875 262.144C65.5159 260.006 65.6792 257.871 65.9765 255.753C65.9765 254.81 66.3606 253.937 66.5702 253.204C67.1371 251.244 68.1266 249.432 69.4689 247.895L70.6912 246.568C71.7107 245.476 72.4847 244.178 72.9612 242.761C74.0447 238.58 74.7806 234.317 75.1615 230.014V229.7H76.2092V229.735Z"
          fill="#41545C"
        />
      </g>
      <mask
        id="mask148_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask148_31_1526)">
        <path
          d="M76.2092 229.84C75.8037 233.558 75.2093 237.253 74.428 240.91C74.2582 241.643 74.0484 242.366 73.7994 243.076C73.3103 244.551 72.4991 245.899 71.4246 247.022L70.0975 248.524C68.8667 249.88 67.9487 251.489 67.4083 253.239C67.1988 254.042 66.9543 254.95 66.7448 255.998C66.4381 258.078 66.2979 260.181 66.3257 262.284C66.3257 264.135 66.3257 265.986 66.3257 267.418C66.3257 267.418 66.3257 267.627 66.3257 267.732H65.5224C65.5224 266.195 65.5224 264.24 65.5224 262.144C65.5509 260.006 65.7142 257.871 66.0114 255.753C66.0114 254.81 66.3955 253.937 66.6051 253.169C67.1581 251.188 68.1758 249.368 69.5736 247.86C69.9927 247.371 70.3769 246.952 70.796 246.533C71.7987 245.448 72.5604 244.162 73.0311 242.761C74.1236 238.589 74.8942 234.339 75.3361 230.049C75.3171 229.945 75.3171 229.839 75.3361 229.735H76.2092V229.84Z"
          fill="#3F525A"
        />
      </g>
      <mask
        id="mask149_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask149_31_1526)">
        <path
          d="M76.1743 229.979C76.1743 230.992 75.4059 236.964 74.4281 241.085C74.2583 241.818 74.0484 242.541 73.7994 243.25C73.3253 244.735 72.5259 246.095 71.4595 247.232C71.0055 247.721 70.5515 248.21 70.1324 248.733C68.9097 250.103 68.0035 251.724 67.4782 253.483C67.196 254.401 66.9629 255.334 66.7797 256.277C66.4719 258.37 66.3317 260.483 66.3606 262.598C66.3606 264.449 66.3606 266.3 66.3606 267.767C66.3606 267.767 66.3606 267.977 66.3606 268.081H65.5923C65.5923 266.545 65.5923 264.589 65.5923 262.459C65.6029 260.308 65.7662 258.16 66.0812 256.033C66.2559 255.055 66.4654 254.216 66.6749 253.448C67.2376 251.461 68.2538 249.632 69.6435 248.105L70.8309 246.778C71.8755 245.692 72.6736 244.393 73.1708 242.971C74.2407 238.782 75.011 234.522 75.4758 230.224C75.4568 230.12 75.4568 230.013 75.4758 229.909H76.1393L76.1743 229.979Z"
          fill="#3D4F57"
        />
      </g>
      <mask
        id="mask150_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask150_31_1526)">
        <path
          d="M76.1742 230.084C76.1742 231.027 75.4059 237.069 74.4281 241.19C74.269 241.922 74.0708 242.644 73.8343 243.355C73.4117 244.824 72.6726 246.183 71.6691 247.336C71.25 247.825 70.761 248.314 70.3769 248.838C69.117 250.2 68.1957 251.839 67.6877 253.623C67.4021 254.538 67.1803 255.471 67.0242 256.417C66.6864 258.506 66.5345 260.622 66.5702 262.738C66.5702 264.589 66.5702 266.44 66.5702 267.907C66.5702 267.907 66.5702 268.116 66.5702 268.221H65.6272C65.6272 266.684 65.6272 264.729 65.6272 262.598C65.6208 260.447 65.7843 258.298 66.1162 256.172C66.2471 255.3 66.4337 254.436 66.6749 253.588C67.2579 251.609 68.2716 249.785 69.6435 248.244L70.8658 246.882C71.9126 245.805 72.7007 244.503 73.1708 243.076C74.2182 238.87 74.9881 234.6 75.4758 230.294C75.4686 230.189 75.4686 230.084 75.4758 229.979L76.1742 230.084Z"
          fill="#3A4D55"
        />
      </g>
      <mask
        id="mask151_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask151_31_1526)">
        <path
          d="M76.1393 230.189C76.1393 231.097 75.4059 237.174 74.3931 241.33C74.3931 242.133 74.009 242.866 73.7994 243.53C73.3205 245.023 72.522 246.393 71.4595 247.546C71.0055 248.035 70.5515 248.524 70.1324 249.048C68.8852 250.413 67.976 252.052 67.4782 253.832C67.196 254.751 66.9629 255.683 66.7797 256.626C66.4732 258.719 66.3331 260.833 66.3606 262.947C66.3606 264.798 66.3606 266.684 66.3606 268.116C66.3606 268.116 66.3606 268.326 66.3606 268.431H65.5923C65.5923 266.929 65.5923 264.938 65.5923 262.808C65.6224 260.646 65.7857 258.488 66.0812 256.347C66.2908 255.369 66.4305 254.531 66.6749 253.762C67.2352 251.775 68.2517 249.945 69.6435 248.419L70.8658 247.057C71.9201 245.971 72.7089 244.657 73.1708 243.215C74.2192 239 74.9777 234.718 75.4408 230.398V230.084L76.1393 230.189Z"
          fill="#384A52"
        />
      </g>
      <mask
        id="mask152_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask152_31_1526)">
        <path
          d="M76.1393 230.294C76.1393 231.167 75.4059 237.278 74.4281 241.434C74.2731 242.179 74.0748 242.913 73.8343 243.634C73.4071 245.112 72.6688 246.482 71.6691 247.651C71.25 248.14 70.761 248.629 70.3769 249.152C69.0538 250.502 68.0616 252.14 67.4782 253.937C67.2337 254.775 66.9893 255.683 66.7797 256.766C66.4708 258.87 66.3306 260.996 66.3606 263.122C66.3606 265.008 66.3606 266.859 66.3606 268.326C66.3606 268.326 66.3606 268.57 66.3606 268.64H65.5923C65.5923 267.138 65.5923 265.148 65.5923 262.947C65.6155 260.87 65.7437 258.795 65.9765 256.731C65.9765 255.788 66.3606 254.95 66.5702 254.182C67.1395 252.187 68.1545 250.348 69.5387 248.803L70.761 247.441C71.8017 246.351 72.5783 245.037 73.0311 243.6C74.0538 239.314 74.7658 234.961 75.1615 230.573C75.1424 230.469 75.1424 230.363 75.1615 230.259H75.9298L76.1393 230.294Z"
          fill="#354850"
        />
      </g>
      <mask
        id="mask153_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask153_31_1526)">
        <path
          d="M76.1044 230.398C76.1044 231.202 75.371 237.383 74.3931 241.609C74.3931 242.412 74.009 243.146 73.8343 243.809C73.4067 245.297 72.6687 246.678 71.6691 247.86L70.307 249.362C69.0595 250.738 68.1295 252.371 67.583 254.147C67.3013 255.063 67.0796 255.996 66.9194 256.941C66.6168 259.046 66.4651 261.17 66.4654 263.297C66.4654 265.183 66.4654 267.068 66.4654 268.5C66.4654 268.5 66.4654 268.745 66.4654 268.85H65.5224C65.5224 267.348 65.5224 265.357 65.5224 263.192C65.5114 261.033 65.628 258.876 65.8717 256.731C66.0812 255.753 66.2209 254.88 66.4654 254.112C67.0347 252.117 68.0498 250.278 69.4339 248.733L70.6563 247.371C71.7041 246.287 72.4817 244.971 72.9263 243.53C73.9565 239.288 74.7032 234.983 75.1614 230.643C75.1424 230.539 75.1424 230.432 75.1614 230.328L76.1044 230.398Z"
          fill="#33454D"
        />
      </g>
      <mask
        id="mask154_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask154_31_1526)">
        <path
          d="M76.1044 230.503C76.1044 231.271 75.371 237.488 74.428 241.749C74.2687 242.492 74.0705 243.226 73.8343 243.949C73.4278 245.445 72.6875 246.83 71.6691 248C71.25 248.524 70.761 248.978 70.307 249.502C69.0531 250.887 68.1227 252.533 67.583 254.321C67.3734 255.124 67.1289 256.067 66.9194 257.15C66.5627 259.321 66.3642 261.516 66.3257 263.716C66.3257 265.602 66.3257 267.488 66.3257 268.919C66.3257 268.919 66.3257 269.164 66.3257 269.269H65.5574C65.5574 267.767 65.5574 265.776 65.5574 263.576C65.5577 261.403 65.7094 259.232 66.0114 257.08C66.1531 256.195 66.3514 255.32 66.6051 254.461C67.1716 252.447 68.2 250.594 69.6085 249.048L70.8309 247.686C71.8866 246.594 72.6651 245.264 73.1009 243.809C74.0925 239.497 74.781 235.121 75.1614 230.713V230.363L76.1044 230.503Z"
          fill="#31434B"
        />
      </g>
      <mask
        id="mask155_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask155_31_1526)">
        <path
          d="M76.0695 230.608C76.0695 231.341 75.371 237.593 74.3931 241.888C74.3931 242.692 74.009 243.46 73.7994 244.123C73.3562 245.642 72.5536 247.032 71.4595 248.175L70.0975 249.746C68.8308 251.122 67.8986 252.771 67.3734 254.566C67.088 255.492 66.8663 256.438 66.7099 257.395C66.4231 259.489 66.2831 261.602 66.2908 263.716C66.2908 265.602 66.2908 267.488 66.2908 268.954C66.2908 268.954 66.2908 269.199 66.2908 269.304H65.5574C65.5574 267.802 65.5574 265.811 65.5574 263.611C65.5577 261.438 65.7094 259.267 66.0114 257.115C66.1531 256.23 66.3514 255.355 66.6051 254.496C67.163 252.479 68.1925 250.624 69.6085 249.083L70.8309 247.721C71.8866 246.629 72.6651 245.299 73.1009 243.844C74.0811 239.577 74.7696 235.248 75.1614 230.887V230.538L76.0695 230.608Z"
          fill="#2E4048"
        />
      </g>
      <mask
        id="mask156_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask156_31_1526)">
        <path
          d="M76.0695 230.748C76.0695 231.411 75.371 237.732 74.3931 242.063C74.3931 242.866 74.009 243.635 73.8343 244.298C73.4496 245.814 72.7071 247.215 71.6691 248.384L70.1324 249.746C68.8732 251.12 67.9313 252.753 67.3734 254.531C67.0919 255.459 66.8703 256.403 66.7099 257.36C66.4182 259.489 66.2782 261.636 66.2908 263.786C66.2908 265.706 66.2908 267.592 66.2908 269.024C66.2908 269.024 66.2908 269.269 66.2908 269.373H65.5574C65.5574 267.872 65.5574 265.881 65.5574 263.681C65.5592 261.496 65.7109 259.314 66.0114 257.15C66.1531 256.265 66.3514 255.39 66.6051 254.531C67.163 252.514 68.1925 250.658 69.6085 249.118L70.8309 247.756C71.8937 246.655 72.6727 245.313 73.1009 243.844C74.0561 239.607 74.7443 235.315 75.1614 230.992V230.643L76.0695 230.748Z"
          fill="#2C3E45"
        />
      </g>
      <mask
        id="mask157_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask157_31_1526)">
        <path
          d="M76.0346 230.852C76.0346 231.481 75.3361 237.837 74.3931 242.168C74.3931 242.971 74.009 243.704 73.8343 244.403C73.4496 245.918 72.7071 247.32 71.6691 248.489L70.307 249.991C69.0406 251.372 68.0981 253.019 67.548 254.81C67.2666 255.738 67.0449 256.683 66.8845 257.639C66.5947 259.769 66.4547 261.916 66.4654 264.065C66.4654 265.986 66.4654 267.872 66.4654 269.304C66.4654 269.304 66.4654 269.548 66.4654 269.653H65.5923C65.5923 268.151 65.5923 266.16 65.5923 263.925C65.5832 261.741 65.7232 259.559 66.0114 257.395C66.1531 256.51 66.3514 255.635 66.6051 254.775C67.1725 252.752 68.2005 250.887 69.6085 249.327L70.8309 247.965C71.8937 246.865 72.6728 245.522 73.1009 244.054C74.0756 239.762 74.764 235.41 75.1615 231.027C75.1525 230.911 75.1525 230.794 75.1615 230.678L76.0346 230.852Z"
          fill="#293B43"
        />
      </g>
      <mask
        id="mask158_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask158_31_1526)">
        <path
          d="M76.0345 230.957C76.0345 231.551 75.3361 237.942 74.3931 242.307C74.3931 243.146 74.0439 243.879 73.8343 244.543C73.4307 246.061 72.6907 247.47 71.6691 248.664L70.307 250.165C69.0332 251.555 68.09 253.214 67.548 255.02C67.2626 255.946 67.0409 256.892 66.8845 257.849C66.5945 259.966 66.4545 262.102 66.4654 264.24C66.4654 266.16 66.4654 268.081 66.4654 269.513C66.4476 269.629 66.4476 269.747 66.4654 269.862H65.6621C65.6621 268.361 65.6621 266.37 65.6621 264.17C65.6532 261.974 65.7932 259.781 66.0812 257.604C66.227 256.709 66.4253 255.822 66.6749 254.95C67.2538 252.931 68.2804 251.069 69.6784 249.502L70.9007 248.14C71.9635 247.039 72.7426 245.697 73.1708 244.228C74.0996 239.919 74.7644 235.557 75.1614 231.167C75.1525 231.05 75.1525 230.934 75.1614 230.817L76.0345 230.957Z"
          fill="#263940"
        />
      </g>
      <mask
        id="mask159_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask159_31_1526)">
        <path
          d="M75.9996 231.062C75.9996 231.586 75.3361 238.047 74.3931 242.447C74.2563 243.215 74.0696 243.973 73.8343 244.717C73.4308 246.236 72.6907 247.644 71.6691 248.838L70.307 250.34C69.0409 251.735 68.0987 253.393 67.548 255.194C67.2591 256.132 67.0373 257.089 66.8845 258.058C66.5948 260.199 66.4548 262.358 66.4654 264.519C66.4654 266.44 66.4654 268.361 66.4654 269.793C66.4481 269.92 66.4481 270.049 66.4654 270.177H65.6621C65.6621 268.675 65.6621 266.684 65.6621 264.449C65.6543 262.254 65.7943 260.06 66.0812 257.883C66.227 256.988 66.4253 256.102 66.6749 255.229C67.1895 253.196 68.1834 251.316 69.5736 249.746L70.8309 248.384C71.894 247.27 72.6728 245.917 73.1009 244.438C74.0664 240.132 74.7546 235.77 75.1615 231.376C75.1525 231.26 75.1525 231.143 75.1615 231.027H75.8949L75.9996 231.062Z"
          fill="#24363D"
        />
      </g>
      <mask
        id="mask160_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask160_31_1526)">
        <path
          d="M75.9996 231.167C75.9996 231.656 75.3361 238.151 74.3931 242.552C74.2604 243.321 74.0737 244.079 73.8343 244.822C73.45 246.369 72.7084 247.804 71.6691 249.013L70.307 250.549C69.0282 251.935 68.0843 253.596 67.548 255.404C67.2591 256.341 67.0373 257.298 66.8845 258.268C66.6135 260.411 66.4736 262.568 66.4654 264.729C66.4654 266.649 66.4654 268.57 66.4654 270.002C66.4481 270.13 66.4481 270.259 66.4654 270.386H65.6621C65.6621 268.884 65.6621 266.894 65.6621 264.624C65.6546 262.417 65.7946 260.212 66.0812 258.023C66.227 257.128 66.4253 256.241 66.6749 255.369C67.2452 253.329 68.2859 251.451 69.7133 249.886L70.9706 248.524C72.0337 247.41 72.8125 246.056 73.2406 244.577C74.1557 240.245 74.7972 235.859 75.1615 231.446C75.1525 231.33 75.1525 231.213 75.1615 231.097L75.9996 231.167Z"
          fill="#21333B"
        />
      </g>
      <mask
        id="mask161_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask161_31_1526)">
        <path
          d="M75.9647 231.271C75.9647 231.69 75.3011 238.256 74.3931 242.726C74.3931 243.565 74.0788 244.333 73.8693 244.996C73.4758 246.537 72.7216 247.961 71.6691 249.152L70.307 250.689C69.0087 252.074 68.0624 253.751 67.548 255.578C67.2669 256.518 67.0452 257.475 66.8845 258.442C66.6087 260.596 66.4804 262.767 66.5003 264.938C66.5003 266.894 66.5003 268.815 66.5003 270.246V270.7H65.732C65.732 269.234 65.732 267.208 65.732 264.938C65.7244 262.731 65.8644 260.526 66.1511 258.337C66.2931 257.441 66.4914 256.555 66.7448 255.683C67.3065 253.64 68.3482 251.76 69.7832 250.2L71.0404 248.838C72.1107 247.716 72.8901 246.349 73.3105 244.857C74.1879 240.485 74.806 236.065 75.1614 231.621C75.1614 231.376 75.1614 231.236 75.1614 231.236H75.825L75.9647 231.271Z"
          fill="#1F3138"
        />
      </g>
      <mask
        id="mask162_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask162_31_1526)">
        <path
          d="M75.9647 231.376C75.9647 231.76 75.3012 238.361 74.3931 242.866C74.3931 243.704 74.0788 244.473 73.8693 245.136C73.4835 246.679 72.7284 248.106 71.6691 249.292L70.2721 250.829C68.9811 252.225 68.0256 253.897 67.4782 255.718C67.197 256.658 66.9754 257.614 66.8146 258.582C66.5389 260.736 66.4105 262.906 66.4305 265.078C66.4305 267.034 66.4305 268.954 66.4305 270.386V270.701H65.6621C65.6621 269.234 65.6621 267.208 65.6621 264.903C65.6546 262.696 65.7946 260.491 66.0812 258.303C66.2193 257.406 66.4177 256.519 66.6749 255.648C67.2366 253.605 68.2783 251.725 69.7133 250.165L70.9706 248.803C72.0352 247.683 72.8035 246.314 73.2057 244.822C74.1274 240.489 74.7805 236.104 75.1615 231.691C75.1615 231.446 75.1615 231.306 75.1615 231.306L75.9647 231.376Z"
          fill="#1C2E35"
        />
      </g>
      <mask
        id="mask163_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask163_31_1526)">
        <path
          d="M75.9298 231.516C75.9298 231.865 75.3011 238.501 74.3582 243.041C74.1952 243.879 74.0206 244.647 73.8343 245.346C73.464 246.898 72.7208 248.336 71.6691 249.537L70.2721 251.073C68.9811 252.469 68.0256 254.142 67.4782 255.963C67.197 256.902 66.9754 257.859 66.8146 258.826C66.539 260.992 66.4107 263.174 66.4305 265.357C66.4305 267.313 66.4305 269.269 66.4305 270.701V271.085H65.6272C65.6272 269.618 65.4526 267.592 65.6272 265.287C65.609 263.069 65.7373 260.853 66.0114 258.652C66.1495 257.755 66.3478 256.868 66.6051 255.998C67.1718 253.938 68.2259 252.046 69.6784 250.48L70.9357 249.118C72.0066 247.988 72.7753 246.607 73.1708 245.101C74.101 240.745 74.7658 236.337 75.1614 231.9V231.481H75.9996L75.9298 231.516Z"
          fill="#192B32"
        />
      </g>
      <mask
        id="mask164_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask164_31_1526)">
        <path
          d="M75.9298 231.621C75.9298 231.9 75.3011 238.605 74.3931 243.146C74.2301 243.984 74.0555 244.752 73.8693 245.451C73.5135 247.046 72.7561 248.525 71.6691 249.746L70.2721 251.283C68.9745 252.688 68.0184 254.373 67.4782 256.207C67.1934 257.158 66.9717 258.126 66.8146 259.106C66.5565 261.273 66.4283 263.454 66.4305 265.637C66.4305 267.592 66.4305 269.548 66.4305 270.98V271.364H65.6272C65.6272 269.897 65.4526 267.872 65.6272 265.567C65.609 263.349 65.7373 261.132 66.0114 258.931C66.1536 258.023 66.3518 257.125 66.6051 256.242C67.1559 254.176 68.2121 252.28 69.6784 250.724L70.9357 249.327C72.0066 248.198 72.7753 246.816 73.1708 245.311C74.103 240.908 74.7678 236.453 75.1614 231.97C75.1614 231.725 75.1614 231.586 75.1614 231.586H75.9647L75.9298 231.621Z"
          fill="#16262D"
        />
      </g>
      <mask
        id="mask165_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask165_31_1526)">
        <path
          d="M75.8949 231.725C75.8949 231.97 75.2662 238.536 74.3582 243.285C74.1952 244.123 74.0206 244.892 73.8343 245.59C73.4614 247.131 72.7182 248.558 71.6691 249.746L70.2721 251.283C68.9745 252.688 68.0184 254.373 67.4782 256.207C67.1934 257.158 66.9717 258.126 66.8146 259.106C66.5565 261.273 66.4283 263.454 66.4305 265.637C66.4305 267.627 66.4305 269.548 66.4305 270.98V271.364H65.6272C65.6272 269.897 65.4526 267.872 65.4526 265.532C65.4166 263.302 65.5451 261.072 65.8368 258.861C65.9789 257.954 66.1772 257.056 66.4305 256.172C66.9813 254.106 68.0375 252.21 69.5038 250.654L70.761 249.257C71.832 248.128 72.6007 246.746 72.9962 245.241C73.9757 240.887 74.6987 236.479 75.1615 232.04C75.1696 231.912 75.1696 231.784 75.1615 231.656L75.8949 231.725Z"
          fill="#132127"
        />
      </g>
      <mask
        id="mask166_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask166_31_1526)">
        <path
          d="M75.8949 231.83C75.8949 232.04 75.2662 238.815 74.3931 243.425C74.3931 244.263 74.0788 245.066 73.9042 245.73C73.5083 247.297 72.7418 248.747 71.6691 249.956L70.2721 251.492C68.9745 252.897 68.0184 254.582 67.4782 256.417C67.1934 257.367 66.9717 258.336 66.8146 259.315C66.5567 261.494 66.4284 263.687 66.4305 265.881C66.4305 267.872 66.4305 269.828 66.4305 271.259V271.678H65.6272C65.6272 270.212 65.4526 268.186 65.4526 265.846C65.4166 263.616 65.5451 261.387 65.8368 259.176C66.0228 258.348 66.256 257.532 66.5352 256.731C67.1093 254.664 68.1622 252.762 69.6085 251.178L70.8658 249.781C71.9369 248.638 72.7053 247.246 73.1009 245.73C74.0341 241.289 74.722 236.801 75.1615 232.284C75.1696 232.156 75.1696 232.028 75.1615 231.9H75.9647L75.8949 231.83Z"
          fill="#0F1C20"
        />
      </g>
      <mask
        id="mask167_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask167_31_1526)">
        <path
          d="M75.8599 231.935C75.8599 231.935 75.1614 238.71 74.3582 243.565C74.2467 244.343 74.0833 245.113 73.8693 245.87C73.5123 247.455 72.7548 248.922 71.6691 250.13L70.2721 251.667C68.9314 253.111 67.9398 254.844 67.3734 256.731C67.0886 257.682 66.867 258.65 66.7099 259.63C66.4481 261.808 66.3315 264.001 66.3606 266.195C66.3606 268.186 66.3606 270.142 66.3606 271.574V271.993H65.5574C65.5574 270.526 65.3827 268.5 65.3827 266.16C65.3483 263.919 65.4767 261.678 65.7669 259.455C65.936 258.528 66.1813 257.617 66.5003 256.731C67.0802 254.656 68.132 252.744 69.5736 251.143L70.8309 249.746C71.902 248.603 72.6704 247.211 73.066 245.695C74.0063 241.266 74.7058 236.789 75.1614 232.284C75.1695 232.156 75.1695 232.028 75.1614 231.9H75.8599V231.935Z"
          fill="#0C161A"
        />
      </g>
      <mask
        id="mask168_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask168_31_1526)">
        <path
          d="M75.8599 232.04C75.8599 232.04 75.1615 238.815 74.3582 243.669C74.2429 244.459 74.0796 245.24 73.8693 246.009C73.5198 247.597 72.7613 249.066 71.6691 250.27L70.2721 251.807C68.9417 253.205 67.95 254.889 67.3734 256.731C67.0886 257.682 66.867 258.65 66.7099 259.63C66.4473 261.82 66.3306 264.025 66.3606 266.23C66.3606 268.221 66.3606 270.212 66.3606 271.609C66.342 271.759 66.342 271.912 66.3606 272.063H65.732C65.732 270.631 65.5574 268.57 65.5574 266.195C65.5205 263.965 65.6489 261.736 65.9415 259.525C66.0555 258.612 66.2542 257.712 66.5352 256.836C67.103 254.759 68.1701 252.853 69.6435 251.283L70.9007 249.886C71.9794 248.735 72.7484 247.329 73.1359 245.8C74.0687 241.337 74.745 236.824 75.1615 232.284C75.1704 232.145 75.1704 232.005 75.1615 231.865H75.8599V232.04Z"
          fill="#071013"
        />
      </g>
      <mask
        id="mask169_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask169_31_1526)">
        <path
          d="M75.825 232.284C75.825 232.284 75.1615 238.955 74.3582 243.844C74.2429 244.633 74.0796 245.415 73.8693 246.184C73.5198 247.772 72.7613 249.24 71.6691 250.445L70.2721 251.981C68.9551 253.391 67.9864 255.089 67.4433 256.94C67.155 257.902 66.9333 258.882 66.7797 259.874C66.5172 262.064 66.4005 264.269 66.4305 266.475C66.4305 268.465 66.4305 270.456 66.4305 271.888C66.4133 272.027 66.4133 272.168 66.4305 272.307H65.6272C65.6272 270.84 65.4526 268.815 65.4526 266.44C65.4261 264.188 65.5428 261.937 65.8018 259.699C65.9268 258.777 66.1254 257.866 66.3955 256.975C66.9723 254.892 68.0379 252.976 69.5038 251.388L70.761 249.991C71.8397 248.84 72.6087 247.434 72.9962 245.905C73.9693 241.479 74.6922 237.001 75.1615 232.494C75.1691 232.354 75.1691 232.214 75.1615 232.075L75.825 232.284Z"
          fill="#04080A"
        />
      </g>
      <mask
        id="mask170_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask170_31_1526)">
        <path
          d="M65.5574 266.684C65.5309 264.432 65.6475 262.181 65.9066 259.944C66.2188 256.848 67.5164 253.935 69.6085 251.632C71.2777 250.18 72.4907 248.276 73.1009 246.149C74.0399 241.568 74.7278 236.94 75.1615 232.284H75.9647C75.5724 236.972 74.9313 241.635 74.0439 246.254C73.3878 248.565 72.0634 250.63 70.2372 252.191C68.2417 254.369 67.015 257.142 66.7448 260.084C66.4823 262.285 66.3657 264.502 66.3955 266.719C66.3955 268.954 66.3955 271.12 66.5702 272.552H65.7669C65.7669 271.05 65.5574 268.85 65.5574 266.614"
          fill="black"
        />
      </g>
      <mask
        id="mask171_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="65"
        y="74"
        width="192"
        height="334"
      >
        <path
          d="M74.6027 234.135C74.2185 237.313 74.1137 238.99 73.7645 241.12C73.1359 245.381 73.1009 247.721 70.2721 250.619C67.4433 253.518 65.3828 256.731 65.5923 267.208C67.2177 292.456 74.1181 317.084 85.8482 339.501C101.339 368.602 125.193 392.396 154.334 407.812C130.263 390.605 110.605 367.947 96.9659 341.689C83.3271 315.431 76.0948 286.319 75.8599 256.731C75.8785 208.764 94.9463 162.768 128.871 128.856C162.795 94.9449 208.799 75.8948 256.766 75.8948V74.4629H255.613C165.405 74.428 85.6386 143.158 74.6027 234.135Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask171_31_1526)">
        <path
          d="M256.731 74.428H65.3828V407.812H256.731V74.428Z"
          fill="url(#paint6_linear_31_1526)"
        />
      </g>
      <mask
        id="mask172_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="246"
        y="75"
        width="192"
        height="363"
      >
        <path
          d="M246.638 76.1393V77.2917C338.243 77.2917 414.273 143.647 425.239 232.214C425.669 236.465 427.36 240.491 430.093 243.774C431.842 245.74 433.168 248.044 433.991 250.543C434.814 253.041 435.116 255.682 434.878 258.302C434.712 305.618 415.765 350.932 382.203 384.285C348.641 417.638 303.209 436.3 255.893 436.17V437.602H256.766C304.736 437.602 350.741 418.546 384.661 384.626C418.581 350.706 437.637 304.701 437.637 256.731C437.637 208.761 418.581 162.756 384.661 128.836C350.741 94.9159 304.736 75.8599 256.766 75.8599L246.638 76.1393Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask172_31_1526)">
        <path
          d="M437.637 75.8599H246.638V437.637H437.637V75.8599Z"
          fill="url(#paint7_linear_31_1526)"
        />
      </g>
      <mask
        id="mask173_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask173_31_1526)">
        <path
          d="M74.6725 257.814C74.6725 209.529 93.8536 163.221 127.996 129.079C162.139 94.9363 208.446 75.7552 256.731 75.7552C305.016 75.7552 351.323 94.9363 385.466 129.079C419.608 163.221 438.789 209.529 438.789 257.814C438.789 306.099 419.608 352.406 385.466 386.548C351.323 420.691 305.016 439.872 256.731 439.872C208.446 439.872 162.139 420.691 127.996 386.548C93.8536 352.406 74.6725 306.099 74.6725 257.814ZM129.678 130.621C100.558 159.99 82.5126 198.541 78.6116 239.716C74.7105 280.89 85.1948 322.144 108.281 356.46C131.367 390.776 165.628 416.034 205.237 427.937C244.846 439.84 287.355 437.653 325.533 421.748C363.711 405.843 395.2 377.203 414.643 340.699C434.085 304.195 440.281 262.083 432.175 221.526C424.069 180.97 402.163 144.474 370.183 118.248C338.203 92.0214 298.125 77.6845 256.766 77.676C233.143 77.7228 209.761 82.4225 187.955 91.5069C166.149 100.591 146.347 113.882 129.678 130.621Z"
          fill="black"
        />
      </g>
      <mask
        id="mask174_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask174_31_1526)">
        <path
          d="M74.6725 256.487C74.6725 208.202 93.8536 161.894 127.996 127.752C162.139 93.6091 208.446 74.428 256.731 74.428C305.016 74.428 351.323 93.6091 385.466 127.752C419.608 161.894 438.789 208.202 438.789 256.487C438.789 304.771 419.608 351.079 385.466 385.221C351.323 419.364 305.016 438.545 256.731 438.545C208.446 438.545 162.139 419.364 127.996 385.221C93.8536 351.079 74.6725 304.771 74.6725 256.487ZM129.678 129.363C100.531 158.746 82.4652 197.319 78.554 238.521C74.6428 279.722 85.1279 321.006 108.225 355.348C131.323 389.69 165.605 414.968 205.24 426.881C244.875 438.795 287.413 436.608 325.617 420.692C363.821 404.776 395.33 376.115 414.784 339.586C434.237 303.056 440.433 260.915 432.317 220.332C424.201 179.749 402.274 143.232 370.268 116.993C338.261 90.7552 298.153 76.4171 256.766 76.4187C233.146 76.4609 209.765 81.1551 187.959 90.2334C166.154 99.3117 146.349 112.596 129.678 129.328"
          fill="black"
        />
      </g>
      <mask
        id="mask175_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask175_31_1526)">
        <path
          d="M74.4979 257.15C74.4219 221.093 85.0441 185.824 105.02 155.806C124.997 125.788 153.429 102.371 186.719 88.5184C220.009 74.6656 256.66 70.9999 292.034 77.9852C327.408 84.9704 359.915 102.293 385.44 127.759C410.966 153.226 428.363 185.693 435.43 221.051C442.496 256.409 438.915 293.069 425.139 326.39C411.363 359.712 388.011 388.198 358.039 408.243C328.068 428.289 292.823 438.992 256.766 438.999C208.535 438.88 162.307 419.696 128.163 385.63C94.0186 351.565 74.7282 305.381 74.4979 257.15ZM129.817 130.097C100.694 159.447 82.6404 197.982 78.7277 239.143C74.8149 280.305 85.2852 321.551 108.357 355.862C131.428 390.174 165.676 415.432 205.272 427.338C244.868 439.244 287.366 437.063 325.535 421.165C363.704 405.267 395.185 376.636 414.622 340.142C434.059 303.649 440.252 261.547 432.145 221.003C424.038 180.458 402.134 143.975 370.159 117.76C338.183 91.5462 298.113 77.2209 256.766 77.222C209.113 77.3196 163.45 96.3386 129.817 130.097Z"
          fill="white"
        />
      </g>
      <mask
        id="mask176_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="64"
        y="64"
        width="386"
        height="386"
      >
        <path
          d="M65.4526 256.731C65.4457 218.891 76.6602 181.899 97.6777 150.433C118.695 118.968 148.572 94.441 183.529 79.9556C218.487 65.4702 256.954 61.6765 294.068 69.0545C331.181 76.4324 365.273 94.6505 392.033 121.405C418.792 148.159 437.016 182.248 444.401 219.36C451.785 256.472 447.999 294.94 433.52 329.9C419.041 364.86 394.52 394.741 363.058 415.765C331.595 436.788 294.606 448.009 256.766 448.009C206.033 448.009 157.377 427.858 121.499 391.987C85.6221 356.117 65.4619 307.464 65.4526 256.731ZM64.3001 256.731C64.3001 294.789 75.5851 331.992 96.7281 363.636C117.871 395.28 147.923 419.945 183.083 434.511C218.243 449.076 256.933 452.889 294.26 445.467C331.587 438.045 365.875 419.721 392.788 392.812C419.701 365.904 438.031 331.619 445.46 294.294C452.889 256.968 449.083 218.278 434.524 183.115C419.965 147.952 395.306 117.896 363.665 96.7475C332.025 75.5987 294.824 64.307 256.766 64.3C205.727 64.3 156.778 84.5728 120.684 120.66C84.591 156.746 64.3094 205.692 64.3001 256.731Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask176_31_1526)">
        <path
          d="M256.731 -128.131L641.593 256.696L256.731 641.558L-128.096 256.696L256.731 -128.131Z"
          fill="url(#paint8_linear_31_1526)"
        />
      </g>
      <mask
        id="mask177_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="86"
        y="86"
        width="342"
        height="342"
      >
        <path
          d="M87.3848 256.731C87.3917 223.24 97.3287 190.504 115.939 162.66C134.55 134.817 160.999 113.117 191.941 100.304C222.884 87.4907 256.931 84.14 289.777 90.6754C322.624 97.2107 352.795 113.339 376.477 137.02C400.158 160.701 416.286 190.873 422.821 223.72C429.357 256.566 426.006 290.613 413.193 321.556C400.38 352.498 378.68 378.947 350.836 397.557C322.993 416.168 290.256 426.105 256.766 426.112C234.521 426.117 212.493 421.739 191.941 413.228C171.389 404.717 152.715 392.241 136.985 376.512C121.256 360.782 108.779 342.108 100.269 321.556C91.7583 301.003 87.3802 278.976 87.3848 256.731ZM86.2673 256.731C86.2673 290.444 96.2639 323.4 114.993 351.432C133.722 379.464 160.343 401.313 191.489 414.216C222.635 427.119 256.908 430.496 289.974 423.922C323.04 417.347 353.414 401.116 377.255 377.279C401.096 353.443 417.334 323.073 423.915 290.008C430.496 256.944 427.126 222.67 414.229 191.521C401.332 160.373 379.489 133.748 351.461 115.013C323.433 96.2775 290.479 86.2741 256.766 86.2672C234.376 86.258 212.204 90.6607 191.516 99.2236C170.828 107.787 152.031 120.342 136.197 136.172C120.363 152.003 107.804 170.798 99.237 191.484C90.6699 212.17 86.2627 234.341 86.2673 256.731Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask177_31_1526)">
        <path
          d="M256.731 597.658L-84.1965 256.696L256.731 -84.1965L597.693 256.696L256.731 597.658Z"
          fill="url(#paint9_linear_31_1526)"
        />
      </g>
      <mask
        id="mask178_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask178_31_1526)">
        <path
          d="M256.766 81.6224V258.757L285.508 242.168L263.751 87.5594C261.967 85.0167 259.563 82.9728 256.766 81.6224Z"
          fill="#0D171A"
        />
      </g>
      <mask
        id="mask179_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask179_31_1526)">
        <path
          d="M256.766 81.6224V258.687C256.766 258.687 285.334 241.958 285.264 241.225L263.646 87.5594C261.822 85.0721 259.426 83.0599 256.661 81.6922"
          fill="#0F181C"
        />
      </g>
      <mask
        id="mask180_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask180_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.9716 256.766 258.652 256.766 258.652C256.766 258.652 285.124 241.818 285.019 240.282C285.019 240.282 263.576 87.5594 263.576 87.5245C261.779 85.0029 259.377 82.9734 256.591 81.6224"
          fill="#101B1F"
        />
      </g>
      <mask
        id="mask181_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask181_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.9716 256.766 258.547 256.766 258.547C256.766 258.547 284.949 241.574 284.705 239.304C284.705 239.269 263.541 87.4896 263.506 87.4547C261.778 84.973 259.462 82.9574 256.766 81.5875"
          fill="#121C21"
        />
      </g>
      <mask
        id="mask182_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask182_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.9716 256.766 258.547 256.766 258.547C257.464 258.058 284.705 241.434 284.705 238.396C284.705 238.151 263.751 87.5245 263.751 87.4547C261.944 84.9596 259.543 82.955 256.766 81.6224Z"
          fill="#131E22"
        />
      </g>
      <mask
        id="mask183_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask183_31_1526)">
        <path
          d="M256.766 81.6224C256.766 82.1113 256.766 258.477 256.766 258.477C257.674 257.849 284.705 241.26 284.251 237.523C284.251 237.208 263.297 87.5944 263.297 87.5245C261.659 85.0317 259.411 82.9998 256.766 81.6224Z"
          fill="#142024"
        />
      </g>
      <mask
        id="mask184_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask184_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.9716 256.766 258.442 256.766 258.442C257.849 257.674 284.391 240.98 284.007 236.51C284.007 236.126 263.366 87.5245 263.366 87.4197C261.686 84.9655 259.416 82.9722 256.766 81.6224Z"
          fill="#162227"
        />
      </g>
      <mask
        id="mask185_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask185_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.9716 256.766 258.372 256.766 258.372C258.023 257.499 284.216 240.91 283.762 235.567C283.762 235.113 263.262 87.5245 263.262 87.4197C261.651 84.9434 259.409 82.942 256.766 81.6224Z"
          fill="#172328"
        />
      </g>
      <mask
        id="mask186_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask186_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.9367 256.766 258.337 256.766 258.337C258.198 257.325 284.007 240.876 283.518 234.659C283.518 234.135 263.262 87.5594 263.192 87.4197C261.607 84.9472 259.388 82.9452 256.766 81.6224Z"
          fill="#18252A"
        />
      </g>
      <mask
        id="mask187_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask187_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.9367 256.766 258.268 256.766 258.268C258.372 257.15 283.797 240.526 283.273 233.821C283.273 233.227 263.157 87.6642 263.157 87.4896C261.554 85.0273 259.356 83.0093 256.766 81.6224Z"
          fill="#1A272C"
        />
      </g>
      <mask
        id="mask188_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask188_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.9367 256.766 258.233 256.766 258.233C258.547 256.975 283.622 240.352 283.029 232.773C283.029 232.11 263.122 87.5245 263.087 87.3848C261.529 84.9369 259.347 82.948 256.766 81.6224Z"
          fill="#1B282E"
        />
      </g>
      <mask
        id="mask189_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask189_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.9367 256.766 258.198 256.766 258.198C258.722 256.801 283.413 240.212 282.784 231.83C282.784 231.132 263.052 87.5245 263.052 87.3499C261.494 84.9238 259.326 82.9489 256.766 81.6224Z"
          fill="#1C2A2F"
        />
      </g>
      <mask
        id="mask190_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask190_31_1526)">
        <path
          d="M256.766 81.6224C256.766 82.1113 256.766 258.128 256.766 258.128C258.896 256.626 283.238 240.002 282.505 230.887C282.505 230.119 262.982 87.5245 262.947 87.3499C261.435 84.9236 259.3 82.9461 256.766 81.6224Z"
          fill="#1D2C32"
        />
      </g>
      <mask
        id="mask191_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask191_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.9367 256.766 258.093 256.766 258.093C259.071 256.417 283.029 239.828 282.26 229.944C282.26 229.106 262.912 87.5245 262.878 87.315C261.411 84.8755 259.295 82.8924 256.766 81.5875"
          fill="#1E2D33"
        />
      </g>
      <mask
        id="mask192_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask192_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.9367 256.766 258.023 256.766 258.023C259.28 256.277 282.854 239.653 282.016 229.001C282.016 228.093 262.878 87.5245 262.843 87.2801C261.36 84.8846 259.261 82.9308 256.766 81.6224Z"
          fill="#1F2E34"
        />
      </g>
      <mask
        id="mask193_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask193_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.9367 256.766 257.988 256.766 257.988C259.455 256.102 282.679 239.444 281.771 228.093C281.771 227.115 262.808 87.5594 262.773 87.315C261.354 84.8839 259.27 82.9089 256.766 81.6224Z"
          fill="#202F35"
        />
      </g>
      <mask
        id="mask194_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask194_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.9367 256.766 257.918 256.766 257.918C259.665 255.928 282.47 239.304 281.527 227.115C281.527 226.068 262.773 87.4197 262.738 87.2451C261.28 84.8753 259.219 82.9349 256.766 81.6224Z"
          fill="#223036"
        />
      </g>
      <mask
        id="mask195_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask195_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.9018 256.766 257.883 256.766 257.883C259.804 255.753 282.295 239.094 281.213 226.207C281.213 225.299 262.843 87.5245 262.808 87.2801C261.366 84.863 259.272 82.9019 256.766 81.6224Z"
          fill="#233137"
        />
      </g>
      <mask
        id="mask196_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask196_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.9018 256.766 257.814 256.766 257.814C260.258 255.544 282.225 238.92 281.213 225.299C281.213 224.147 262.878 87.5594 262.773 87.2801C261.355 84.857 259.269 82.893 256.766 81.6224Z"
          fill="#233238"
        />
      </g>
      <mask
        id="mask197_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask197_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.9018 256.975 257.779 256.975 257.779C260.468 255.404 282.121 238.78 280.968 224.322C280.968 223.099 262.773 87.5245 262.738 87.2102C261.304 84.8298 259.236 82.8951 256.766 81.6224Z"
          fill="#253339"
        />
      </g>
      <mask
        id="mask198_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask198_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.9018 256.975 257.674 256.975 257.674C260.468 255.159 281.911 238.536 280.724 223.344C280.724 222.052 262.738 87.4896 262.668 87.1404C261.275 84.7609 259.226 82.8331 256.766 81.5875"
          fill="#26343A"
        />
      </g>
      <mask
        id="mask199_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask199_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.9018 256.975 257.674 256.975 257.674C260.712 255.055 281.736 238.396 280.479 222.436C280.479 221.074 262.668 87.5245 262.633 87.1753C261.234 84.8128 259.202 82.8892 256.766 81.6224Z"
          fill="#27343A"
        />
      </g>
      <mask
        id="mask200_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask200_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.9018 257.01 257.604 257.01 257.604C260.922 254.81 281.457 238.186 280.305 221.493C280.305 220.061 262.843 87.5245 262.633 87.1404C261.212 84.8044 259.184 82.8975 256.766 81.6224Z"
          fill="#28363B"
        />
      </g>
      <mask
        id="mask201_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask201_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.9018 257.01 257.569 257.01 257.569C261.131 254.67 281.457 238.047 280.025 220.55C280.025 219.048 262.563 87.4896 262.563 87.1404C261.18 84.7992 259.172 82.8887 256.766 81.6224Z"
          fill="#29363C"
        />
      </g>
      <mask
        id="mask202_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask202_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.9018 257.01 257.499 257.01 257.499C261.306 254.496 281.213 237.837 279.816 219.607C279.816 218.07 262.563 87.4896 262.354 87.1054C261.037 84.7942 259.102 82.8955 256.766 81.6224Z"
          fill="#2A373D"
        />
      </g>
      <mask
        id="mask203_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask203_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.9018 257.01 257.464 257.01 257.464C261.481 254.321 281.003 237.697 279.536 218.664C279.536 217.057 262.458 87.4896 262.424 87.1054C261.126 84.7551 259.156 82.8459 256.766 81.6224Z"
          fill="#2B383E"
        />
      </g>
      <mask
        id="mask204_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask204_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.8668 257.045 257.395 257.045 257.395C261.69 254.147 280.898 237.488 279.292 217.721C279.292 216.01 262.424 87.4896 262.389 87.0705C261.072 84.7556 259.121 82.8653 256.766 81.6224Z"
          fill="#2C393F"
        />
      </g>
      <mask
        id="mask205_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask205_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.8668 257.045 257.36 257.045 257.36C261.865 253.867 280.654 237.313 279.047 216.813C279.047 215.067 262.389 87.5944 262.354 87.0705C261.056 84.7532 259.115 82.8611 256.766 81.6224Z"
          fill="#2D3A40"
        />
      </g>
      <mask
        id="mask206_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask206_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.8668 257.045 257.325 257.045 257.325C262.039 253.832 280.479 237.174 278.803 215.87C278.803 214.054 262.319 87.5245 262.284 87.0705C261.023 84.7495 259.103 82.8537 256.766 81.6224Z"
          fill="#2E3B41"
        />
      </g>
      <mask
        id="mask207_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask207_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.8668 257.08 257.255 257.08 257.255C262.249 253.762 280.305 236.964 278.593 214.927C278.593 213.041 262.319 87.5245 262.249 87.0356C260.987 84.7362 259.081 82.8549 256.766 81.6224Z"
          fill="#2F3C42"
        />
      </g>
      <mask
        id="mask208_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask208_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.8668 257.08 257.22 257.08 257.22C262.424 253.413 280.13 236.824 278.349 213.984C278.349 212.028 262.249 87.4896 262.179 87.0007C260.935 84.7203 259.054 82.8515 256.766 81.6224Z"
          fill="#303D43"
        />
      </g>
      <mask
        id="mask209_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask209_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.8668 257.08 257.15 257.08 257.15C262.598 253.273 279.955 236.615 278.035 213.041C277.86 211.05 262.144 87.4896 262.074 87.0007C260.863 84.7313 259.019 82.8628 256.766 81.6224Z"
          fill="#313E43"
        />
      </g>
      <mask
        id="mask210_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask210_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.8668 257.08 257.115 257.08 257.115C262.773 253.239 279.711 236.44 277.72 212.133C277.72 210.073 262.074 87.5245 262.004 87.0007C260.858 84.7082 259.027 82.8288 256.766 81.6224Z"
          fill="#313E44"
        />
      </g>
      <mask
        id="mask211_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask211_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.8668 257.115 257.045 257.115 257.045C264.011 251.678 269.493 244.708 273.084 236.742C276.675 228.775 278.266 220.052 277.72 211.33C277.546 209.199 262.214 87.6642 262.144 87.1404C260.958 84.7942 259.081 82.8683 256.766 81.6224Z"
          fill="#333F45"
        />
      </g>
      <mask
        id="mask212_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask212_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.8668 257.115 257.01 257.115 257.01C264.073 251.48 269.562 244.32 273.095 236.163C276.627 228.007 278.096 219.106 277.371 210.247C277.161 208.047 262.039 87.5245 261.935 86.9657C260.79 84.7043 258.988 82.8417 256.766 81.6224Z"
          fill="#344046"
        />
      </g>
      <mask
        id="mask213_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask213_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.8319 257.115 256.941 257.115 256.941C264.123 251.261 269.618 243.936 273.11 235.619C276.601 227.301 277.981 218.249 277.127 209.269C277.127 206.999 262.004 87.4896 261.9 87.0356C260.783 84.7482 258.991 82.8587 256.766 81.6224Z"
          fill="#344147"
        />
      </g>
      <mask
        id="mask214_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask214_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.8319 257.15 256.906 257.15 256.906C264.211 251.087 269.715 243.604 273.165 235.13C276.616 226.656 277.905 217.457 276.917 208.361C276.917 206.021 261.97 87.5245 261.9 86.9308C260.758 84.6873 258.97 82.8381 256.766 81.6224Z"
          fill="#364248"
        />
      </g>
      <mask
        id="mask215_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask215_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.8319 257.115 256.731 257.115 256.731C263.716 252.086 278.838 235.462 276.638 207.279C276.638 204.869 261.9 87.3499 261.795 86.7562C260.664 84.5755 258.915 82.7774 256.766 81.5875"
          fill="#374349"
        />
      </g>
      <mask
        id="mask216_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask216_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.8319 257.115 256.731 257.115 256.731C263.89 251.981 278.663 235.288 276.393 206.406C276.184 203.961 261.83 87.4197 261.76 86.7911C260.653 84.6054 258.912 82.8041 256.766 81.6224Z"
          fill="#374449"
        />
      </g>
      <mask
        id="mask217_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask217_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.8319 257.185 256.731 257.185 256.731C264.17 251.807 278.523 235.183 276.184 205.498C275.974 202.983 261.83 87.4547 261.725 86.7562C260.631 84.5729 258.902 82.7713 256.766 81.5875"
          fill="#39454B"
        />
      </g>
      <mask
        id="mask218_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask218_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.8319 257.185 256.696 257.185 256.696C264.17 251.667 278.349 235.008 275.939 204.59C275.73 202.005 261.76 87.4896 261.655 86.826C260.6 84.6296 258.892 82.8124 256.766 81.6224Z"
          fill="#39464B"
        />
      </g>
      <mask
        id="mask219_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask219_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.8319 257.185 256.626 257.185 256.626C264.519 251.492 278.139 234.834 275.695 203.647C275.485 200.992 261.725 87.4896 261.725 86.826C260.655 84.6168 258.921 82.7973 256.766 81.6224Z"
          fill="#3A474C"
        />
      </g>
      <mask
        id="mask220_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask220_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.8319 257.185 256.591 257.185 256.591C264.694 251.318 278.139 234.659 275.45 202.704C275.241 199.98 261.481 87.4547 261.481 86.7911C260.485 84.62 258.837 82.8133 256.766 81.6224Z"
          fill="#3B474D"
        />
      </g>
      <mask
        id="mask221_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask221_31_1526)">
        <path
          d="M256.766 81.6224C256.766 81.8319 257.22 256.521 257.22 256.521C264.903 251.143 277.79 234.449 275.241 201.761C275.066 198.932 261.655 87.4547 261.585 86.7911C260.525 84.6301 258.848 82.8315 256.766 81.6224Z"
          fill="#3C484E"
        />
      </g>
      <mask
        id="mask222_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask222_31_1526)">
        <path
          d="M256.766 81.6224L257.22 256.486C265.043 250.969 277.72 234.31 274.961 200.853C274.752 197.989 261.55 87.4896 261.446 86.7911C260.455 84.6276 258.821 82.8226 256.766 81.6224Z"
          fill="#3D494F"
        />
      </g>
      <mask
        id="mask223_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask223_31_1526)">
        <path
          d="M256.766 81.6224L257.22 256.452C265.252 250.794 277.441 234.135 274.682 199.91C274.437 197.011 261.446 87.4896 261.376 86.7562C260.401 84.613 258.792 82.821 256.766 81.6224Z"
          fill="#3E4A50"
        />
      </g>
      <mask
        id="mask224_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask224_31_1526)">
        <path
          d="M256.766 81.6224L257.255 256.242C265.462 250.48 277.266 233.786 274.507 198.827C274.228 195.998 261.446 87.4896 261.341 86.7562C260.378 84.6168 258.781 82.8247 256.766 81.6224Z"
          fill="#3F4B51"
        />
      </g>
      <mask
        id="mask225_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask225_31_1526)">
        <path
          d="M256.766 81.6224L257.255 256.242C265.637 250.305 277.092 233.681 274.263 197.919C274.018 194.881 261.411 87.3848 261.306 86.6165C260.343 84.5237 258.758 82.7794 256.766 81.6224Z"
          fill="#404C52"
        />
      </g>
      <mask
        id="mask226_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask226_31_1526)">
        <path
          d="M256.766 81.6224L257.255 256.242C265.811 250.235 276.882 233.542 274.018 196.871C273.739 193.868 261.341 87.4896 261.236 86.6514C260.308 84.5402 258.746 82.7704 256.766 81.5875"
          fill="#414D52"
        />
      </g>
      <mask
        id="mask227_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask227_31_1526)">
        <path
          d="M256.766 81.6224L257.255 256.242C265.986 250.061 276.707 233.402 273.774 196.173C273.529 192.995 261.306 87.4896 261.201 86.7213C260.298 84.5958 258.746 82.8109 256.766 81.6224Z"
          fill="#424E53"
        />
      </g>
      <mask
        id="mask228_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask228_31_1526)">
        <path
          d="M256.766 81.6224L257.29 256.242C266.23 249.991 276.533 233.297 273.564 195.265C273.32 192.017 261.306 87.5245 261.201 86.7213C260.29 84.6009 258.74 82.8182 256.766 81.6224Z"
          fill="#434F54"
        />
      </g>
      <mask
        id="mask229_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask229_31_1526)">
        <path
          d="M256.766 81.6224L257.29 256.242C266.405 249.851 276.358 233.157 273.32 194.392C273.075 191.074 261.236 87.5944 261.131 86.7911C260.255 84.6524 258.728 82.8439 256.766 81.6224Z"
          fill="#444F55"
        />
      </g>
      <mask
        id="mask230_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask230_31_1526)">
        <path
          d="M256.766 81.6224L257.29 256.242C266.58 249.711 276.184 233.018 273.04 193.379C272.761 189.887 261.166 87.5245 261.027 86.6863C260.176 84.5913 258.685 82.8188 256.766 81.6224Z"
          fill="#455056"
        />
      </g>
      <mask
        id="mask231_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask231_31_1526)">
        <path
          d="M256.766 81.6224L257.325 256.033C266.824 249.397 276.044 232.703 272.831 192.401C272.551 188.909 261.131 87.6293 261.027 86.6165C260.146 84.5581 258.66 82.8164 256.766 81.6224Z"
          fill="#465157"
        />
      </g>
      <mask
        id="mask232_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask232_31_1526)">
        <path
          d="M256.766 81.6224L257.325 255.928C266.964 249.152 275.834 232.459 272.586 191.423C272.307 187.931 261.096 87.4547 260.957 86.6514C260.114 84.5816 258.65 82.8244 256.766 81.6224Z"
          fill="#475257"
        />
      </g>
      <mask
        id="mask233_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask233_31_1526)">
        <path
          d="M256.766 81.6224L257.325 255.928C267.243 249.013 275.625 232.284 272.307 190.376C272.028 186.883 260.992 87.3499 260.887 86.4419C260.027 84.4589 258.591 82.7799 256.766 81.6224Z"
          fill="#485358"
        />
      </g>
      <mask
        id="mask234_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask234_31_1526)">
        <path
          d="M256.766 81.6224L257.36 255.858C267.348 248.873 275.485 232.11 272.132 189.502C271.853 186.01 260.992 87.3848 260.887 86.5117C260.029 84.5087 258.595 82.8066 256.766 81.6224Z"
          fill="#495459"
        />
      </g>
      <mask
        id="mask235_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask235_31_1526)">
        <path
          d="M256.766 81.6224L257.36 255.823C267.522 248.664 275.276 231.97 271.888 188.629C271.609 184.927 260.957 87.3499 260.817 86.5466C260.011 84.5242 258.595 82.803 256.766 81.6224Z"
          fill="#4A555A"
        />
      </g>
      <mask
        id="mask236_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask236_31_1526)">
        <path
          d="M256.766 81.6224L257.36 255.753C267.837 248.489 275.101 231.795 271.643 187.686C271.329 183.95 260.887 87.4547 260.782 86.407C259.943 84.4521 258.546 82.788 256.766 81.6224Z"
          fill="#4B555B"
        />
      </g>
      <mask
        id="mask237_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask237_31_1526)">
        <path
          d="M256.766 81.6224L257.36 255.718C267.837 248.314 274.822 231.621 271.329 186.743C271.015 182.937 260.852 87.4547 260.642 86.5117C259.893 84.5169 258.537 82.8071 256.766 81.6224Z"
          fill="#4C565C"
        />
      </g>
      <mask
        id="mask238_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask238_31_1526)">
        <path
          d="M256.766 81.6224L257.395 255.648C268.116 248.14 274.856 231.411 271.155 185.8C270.84 181.924 260.677 87.4547 260.677 86.4768C259.896 84.4993 258.532 82.8061 256.766 81.6224Z"
          fill="#4D575C"
        />
      </g>
      <mask
        id="mask239_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask239_31_1526)">
        <path
          d="M256.766 81.6224L257.395 255.613C268.291 247.965 274.577 231.167 270.91 184.892C270.735 180.946 260.712 87.4896 260.573 86.4768C259.808 84.5196 258.484 82.8311 256.766 81.6224Z"
          fill="#4E585D"
        />
      </g>
      <mask
        id="mask240_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask240_31_1526)">
        <path
          d="M256.766 81.6224L257.395 255.578C268.465 247.79 274.368 231.132 270.666 183.949C270.316 179.898 260.642 87.4896 260.503 86.4768C259.786 84.5128 258.481 82.8176 256.766 81.6224Z"
          fill="#4E595E"
        />
      </g>
      <mask
        id="mask241_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask241_31_1526)">
        <path
          d="M256.766 81.6224L257.429 255.509C268.675 247.616 274.228 231.062 270.456 183.007C270.142 178.92 260.677 87.4547 260.538 86.4419C259.768 84.5071 258.459 82.8341 256.766 81.6224Z"
          fill="#505A5F"
        />
      </g>
      <mask
        id="mask242_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask242_31_1526)">
        <path
          d="M256.766 81.6224L257.429 255.474C268.85 247.406 274.018 230.713 270.212 182.133C269.932 177.978 260.608 87.5245 260.503 86.5117C259.781 84.5318 258.478 82.8157 256.766 81.5875"
          fill="#505B60"
        />
      </g>
      <mask
        id="mask243_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask243_31_1526)">
        <path
          d="M256.766 81.6224L257.429 255.404C269.059 247.267 273.844 230.538 269.967 181.121C269.618 176.93 260.573 87.4547 260.433 86.407C259.735 84.5193 258.525 82.8628 256.94 81.6224"
          fill="#515B60"
        />
      </g>
      <mask
        id="mask244_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask244_31_1526)">
        <path
          d="M256.766 81.6224L257.429 255.369C269.199 247.057 273.634 230.328 269.688 180.178C269.304 175.917 260.433 87.4547 260.258 86.372C259.605 84.4607 258.387 82.7925 256.766 81.5875"
          fill="#525C61"
        />
      </g>
      <mask
        id="mask245_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask245_31_1526)">
        <path
          d="M256.766 81.6224L257.464 255.299C269.408 246.882 273.494 230.189 269.478 179.235C269.094 174.904 260.433 87.4547 260.258 86.372C259.561 84.4936 258.351 82.8481 256.766 81.6224Z"
          fill="#535D62"
        />
      </g>
      <mask
        id="mask246_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask246_31_1526)">
        <path
          d="M256.766 81.6224L257.464 255.264C269.618 246.743 273.32 229.979 269.234 178.432C268.85 173.926 260.258 87.4896 260.258 86.372C259.589 84.4785 258.374 82.8257 256.766 81.6224Z"
          fill="#545E63"
        />
      </g>
      <mask
        id="mask247_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask247_31_1526)">
        <path
          d="M256.766 81.6224L257.464 255.194C269.792 246.533 273.11 229.84 268.989 177.349C268.605 172.914 260.258 87.4197 260.258 86.3022C259.561 84.4428 258.35 82.8198 256.766 81.6224Z"
          fill="#555F63"
        />
      </g>
      <mask
        id="mask248_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask248_31_1526)">
        <path
          d="M256.766 81.6224L257.499 255.159C269.967 246.254 272.936 229.665 268.745 176.406C268.396 171.866 260.258 87.4547 260.258 86.3371C259.554 84.4723 258.344 82.84 256.766 81.6224Z"
          fill="#566064"
        />
      </g>
      <mask
        id="mask249_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask249_31_1526)">
        <path
          d="M256.766 81.6224L257.499 255.055C270.212 246.149 272.761 229.455 268.57 175.428C268.151 170.818 260.258 87.3848 260.258 86.2323C259.533 84.3982 258.327 82.7935 256.766 81.5875"
          fill="#576065"
        />
      </g>
      <mask
        id="mask250_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask250_31_1526)">
        <path
          d="M256.766 81.6224L257.499 255.055C270.351 246.044 272.621 229.316 268.291 174.555C267.872 169.91 260.258 87.4197 260.014 86.3022C259.414 84.4573 258.284 82.8297 256.766 81.6224Z"
          fill="#586166"
        />
      </g>
      <mask
        id="mask251_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask251_31_1526)">
        <path
          d="M256.766 81.6224L257.534 254.985C270.561 245.8 272.412 229.071 268.011 173.577C267.627 168.862 260.153 87.4198 259.979 86.2673C259.345 84.4486 258.235 82.8327 256.766 81.5875"
          fill="#596267"
        />
      </g>
      <mask
        id="mask252_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask252_31_1526)">
        <path
          d="M256.766 81.6224L257.534 254.95C270.735 245.66 272.202 228.792 267.767 172.669C267.243 167.884 260.258 87.4547 259.909 86.2323C259.32 84.4283 258.23 82.8293 256.766 81.6224Z"
          fill="#5A6368"
        />
      </g>
      <mask
        id="mask253_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask253_31_1526)">
        <path
          d="M256.766 81.6224L257.534 254.88C270.735 245.451 271.993 228.792 267.522 171.726C267.243 166.872 260.014 87.4547 259.874 86.2323C259.251 84.4542 258.181 82.8665 256.766 81.6224Z"
          fill="#5B6468"
        />
      </g>
      <mask
        id="mask254_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask254_31_1526)">
        <path
          d="M256.766 81.6224L257.534 254.845C271.12 245.311 271.853 228.582 267.313 170.783C266.894 165.929 259.979 87.4197 259.804 86.1974C259.241 84.4176 258.188 82.8323 256.766 81.6224Z"
          fill="#5C6569"
        />
      </g>
      <mask
        id="mask255_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask255_31_1526)">
        <path
          d="M256.766 81.6224L257.569 254.775C271.329 245.136 271.713 228.373 267.103 169.84C266.719 164.846 260.119 87.4197 259.839 86.0228C259.181 84.3314 258.127 82.8224 256.766 81.6224Z"
          fill="#5D666A"
        />
      </g>
      <mask
        id="mask256_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask256_31_1526)">
        <path
          d="M256.766 81.6224L257.569 254.74C271.539 244.962 271.539 228.233 266.859 168.932C266.475 163.868 259.874 87.4547 259.874 86.1974C259.253 84.4283 258.182 82.8515 256.766 81.6224Z"
          fill="#5E676B"
        />
      </g>
      <mask
        id="mask257_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask257_31_1526)">
        <path
          d="M256.766 81.6224L257.569 254.705C271.539 244.787 271.329 228.058 266.579 167.989C266.16 162.89 259.839 87.4547 259.595 86.1625C259.045 84.4369 258.073 82.8762 256.766 81.6224Z"
          fill="#5F676C"
        />
      </g>
      <mask
        id="mask258_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask258_31_1526)">
        <path
          d="M256.766 81.6224L257.604 254.636C271.888 244.612 271.189 227.849 266.37 167.046C265.951 161.878 259.839 87.4547 259.665 86.1625C259.087 84.4335 258.091 82.874 256.766 81.6224Z"
          fill="#60686D"
        />
      </g>
      <mask
        id="mask259_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask259_31_1526)">
        <path
          d="M256.766 81.6224L257.604 254.601C272.063 244.403 270.98 227.709 266.125 166.103C265.741 160.865 259.769 87.4547 259.63 86.1276C259.047 84.4195 258.065 82.8751 256.766 81.6224Z"
          fill="#61696D"
        />
      </g>
      <mask
        id="mask260_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask260_31_1526)">
        <path
          d="M256.766 81.6224L257.604 254.531C272.237 244.263 270.805 227.5 265.881 165.125C265.462 159.852 259.734 87.4197 259.56 86.0926C258.993 84.4034 258.036 82.8717 256.766 81.6224Z"
          fill="#626A6E"
        />
      </g>
      <mask
        id="mask261_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask261_31_1526)">
        <path
          d="M256.766 81.6224L257.604 254.496C272.447 244.019 270.596 227.36 265.637 164.217C265.252 158.839 259.665 87.3848 259.525 86.0926C258.96 84.4106 258.016 82.881 256.766 81.6224Z"
          fill="#636B6F"
        />
      </g>
      <mask
        id="mask262_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask262_31_1526)">
        <path
          d="M256.766 81.6224L257.639 254.426C272.621 243.949 270.456 227.15 265.427 163.275C265.008 157.826 259.665 87.4197 259.455 86.0577C258.899 84.3982 257.98 82.8832 256.766 81.6224Z"
          fill="#646C70"
        />
      </g>
      <mask
        id="mask263_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask263_31_1526)">
        <path
          d="M256.766 81.6224L257.639 254.391C272.831 243.704 270.247 226.976 265.183 162.366C264.763 156.849 259.595 87.4547 259.455 86.0926C258.883 84.43 257.967 82.9068 256.766 81.6224Z"
          fill="#656D71"
        />
      </g>
      <mask
        id="mask264_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask264_31_1526)">
        <path
          d="M256.766 81.6224L257.639 254.321C273.005 243.53 270.072 226.801 264.903 161.389C264.449 155.836 259.525 87.4197 259.315 86.0228C258.801 84.3859 257.93 82.8831 256.766 81.6224Z"
          fill="#666E72"
        />
      </g>
      <mask
        id="mask265_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask265_31_1526)">
        <path
          d="M256.766 81.6224L257.674 254.286C273.215 243.39 269.897 226.627 264.659 160.481C264.205 154.858 259.455 87.4547 259.28 86.0228C258.738 84.4059 257.883 82.9109 256.766 81.6224Z"
          fill="#676F72"
        />
      </g>
      <mask
        id="mask266_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask266_31_1526)">
        <path
          d="M256.766 81.6224L257.674 254.182C273.39 243.146 269.723 226.242 264.449 159.468C263.995 153.775 259.455 87.3848 259.245 86.1276C258.733 84.4625 257.89 82.9182 256.766 81.5875"
          fill="#686F73"
        />
      </g>
      <mask
        id="mask267_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask267_31_1526)">
        <path
          d="M256.766 81.6224L257.674 254.182C273.564 243.006 269.513 226.242 264.205 158.595C263.751 152.832 259.35 87.4197 259.141 85.9879C258.626 84.3984 257.821 82.9182 256.766 81.6224Z"
          fill="#697074"
        />
      </g>
      <mask
        id="mask268_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask268_31_1526)">
        <path
          d="M256.766 81.6224L257.709 254.112C273.809 242.796 269.373 226.173 263.995 157.617C263.506 151.959 259.35 87.3848 259.141 85.953C258.616 84.3675 257.812 82.889 256.766 81.5875"
          fill="#6B7175"
        />
      </g>
      <mask
        id="mask269_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask269_31_1526)">
        <path
          d="M259.071 85.9529C258.543 84.3938 257.764 82.9312 256.766 81.6224L257.709 254.077C273.914 242.761 269.164 225.893 263.751 156.709C263.262 150.842 259.315 87.4547 259.106 85.9529"
          fill="#6C7276"
        />
      </g>
      <mask
        id="mask270_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask270_31_1526)">
        <path
          d="M328.255 318.616L399.779 347.359L408.301 344.32L332.516 300.595L294.623 278.733L256.731 256.836V289.909L328.255 318.616Z"
          fill="#4F585D"
        />
      </g>
      <mask
        id="mask271_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask271_31_1526)">
        <path
          d="M256.766 256.731V257.988C256.766 257.988 257.01 289.734 257.255 289.839C257.499 289.944 328.43 318.546 328.43 318.546L398.068 346.486L399.849 347.149L408.336 344.146L384.518 330.386L332.516 300.561L294.623 278.698C294.379 278.593 256.766 256.731 256.766 256.731Z"
          fill="#4F585C"
        />
      </g>
      <mask
        id="mask272_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask272_31_1526)">
        <path
          d="M256.766 256.731V258.023C256.766 258.233 257.29 289.699 257.744 290.014C258.198 290.328 328.604 318.651 328.604 318.651L398.103 346.59L399.954 347.533L408.406 344.495L384.587 330.735L332.516 300.595L294.623 278.733L256.766 256.731Z"
          fill="#4E575C"
        />
      </g>
      <mask
        id="mask273_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask273_31_1526)">
        <path
          d="M256.766 256.731V258.023C256.766 258.372 257.569 289.664 258.233 290.118C258.896 290.572 328.709 318.861 328.709 318.861L398.068 346.8C398.068 346.8 399.814 347.498 399.814 347.463C399.814 347.428 408.161 344.495 408.231 344.425L384.413 330.665L332.446 300.595L294.554 278.733C293.89 278.314 256.766 256.731 256.766 256.731Z"
          fill="#4E575C"
        />
      </g>
      <mask
        id="mask274_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask274_31_1526)">
        <path
          d="M256.766 256.731V258.023C256.766 258.477 257.814 289.455 258.722 290.188C259.63 290.922 328.849 318.896 328.849 318.896L398.103 346.835L399.954 347.533L408.371 344.495L384.553 330.735L332.481 300.561L294.588 278.698L256.766 256.731Z"
          fill="#4D575B"
        />
      </g>
      <mask
        id="mask275_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask275_31_1526)">
        <path
          d="M256.766 256.731V258.023C256.766 258.617 258.093 289.455 259.211 290.293C260.328 291.131 329.058 318.861 329.058 318.861L398.173 346.59L399.919 347.289C399.919 347.289 408.161 344.355 408.336 344.25L384.518 330.49C383.679 330.071 333.599 301.224 332.481 300.63L294.588 278.768C293.436 278.035 256.766 256.731 256.766 256.731Z"
          fill="#4C565B"
        />
      </g>
      <mask
        id="mask276_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask276_31_1526)">
        <path
          d="M256.766 256.731V258.023C256.766 258.722 258.337 289.455 259.699 290.398C261.062 291.341 329.198 318.861 329.198 318.861L398.173 346.52L399.919 347.184C399.919 347.184 408.126 344.285 408.301 344.181L384.483 330.421C383.505 330.071 333.599 301.294 332.481 300.561L294.588 278.698C293.192 277.93 256.766 256.731 256.766 256.731Z"
          fill="#4C565A"
        />
      </g>
      <mask
        id="mask277_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask277_31_1526)">
        <path
          d="M256.766 256.731V258.023C256.975 258.826 258.617 289.455 260.258 290.468C261.9 291.48 329.408 318.931 329.408 318.931L398.278 346.59C398.845 346.83 399.428 347.028 400.024 347.184C400.024 347.184 408.196 344.285 408.406 344.181L384.587 330.421L332.516 300.561L294.623 278.698L256.766 256.731Z"
          fill="#4B555A"
        />
      </g>
      <mask
        id="mask278_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask278_31_1526)">
        <path
          d="M256.766 256.731V258.093C257.01 259.001 258.861 289.525 260.677 290.642C262.493 291.76 329.477 319.035 329.477 319.035L398.208 346.59L399.954 347.533C399.954 347.533 408.056 344.669 408.301 344.53L384.483 330.77L332.481 300.595L294.588 278.733L256.766 256.731Z"
          fill="#4B555A"
        />
      </g>
      <mask
        id="mask279_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask279_31_1526)">
        <path
          d="M256.766 256.731V258.093C257.01 259.106 259.141 289.525 261.166 290.712C263.192 291.899 329.652 319.07 329.652 319.07L398.208 346.73L399.954 347.533C399.954 347.533 408.021 344.669 408.301 344.53L384.483 330.77L332.516 300.595L294.623 278.733L256.766 256.731Z"
          fill="#4A5459"
        />
      </g>
      <mask
        id="mask280_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask280_31_1526)">
        <path
          d="M256.766 256.731V258.093C257.045 259.211 259.385 289.315 261.655 290.817C263.925 292.319 329.757 319.245 329.757 319.245L398.208 346.73C398.208 346.73 399.849 347.324 399.954 347.324C400.059 347.324 407.952 344.495 408.266 344.32L384.448 330.56L332.481 300.561L294.588 278.698C292.214 277.371 256.766 256.731 256.766 256.731Z"
          fill="#4A5459"
        />
      </g>
      <mask
        id="mask281_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask281_31_1526)">
        <path
          d="M256.766 256.731V258.128C257.08 259.35 259.665 289.28 262.144 290.922C264.624 292.563 329.931 319.14 329.931 319.14L398.278 346.59C398.849 346.82 399.431 347.018 400.024 347.184C400.233 347.184 407.987 344.39 408.371 344.181C408.755 343.971 386.229 331.468 384.518 330.421L332.516 300.561L294.623 278.698L256.766 256.731Z"
          fill="#495358"
        />
      </g>
      <mask
        id="mask282_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask282_31_1526)">
        <path
          d="M256.766 256.731V258.128C257.115 259.455 259.909 289.21 262.633 291.026C265.357 292.842 330.106 319.385 330.106 319.385L398.313 346.73C398.881 346.965 399.465 347.163 400.059 347.324C400.268 347.324 407.987 344.53 408.336 344.32L384.518 330.56L332.481 300.561L294.588 278.698L256.766 256.731Z"
          fill="#495358"
        />
      </g>
      <mask
        id="mask283_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask283_31_1526)">
        <path
          d="M256.766 256.731V258.128C257.15 259.56 260.258 289.175 263.122 291.131C265.986 293.087 330.106 319.594 330.106 319.594L398.208 346.94L399.954 347.533C399.954 347.533 407.812 344.774 408.231 344.53L384.378 330.77L332.516 300.595L294.623 278.733L256.766 256.731Z"
          fill="#485257"
        />
      </g>
      <mask
        id="mask284_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask284_31_1526)">
        <path
          d="M256.766 256.731V258.163C257.15 259.734 260.258 289.14 263.751 291.236C267.243 293.331 330.351 319.594 330.351 319.594L398.313 346.87C398.844 347.128 399.392 347.35 399.954 347.533C400.198 347.533 407.777 344.809 408.196 344.53L384.378 330.77L332.516 300.595L294.623 278.733L256.766 256.731Z"
          fill="#485257"
        />
      </g>
      <mask
        id="mask285_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask285_31_1526)">
        <path
          d="M256.766 256.731V258.163C257.185 259.839 260.712 289.071 264.1 291.341C267.488 293.611 330.455 319.28 330.455 319.28L398.243 346.52C398.786 346.901 399.358 347.24 399.954 347.533C400.268 347.533 407.742 344.809 408.231 344.53L384.378 330.77L332.516 300.595L294.658 278.733L256.766 256.731Z"
          fill="#475257"
        />
      </g>
      <mask
        id="mask286_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask286_31_1526)">
        <path
          d="M256.766 256.731V258.163C257.22 259.979 260.957 289.071 264.589 291.41C268.221 293.75 330.665 319.35 330.665 319.35L398.348 346.52C398.916 346.748 399.499 346.935 400.094 347.079C400.408 347.079 407.847 344.39 408.336 344.076L384.483 330.316L332.481 300.561C330.176 299.268 296.649 279.921 294.623 278.698L256.766 256.731Z"
          fill="#475156"
        />
      </g>
      <mask
        id="mask287_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask287_31_1526)">
        <path
          d="M256.766 256.731V258.163C257.255 260.084 261.236 288.966 265.078 291.55C268.919 294.135 330.805 319.594 330.805 319.594L398.348 346.835C398.911 347.057 399.496 347.221 400.094 347.324C400.373 347.324 407.777 344.635 408.336 344.32L384.483 330.56L332.516 300.561L294.658 278.698C290.537 276.358 256.766 256.731 256.766 256.731Z"
          fill="#465155"
        />
      </g>
      <mask
        id="mask288_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask288_31_1526)">
        <path
          d="M256.766 256.731V258.163C257.29 260.154 261.481 288.931 265.567 291.655C269.653 294.379 330.979 319.594 330.979 319.594L398.382 346.835C398.946 347.057 399.531 347.221 400.129 347.324C400.443 347.324 407.777 344.704 408.301 344.32L384.483 330.56L332.516 300.561C329.932 299.059 296.928 280.06 294.658 278.698L256.766 256.731Z"
          fill="#465055"
        />
      </g>
      <mask
        id="mask289_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask289_31_1526)">
        <path
          d="M256.766 256.731V258.233C257.325 260.363 261.76 288.896 266.056 291.76C270.351 294.623 331.119 319.699 331.119 319.699L398.417 346.835C398.981 347.057 399.566 347.221 400.164 347.324C400.478 347.324 407.742 344.704 408.336 344.32L384.483 330.56L332.516 300.561C329.757 299.024 297.068 280.095 294.658 278.698L256.766 256.731Z"
          fill="#455055"
        />
      </g>
      <mask
        id="mask290_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask290_31_1526)">
        <path
          d="M256.766 256.731V258.233C257.325 260.468 262.004 288.861 266.545 291.83C271.085 294.798 331.259 319.769 331.259 319.769L398.382 346.835C398.934 347.058 399.508 347.221 400.094 347.324C400.478 347.324 407.637 344.704 408.231 344.32L384.413 330.56L332.446 300.561C329.547 298.884 297.103 280.2 294.588 278.698L256.766 256.731Z"
          fill="#454F54"
        />
      </g>
      <mask
        id="mask291_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask291_31_1526)">
        <path
          d="M256.766 256.731V258.233C257.36 260.573 262.284 288.791 267.034 291.934C271.783 295.078 331.433 319.873 331.433 319.873L398.487 346.835C398.487 346.835 399.989 347.324 400.198 347.324C400.408 347.324 407.707 344.704 408.371 344.32L384.518 330.56C381.235 328.709 336.916 303.075 332.551 300.561L294.658 278.698L256.766 256.731Z"
          fill="#444F54"
        />
      </g>
      <mask
        id="mask292_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask292_31_1526)">
        <path
          d="M256.766 256.731V258.268C257.394 260.712 262.528 288.756 267.522 292.074C272.517 295.392 331.573 320.013 331.573 320.013L398.487 346.87C399.044 347.077 399.616 347.24 400.198 347.359C400.583 347.359 407.672 344.809 408.336 344.39L384.483 330.63C380.99 328.604 337.056 303.25 332.481 300.63L294.623 278.768C289.385 275.695 256.766 256.731 256.766 256.731Z"
          fill="#444E53"
        />
      </g>
      <mask
        id="mask293_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask293_31_1526)">
        <path
          d="M256.766 256.731V258.268C257.429 260.817 262.808 288.721 268.011 292.179C273.215 295.636 331.713 319.908 331.713 319.908L398.452 346.835C399.008 347.046 399.58 347.21 400.164 347.324C400.583 347.324 407.567 344.774 408.301 344.32C408.301 344.32 388.08 332.691 384.448 330.56L332.446 300.561L294.623 278.698L256.766 256.731Z"
          fill="#434E53"
        />
      </g>
      <mask
        id="mask294_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask294_31_1526)">
        <path
          d="M256.766 256.731V258.268C257.464 260.957 263.052 288.651 268.5 292.249C273.948 295.846 331.852 319.943 331.852 319.943L398.487 346.835C399.044 347.033 399.617 347.185 400.198 347.289C400.618 347.289 407.567 344.774 408.266 344.32L384.448 330.56L332.446 300.561L294.588 278.698C288.896 275.38 256.766 256.731 256.766 256.731Z"
          fill="#434D52"
        />
      </g>
      <mask
        id="mask295_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask295_31_1526)">
        <path
          d="M256.766 256.731V258.268C257.464 261.097 263.332 288.582 268.989 292.388C274.647 296.195 332.027 320.013 332.027 320.013L398.382 346.73C398.95 346.931 399.535 347.083 400.129 347.184C400.583 347.184 407.393 344.669 408.196 344.215L384.343 330.455L332.481 300.595L294.623 278.733C288.651 275.241 256.766 256.731 256.766 256.731Z"
          fill="#424D52"
        />
      </g>
      <mask
        id="mask296_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask296_31_1526)">
        <path
          d="M256.766 256.731V258.268C257.499 261.201 263.576 288.547 269.478 292.458C275.38 296.37 332.167 320.118 332.167 320.118L398.522 346.765C399.078 346.968 399.65 347.119 400.233 347.219C400.687 347.219 407.498 344.739 408.266 344.25L384.448 330.49L332.446 300.63L294.588 278.768C288.407 275.136 256.766 256.731 256.766 256.731Z"
          fill="#424C51"
        />
      </g>
      <mask
        id="mask297_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask297_31_1526)">
        <path
          d="M256.766 256.731V258.268C257.534 261.271 263.751 288.512 269.967 292.528C276.184 296.544 332.306 320.118 332.306 320.118L398.662 346.73C399.226 346.935 399.812 347.075 400.408 347.149C400.862 347.149 407.602 344.704 408.441 344.181L384.587 330.421L332.446 300.561L294.623 278.698L256.766 256.731Z"
          fill="#414C51"
        />
      </g>
      <mask
        id="mask298_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask298_31_1526)">
        <path
          d="M256.766 256.731V258.338C257.569 261.446 264.1 288.442 270.456 292.668C276.812 296.894 332.481 320.223 332.481 320.223L398.627 346.765C399.178 346.975 399.753 347.115 400.338 347.184C403.055 346.325 405.725 345.323 408.336 344.181L384.518 330.421L332.516 300.386L294.623 278.663C287.918 274.857 256.766 256.731 256.766 256.731Z"
          fill="#414B51"
        />
      </g>
      <mask
        id="mask299_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask299_31_1526)">
        <path
          d="M256.766 256.731V258.338C257.604 261.585 264.379 288.407 270.945 292.773C277.511 297.138 332.621 320.223 332.621 320.223L398.627 346.73C399.178 346.94 399.753 347.08 400.338 347.149C403.053 346.297 405.723 345.307 408.336 344.181L384.518 330.421L332.516 300.386L294.623 278.663C287.674 274.717 256.766 256.731 256.766 256.731Z"
          fill="#404B50"
        />
      </g>
      <mask
        id="mask300_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask300_31_1526)">
        <path
          d="M256.766 256.731V258.338C257.639 261.83 264.624 288.337 271.434 292.877C278.244 297.417 332.76 320.327 332.76 320.327L398.627 346.765C399.18 346.96 399.755 347.089 400.338 347.149C403.047 346.312 405.705 345.321 408.301 344.181L384.483 330.421L332.481 300.386L294.588 278.628C287.429 274.577 256.766 256.731 256.766 256.731Z"
          fill="#3F4A4F"
        />
      </g>
      <mask
        id="mask301_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask301_31_1526)">
        <path
          d="M256.766 256.731V258.372C257.639 261.865 264.903 288.337 271.923 292.947C278.943 297.557 332.9 320.397 332.9 320.397L398.662 346.8C399.214 346.999 399.789 347.128 400.373 347.184C403.087 346.35 405.747 345.347 408.336 344.181L384.483 330.421L332.481 300.386L294.623 278.663L256.766 256.731Z"
          fill="#3F4A4F"
        />
      </g>
      <mask
        id="mask302_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask302_31_1526)">
        <path
          d="M256.766 256.731V258.372C257.674 261.865 265.148 288.267 272.412 293.087C279.676 297.906 333.075 320.397 333.075 320.397L398.697 346.73C399.249 346.929 399.824 347.059 400.408 347.114C403.12 346.287 405.779 345.296 408.371 344.146L384.518 330.386L332.516 300.351L294.623 278.628C286.975 274.193 256.766 256.731 256.766 256.731Z"
          fill="#3F4A4F"
        />
      </g>
      <mask
        id="mask303_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask303_31_1526)">
        <path
          d="M256.766 256.731V258.372C257.709 262.039 265.427 288.232 272.901 293.296C280.374 298.36 333.179 320.642 333.179 320.642L398.662 346.94C399.214 347.139 399.789 347.268 400.373 347.324C403.078 346.489 405.736 345.509 408.336 344.39L384.483 330.63L332.481 300.595L294.623 278.733L256.766 256.731Z"
          fill="#3E494E"
        />
      </g>
      <mask
        id="mask304_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask304_31_1526)">
        <path
          d="M256.766 256.731V258.407C257.744 262.214 265.671 288.197 273.39 293.331C281.108 298.465 333.354 320.607 333.354 320.607L398.697 346.835C399.254 347.007 399.828 347.124 400.408 347.184C403.097 346.369 405.733 345.389 408.301 344.25L384.483 330.49L332.481 300.456L294.588 278.698L256.766 256.731Z"
          fill="#3D484E"
        />
      </g>
      <mask
        id="mask305_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask305_31_1526)">
        <path
          d="M256.766 256.731V258.407C257.779 262.319 265.951 288.128 273.879 293.331C281.806 298.535 333.599 320.781 333.599 320.781L398.836 346.974C399.39 347.162 399.965 347.279 400.548 347.324C403.236 346.509 405.872 345.529 408.441 344.39L384.622 330.63L332.621 300.595L294.623 278.733L256.766 256.731Z"
          fill="#3D484D"
        />
      </g>
      <mask
        id="mask306_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask306_31_1526)">
        <path
          d="M256.766 256.731V258.407C257.814 262.424 266.23 288.058 274.228 293.331C282.225 298.605 333.599 320.537 333.599 320.537L398.697 346.66C399.253 346.836 399.827 346.953 400.408 347.009C403.083 346.188 405.707 345.209 408.266 344.076L384.448 330.316L332.446 300.281L294.623 278.698C285.997 273.774 256.766 256.731 256.766 256.731Z"
          fill="#3C484D"
        />
      </g>
      <mask
        id="mask307_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask307_31_1526)">
        <path
          d="M256.766 256.731V258.407C257.814 262.528 266.475 288.023 274.856 293.576C283.238 299.129 333.808 320.712 333.808 320.712L398.767 346.8C399.328 346.998 399.918 347.104 400.513 347.114C403.193 346.307 405.818 345.327 408.371 344.181C408.371 344.181 390.315 333.703 384.518 330.421L332.516 300.386L294.623 278.663L256.766 256.731Z"
          fill="#3C474C"
        />
      </g>
      <mask
        id="mask308_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask308_31_1526)">
        <path
          d="M256.766 256.731V258.407C257.849 262.633 266.754 287.953 275.345 293.681C283.937 299.408 333.948 320.816 333.948 320.816L398.767 346.8C399.31 346.973 399.873 347.078 400.443 347.114C403.122 346.339 405.738 345.359 408.266 344.181L384.448 330.421L332.446 300.386L294.554 278.663L256.766 256.731Z"
          fill="#3B474C"
        />
      </g>
      <mask
        id="mask309_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask309_31_1526)">
        <path
          d="M256.766 256.731V258.407C257.883 262.773 266.999 287.918 275.834 293.785C284.67 299.653 334.087 320.816 334.087 320.816L398.801 346.8C399.344 346.978 399.908 347.084 400.478 347.114C403.155 346.334 405.77 345.353 408.301 344.181C408.301 344.181 390.559 333.983 384.483 330.421C378.406 326.858 340.583 305.205 332.446 300.526L294.588 278.663L256.766 256.731Z"
          fill="#3B464B"
        />
      </g>
      <mask
        id="mask310_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask310_31_1526)">
        <path
          d="M256.766 256.731V258.477C257.918 262.947 267.243 287.918 276.323 293.925C285.403 299.932 334.262 320.956 334.262 320.956L398.836 346.87C399.379 347.048 399.943 347.154 400.513 347.184C403.179 346.403 405.782 345.422 408.301 344.25L384.483 330.49L332.481 300.456L294.588 278.733L256.766 256.731Z"
          fill="#3A464B"
        />
      </g>
      <mask
        id="mask311_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask311_31_1526)">
        <path
          d="M256.766 256.731V258.477C257.953 263.017 267.522 287.813 276.812 293.96C286.102 300.107 334.437 320.921 334.437 320.921L398.836 346.8C399.377 346.98 399.943 347.074 400.513 347.079C403.181 346.321 405.786 345.351 408.301 344.181L384.483 330.421L332.481 300.386C326.579 296.894 299.827 281.527 294.623 278.489C284.705 273.075 256.766 256.731 256.766 256.731Z"
          fill="#3A454A"
        />
      </g>
      <mask
        id="mask312_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask312_31_1526)">
        <path
          d="M256.766 256.731V258.512C257.953 263.192 267.802 287.813 277.301 294.135C286.8 300.456 334.541 321.061 334.541 321.061L398.871 346.87C399.411 347.053 399.977 347.148 400.548 347.149C403.205 346.378 405.798 345.397 408.301 344.215L384.483 330.455L332.481 300.421L294.588 278.698L256.766 256.731Z"
          fill="#39454A"
        />
      </g>
      <mask
        id="mask313_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask313_31_1526)">
        <path
          d="M256.766 256.731V258.512C257.988 263.297 268.046 287.743 277.72 294.204C287.394 300.665 334.646 321.096 334.646 321.096L398.836 346.905C399.381 347.071 399.944 347.165 400.513 347.184C403.171 346.412 405.763 345.432 408.266 344.25L384.413 330.49L332.411 300.456L294.623 278.733L256.766 256.731Z"
          fill="#394449"
        />
      </g>
      <mask
        id="mask314_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask314_31_1526)">
        <path
          d="M256.766 256.731V258.512C258.023 263.436 268.326 287.709 278.279 294.309C288.232 300.91 334.856 321.166 334.856 321.166L398.906 346.87C399.448 347.041 400.014 347.124 400.583 347.114C403.232 346.351 405.814 345.37 408.301 344.181L384.483 330.421L332.481 300.386L294.588 278.663C284.076 272.656 256.766 256.731 256.766 256.731Z"
          fill="#384449"
        />
      </g>
      <mask
        id="mask315_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask315_31_1526)">
        <path
          d="M256.766 256.731V258.512C258.058 263.576 268.57 287.639 278.768 294.414C288.966 301.189 334.995 321.375 334.995 321.375L398.906 347.044C399.445 347.231 400.012 347.326 400.583 347.324C403.243 346.575 405.837 345.605 408.336 344.425L384.483 330.455L332.481 300.63C325.985 296.894 300.351 282.086 294.623 278.733C283.867 272.482 256.766 256.731 256.766 256.731Z"
          fill="#384348"
        />
      </g>
      <mask
        id="mask316_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask316_31_1526)">
        <path
          d="M256.766 256.731V258.512C258.093 263.646 268.85 287.569 279.257 294.519C289.664 301.469 335.135 321.27 335.135 321.27L398.906 347.009C399.448 347.181 400.014 347.263 400.583 347.254C403.22 346.504 405.79 345.534 408.266 344.355L384.448 330.595L332.446 300.561L294.588 278.698L256.766 256.731Z"
          fill="#374348"
        />
      </g>
      <mask
        id="mask317_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask317_31_1526)">
        <path
          d="M256.766 256.731V258.512C258.128 263.751 269.094 287.534 279.746 294.623C290.398 301.713 335.31 321.305 335.31 321.305L398.976 346.905C399.532 346.987 400.097 346.987 400.652 346.905C403.286 346.143 405.855 345.174 408.336 344.006L384.518 330.246L332.516 300.211L294.623 278.663L256.766 256.731Z"
          fill="#364247"
        />
      </g>
      <mask
        id="mask318_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask318_31_1526)">
        <path
          d="M256.766 256.731V258.582C258.128 263.89 269.373 287.534 280.235 294.763C291.096 301.992 335.449 321.445 335.449 321.445L398.976 346.94C399.52 347.097 400.086 347.168 400.652 347.149C403.282 346.408 405.841 345.438 408.301 344.25L384.483 330.49L332.446 300.456L294.554 278.733L256.766 256.731Z"
          fill="#364247"
        />
      </g>
      <mask
        id="mask319_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask319_31_1526)">
        <path
          d="M256.766 256.731V258.582C258.163 264.065 269.618 287.429 280.724 294.798C291.83 302.167 335.589 321.48 335.589 321.48L399.046 346.905C399.579 347.06 400.133 347.131 400.687 347.114C403.328 346.374 405.899 345.404 408.371 344.215L384.518 330.455L332.481 300.421L294.623 278.698L256.766 256.731Z"
          fill="#354147"
        />
      </g>
      <mask
        id="mask320_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask320_31_1526)">
        <path
          d="M256.766 256.731V258.582C258.198 264.135 269.897 287.429 281.213 294.903C292.528 302.377 335.694 321.62 335.694 321.62L398.976 347.044C399.532 347.13 400.097 347.13 400.652 347.044C403.278 346.328 405.828 345.357 408.266 344.146L384.448 330.386C376.625 325.915 342.818 306.358 332.411 300.351L294.554 278.663L256.766 256.731Z"
          fill="#354146"
        />
      </g>
      <mask
        id="mask321_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask321_31_1526)">
        <path
          d="M256.766 256.731V258.617C258.233 264.275 270.142 287.394 281.702 295.043C293.261 302.691 335.904 321.585 335.904 321.585L399.046 346.905C399.602 346.987 400.167 346.987 400.722 346.905C403.347 346.183 405.896 345.212 408.336 344.006C408.336 344.006 392.48 334.891 384.518 330.246L332.481 300.211L294.588 278.663C282.4 271.678 256.766 256.731 256.766 256.731Z"
          fill="#344045"
        />
      </g>
      <mask
        id="mask322_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask322_31_1526)">
        <path
          d="M256.766 256.731V258.617C258.268 264.414 270.421 287.324 282.19 295.147C293.96 302.97 336.043 321.655 336.043 321.655L398.906 346.94C399.462 347.025 400.027 347.025 400.583 346.94C403.197 346.223 405.736 345.252 408.161 344.041L384.343 330.281L332.306 300.246L294.588 278.698L256.766 256.731Z"
          fill="#344045"
        />
      </g>
      <mask
        id="mask323_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask323_31_1526)">
        <path
          d="M256.766 256.731V258.617C258.268 264.519 270.735 287.22 282.679 295.252C294.623 303.285 336.183 321.69 336.183 321.69L399.046 346.94C399.601 347.027 400.167 347.027 400.722 346.94C403.344 346.244 405.884 345.272 408.301 344.041L384.483 330.281L332.446 300.246L294.588 278.698L256.766 256.731Z"
          fill="#333F45"
        />
      </g>
      <mask
        id="mask324_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask324_31_1526)">
        <path
          d="M256.766 256.731V258.652C258.303 264.694 270.945 287.255 283.168 295.357C295.392 303.459 336.323 321.794 336.323 321.794L399.186 346.974C399.728 347.073 400.284 347.073 400.827 346.974C403.439 346.282 405.968 345.311 408.371 344.076L384.553 330.316L332.516 300.281L294.519 278.698L256.766 256.731Z"
          fill="#333F44"
        />
      </g>
      <mask
        id="mask325_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask325_31_1526)">
        <path
          d="M256.766 256.731V258.652C258.337 264.798 271.189 287.185 283.657 295.462C296.125 303.739 336.497 321.829 336.497 321.829L399.116 346.974C399.659 347.07 400.214 347.07 400.757 346.974C403.374 346.298 405.905 345.326 408.301 344.076C408.301 344.076 392.969 335.519 384.448 330.56L332.411 300.526L294.554 278.663L256.766 256.731Z"
          fill="#323E44"
        />
      </g>
      <mask
        id="mask326_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask326_31_1526)">
        <path
          d="M256.766 256.731V258.652C258.372 264.903 271.469 287.115 284.146 295.566C296.824 304.018 336.532 321.864 336.532 321.864L399.046 346.94C399.59 347.022 400.143 347.022 400.687 346.94C403.285 346.241 405.802 345.269 408.196 344.041L384.378 330.281L332.341 300.246L294.554 278.663L256.766 256.731Z"
          fill="#323E43"
        />
      </g>
      <mask
        id="mask327_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask327_31_1526)">
        <path
          d="M256.766 256.731V258.652C258.407 265.008 271.713 287.08 284.705 295.671C297.697 304.262 336.742 322.109 336.742 322.109L399.116 347.149C399.658 347.256 400.215 347.256 400.757 347.149C403.353 346.458 405.869 345.499 408.266 344.285L384.448 330.525L332.411 300.491L294.554 278.698L256.766 256.731Z"
          fill="#313D43"
        />
      </g>
      <mask
        id="mask328_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask328_31_1526)">
        <path
          d="M256.766 256.731V258.652C258.442 265.113 271.993 287.045 285.124 295.776C298.256 304.507 337.091 322.178 337.091 322.178L399.325 347.149C399.867 347.258 400.425 347.258 400.967 347.149C403.563 346.495 406.072 345.533 408.441 344.285L384.622 330.525L332.586 300.491L294.554 278.698L256.766 256.731Z"
          fill="#313D42"
        />
      </g>
      <mask
        id="mask329_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask329_31_1526)">
        <path
          d="M256.766 256.731V258.652C258.442 265.252 272.237 286.94 285.613 295.811C298.989 304.682 337.091 322.144 337.091 322.144L399.186 347.079C399.729 347.176 400.284 347.176 400.827 347.079C403.416 346.403 405.923 345.443 408.301 344.215L384.483 330.455L332.446 300.421L294.554 278.663L256.766 256.731Z"
          fill="#303C42"
        />
      </g>
      <mask
        id="mask330_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask330_31_1526)">
        <path
          d="M256.766 256.731V258.722C258.477 265.392 272.517 286.94 286.102 295.951C299.687 304.961 337.091 322.283 337.091 322.283L399.081 347.149C399.626 347.22 400.178 347.22 400.722 347.149C403.305 346.488 405.802 345.527 408.161 344.285L384.343 330.525L332.306 300.491L294.554 278.698L256.766 256.731Z"
          fill="#303C41"
        />
      </g>
      <mask
        id="mask331_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask331_31_1526)">
        <path
          d="M256.766 256.731V258.722C258.512 265.497 272.761 286.905 286.591 296.055C300.421 305.205 337.37 322.144 337.37 322.144L399.221 347.009C399.765 347.082 400.317 347.082 400.862 347.009C403.444 346.328 405.939 345.356 408.301 344.111C408.301 344.111 394.017 335.869 384.483 330.351L332.446 300.316L294.588 278.663L256.766 256.731Z"
          fill="#2F3B41"
        />
      </g>
      <mask
        id="mask332_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask332_31_1526)">
        <path
          d="M256.766 256.731V258.722C258.547 265.706 273.04 286.661 287.08 296.16C301.119 305.659 337.51 322.388 337.51 322.388L399.221 347.149C399.765 347.222 400.317 347.222 400.862 347.149C403.432 346.468 405.916 345.495 408.266 344.25C408.266 344.25 394.296 336.113 384.448 330.49L332.411 300.456L294.588 278.663L256.766 256.731Z"
          fill="#2E3B40"
        />
      </g>
      <mask
        id="mask333_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask333_31_1526)">
        <path
          d="M256.766 256.731V258.757C258.582 265.741 273.285 286.696 287.569 296.3C301.853 305.904 337.685 322.353 337.685 322.353L399.256 347.219C399.799 347.313 400.354 347.313 400.897 347.219C403.47 346.561 405.955 345.6 408.301 344.355L384.483 330.386C374.634 324.693 345.542 307.895 332.446 300.386C323.366 295.147 302.586 283.168 294.623 278.489L256.766 256.731Z"
          fill="#2E3A40"
        />
      </g>
      <mask
        id="mask334_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask334_31_1526)">
        <path
          d="M256.766 256.731V258.757C258.617 265.916 273.564 286.696 288.197 296.37C302.831 306.044 337.789 322.493 337.789 322.493L399.29 347.149C399.833 347.247 400.389 347.247 400.932 347.149C403.498 346.506 405.974 345.544 408.301 344.285L384.448 330.525L332.446 300.491L294.623 278.663C279.292 269.862 256.766 256.731 256.766 256.731Z"
          fill="#2D3A3F"
        />
      </g>
      <mask
        id="mask335_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask335_31_1526)">
        <path
          d="M256.766 256.731V258.757C258.617 266.021 273.809 286.696 288.547 296.474C303.285 306.253 337.964 322.423 337.964 322.423L399.256 347.184C399.799 347.27 400.353 347.27 400.897 347.184C403.469 346.542 405.946 345.568 408.266 344.285C408.266 344.285 394.611 336.427 384.448 330.525L332.411 300.491L294.588 278.698L256.766 256.731Z"
          fill="#2D3A3F"
        />
      </g>
      <mask
        id="mask336_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask336_31_1526)">
        <path
          d="M256.766 256.731V258.757C258.652 266.126 274.228 286.696 289.036 296.544C303.843 306.393 338.139 322.458 338.139 322.458L399.36 346.905C399.904 346.992 400.458 346.992 401.002 346.905C403.566 346.256 406.041 345.294 408.371 344.041L384.518 330.281L332.481 300.246L294.623 278.698L256.766 256.731Z"
          fill="#2C393F"
        />
      </g>
      <mask
        id="mask337_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask337_31_1526)">
        <path
          d="M256.766 256.731V258.757C258.687 266.23 274.228 286.696 289.525 296.649C304.821 306.602 338.418 322.563 338.418 322.563L399.5 347.009C400.043 347.108 400.599 347.108 401.141 347.009C403.702 346.385 406.169 345.422 408.475 344.146L384.657 330.386L332.621 300.351L294.658 278.733L256.766 256.731Z"
          fill="#2C383E"
        />
      </g>
      <mask
        id="mask338_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask338_31_1526)">
        <path
          d="M256.766 256.731V258.826C258.722 266.37 274.612 286.556 290.013 296.789C305.692 306.232 321.848 314.858 338.418 322.632L399.36 347.079C399.906 347.138 400.456 347.138 401.002 347.079C403.549 346.43 406.002 345.455 408.301 344.181C408.301 344.181 395.1 336.602 384.483 330.421L332.446 300.386L294.588 278.698L256.766 256.731Z"
          fill="#2B383D"
        />
      </g>
      <mask
        id="mask339_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask339_31_1526)">
        <path
          d="M256.766 256.731V258.826C258.757 266.475 274.856 286.521 290.502 296.894C306.066 306.296 322.106 314.887 338.558 322.632L399.36 347.079C399.906 347.139 400.456 347.139 401.002 347.079C403.556 346.452 406.012 345.476 408.301 344.181C408.301 344.181 395.239 336.637 384.483 330.421C373.726 324.204 346.765 308.663 332.446 300.351L294.588 278.663L256.766 256.731Z"
          fill="#2B383D"
        />
      </g>
      <mask
        id="mask340_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask340_31_1526)">
        <path
          d="M256.766 256.731V258.826C258.757 266.614 275.136 286.451 290.991 296.998C306.454 306.389 322.389 314.98 338.732 322.737L399.43 347.184C399.976 347.244 400.526 347.244 401.072 347.184C403.611 346.541 406.062 345.591 408.371 344.355L384.518 330.595L332.481 300.526C322.388 294.693 303.564 283.797 294.658 278.698L256.766 256.731Z"
          fill="#2A373D"
        />
      </g>
      <mask
        id="mask341_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask341_31_1526)">
        <path
          d="M256.766 256.731V258.861C258.791 266.754 275.415 286.451 291.48 297.068C306.808 306.55 322.614 315.234 338.837 323.086L399.395 347.533C399.939 347.613 400.492 347.613 401.037 347.533C403.567 346.9 406.008 345.949 408.301 344.704L384.483 330.944C373.377 324.518 347.184 309.431 332.446 300.875L294.623 278.733L256.766 256.731Z"
          fill="#2A363C"
        />
      </g>
      <mask
        id="mask342_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask342_31_1526)">
        <path
          d="M256.766 256.731V258.861C258.826 266.894 275.66 286.347 291.969 297.278C307.188 306.677 322.877 315.291 338.977 323.086L399.395 347.324C399.939 347.414 400.493 347.414 401.037 347.324C403.568 346.727 406.002 345.774 408.266 344.495L384.448 330.735L332.411 300.665L294.588 278.733C277.441 268.78 256.766 256.731 256.766 256.731Z"
          fill="#29363C"
        />
      </g>
      <mask
        id="mask343_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask343_31_1526)">
        <path
          d="M256.766 256.731V258.861C258.861 266.999 275.939 286.312 292.458 297.278C307.575 306.667 323.16 315.281 339.151 323.086L399.5 347.254C400.034 347.314 400.573 347.314 401.106 347.254C403.631 346.635 406.062 345.684 408.336 344.425L384.518 330.665L332.446 300.561L294.623 278.733L256.766 256.731Z"
          fill="#29363B"
        />
      </g>
      <mask
        id="mask344_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask344_31_1526)">
        <path
          d="M256.766 256.731V258.896C258.896 267.138 276.184 286.277 292.947 297.313C307.944 306.692 323.412 315.294 339.291 323.086L399.465 347.219C399.998 347.3 400.539 347.3 401.072 347.219C403.594 346.631 406.018 345.678 408.266 344.39L384.448 330.63L332.376 300.526L294.554 278.698L256.766 256.731Z"
          fill="#28353B"
        />
      </g>
      <mask
        id="mask345_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask345_31_1526)">
        <path
          d="M256.766 256.731V258.896C258.931 267.278 276.463 286.242 293.436 297.522C308.326 306.815 323.677 315.347 339.431 323.086L399.5 347.184C400.032 347.266 400.574 347.266 401.106 347.184C403.634 346.612 406.06 345.658 408.301 344.355L384.448 330.595L332.376 300.526L294.554 278.698L256.766 256.731Z"
          fill="#27353A"
        />
      </g>
      <mask
        id="mask346_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask346_31_1526)">
        <path
          d="M256.766 256.731V258.896C258.931 267.383 276.707 286.172 293.925 297.592C311.142 309.012 339.571 323.086 339.571 323.086L399.465 347.114C399.997 347.195 400.539 347.195 401.072 347.114C403.581 346.519 405.992 345.566 408.231 344.285L384.413 330.525L332.341 300.526L294.519 278.698L256.766 256.731Z"
          fill="#27343A"
        />
      </g>
      <mask
        id="mask347_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask347_31_1526)">
        <path
          d="M256.766 256.731V258.896C258.966 267.488 276.987 286.102 294.414 297.697C309.114 306.924 324.266 315.41 339.815 323.121L399.605 347.114C400.138 347.176 400.678 347.176 401.211 347.114C403.735 346.53 406.159 345.577 408.406 344.285L384.553 330.525L332.411 300.526L294.588 278.698L256.766 256.731Z"
          fill="#263439"
        />
      </g>
      <mask
        id="mask348_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask348_31_1526)">
        <path
          d="M256.766 256.731V258.896C259.001 267.592 277.231 286.067 294.903 297.802C312.574 309.536 339.885 323.366 339.885 323.366L399.535 347.289C400.068 347.359 400.608 347.359 401.141 347.289C403.599 346.705 405.954 345.751 408.126 344.46L384.308 330.7L332.376 300.526L294.554 278.698L256.766 256.731Z"
          fill="#263339"
        />
      </g>
      <mask
        id="mask349_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask349_31_1526)">
        <path
          d="M256.766 256.731V258.896C259.036 267.697 277.511 286.032 295.392 297.906C313.273 309.78 340.059 323.226 340.059 323.226L399.43 347.114C399.963 347.185 400.503 347.185 401.037 347.114C403.493 346.524 405.847 345.571 408.021 344.285C408.021 344.285 396.531 337.685 384.203 330.525C371.875 323.366 348.581 309.955 332.132 300.456L294.554 278.663L256.766 256.731Z"
          fill="#253338"
        />
      </g>
      <mask
        id="mask350_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask350_31_1526)">
        <path
          d="M256.766 256.731V258.966C259.071 267.872 277.72 285.962 295.881 298.046C314.041 310.13 340.199 323.331 340.199 323.331L399.57 347.184C400.103 347.254 400.643 347.254 401.176 347.184C403.64 346.618 405.998 345.663 408.161 344.355L384.343 330.595C372.015 323.366 349 310.165 332.376 300.561L294.554 278.733L256.766 256.731Z"
          fill="#253238"
        />
      </g>
      <mask
        id="mask351_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask351_31_1526)">
        <path
          d="M256.766 256.731V258.966C259.071 267.977 278.035 285.927 296.37 298.116C314.705 310.304 340.374 323.401 340.374 323.401L399.744 347.184C400.291 347.223 400.839 347.223 401.386 347.184C403.848 346.612 406.204 345.657 408.371 344.355L384.518 330.595L332.411 300.526L294.588 278.698L256.766 256.731Z"
          fill="#243237"
        />
      </g>
      <mask
        id="mask352_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask352_31_1526)">
        <path
          d="M256.766 256.731V258.966C259.106 268.116 278.279 285.893 296.859 298.186C315.438 310.479 340.583 323.575 340.583 323.575L399.605 347.254C400.139 347.303 400.677 347.303 401.211 347.254C403.669 346.668 406.024 345.714 408.196 344.425C408.196 344.425 397.195 338.069 384.378 330.665L332.376 300.491L294.554 278.663L256.766 256.731Z"
          fill="#243137"
        />
      </g>
      <mask
        id="mask353_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask353_31_1526)">
        <path
          d="M256.766 256.731V259.001C259.141 268.256 278.558 285.858 297.347 298.36C316.137 310.863 340.583 323.68 340.583 323.68L399.605 347.533C400.139 347.591 400.677 347.591 401.211 347.533C403.678 346.994 406.038 346.05 408.196 344.739L384.378 330.979L332.376 300.595L294.554 278.768L256.766 256.731Z"
          fill="#233136"
        />
      </g>
      <mask
        id="mask354_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask354_31_1526)">
        <path
          d="M256.766 256.731V259.001C259.176 268.361 278.803 285.788 297.836 298.43C316.87 311.073 340.793 323.575 340.793 323.575L399.675 347.184C400.209 347.221 400.746 347.221 401.281 347.184C403.746 346.641 406.106 345.697 408.266 344.39L384.448 330.63L332.376 300.561L294.554 278.733L256.766 256.731Z"
          fill="#223036"
        />
      </g>
      <mask
        id="mask355_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask355_31_1526)">
        <path
          d="M256.766 256.731V259.001C259.211 268.5 279.082 285.753 298.325 298.535C317.568 311.317 340.933 323.75 340.933 323.75L399.675 347.324C400.221 347.369 400.77 347.369 401.316 347.324C403.784 346.791 406.146 345.846 408.301 344.53L384.448 330.77L332.411 300.526L294.588 278.698L256.766 256.731Z"
          fill="#223035"
        />
      </g>
      <mask
        id="mask356_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask356_31_1526)">
        <path
          d="M256.766 256.731V259.036C259.245 268.64 279.327 285.718 298.675 298.64C318.022 311.562 340.967 323.68 340.967 323.68L399.57 347.184C400.104 347.228 400.642 347.228 401.176 347.184C403.648 346.644 406.01 345.687 408.161 344.355C408.161 344.355 397.684 338.348 384.343 330.595L332.376 300.491L294.554 278.663L256.766 256.731Z"
          fill="#212F35"
        />
      </g>
      <mask
        id="mask357_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask357_31_1526)">
        <path
          d="M256.766 256.731V259.036C259.245 268.745 279.606 285.648 299.303 298.745C319 311.841 341.212 323.75 341.212 323.75L399.71 347.533C400.256 347.576 400.805 347.576 401.351 347.533C403.82 347.003 406.182 346.058 408.336 344.739L384.483 330.979L332.411 300.561L294.588 278.733L256.766 256.731Z"
          fill="#212F34"
        />
      </g>
      <mask
        id="mask358_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask358_31_1526)">
        <path
          d="M256.766 256.731V259.036C259.28 268.85 279.851 285.613 299.792 298.849C319.734 312.085 341.387 323.82 341.387 323.82L399.744 347.184C400.279 347.227 400.816 347.227 401.351 347.184C403.827 346.657 406.191 345.699 408.336 344.355L384.483 330.595L332.341 300.491L294.519 278.663L256.766 256.731Z"
          fill="#202E34"
        />
      </g>
      <mask
        id="mask359_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask359_31_1526)">
        <path
          d="M256.766 256.731V259.036C259.315 268.954 280.13 285.578 300.281 298.919C320.432 312.26 341.596 323.89 341.596 323.89L399.954 347.533C400.483 347.514 401.01 347.443 401.526 347.324C403.997 346.8 406.359 345.855 408.51 344.53L384.657 330.77L332.376 300.561L294.519 278.733L256.766 256.731Z"
          fill="#202E33"
        />
      </g>
      <mask
        id="mask360_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask360_31_1526)">
        <path
          d="M256.766 256.731V259.036C259.35 269.094 280.374 285.473 300.77 299.024C321.166 312.574 341.701 323.89 341.701 323.89L399.954 347.324C400.477 347.365 401.003 347.365 401.526 347.324C404.011 346.828 406.38 345.868 408.51 344.495L384.657 330.735L332.306 300.491L294.484 278.663L256.766 256.731Z"
          fill="#1F2D33"
        />
      </g>
      <mask
        id="mask361_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask361_31_1526)">
        <path
          d="M256.766 256.731V259.106C259.385 269.269 280.654 285.473 301.259 299.164C321.864 312.854 341.806 324.134 341.806 324.134L399.954 347.533C402.98 347.213 405.887 346.184 408.441 344.53L384.587 330.77L332.341 300.561L256.766 256.731Z"
          fill="#1E2C32"
        />
      </g>
      <mask
        id="mask362_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask362_31_1526)">
        <path
          d="M113.578 347.533C110.505 347.183 107.554 346.132 104.952 344.46L256.766 256.731V289.909L113.578 347.533Z"
          fill="black"
        />
      </g>
      <mask
        id="mask363_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask363_31_1526)">
        <path
          d="M105.056 344.32L256.766 256.731C256.766 256.906 256.766 289.699 255.893 290.153L113.578 347.324C110.535 346.984 107.609 345.957 105.021 344.32"
          fill="#000102"
        />
      </g>
      <mask
        id="mask364_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask364_31_1526)">
        <path
          d="M105.056 344.32L256.766 256.731C256.766 257.08 256.766 289.525 254.985 290.398C254.461 290.677 113.578 347.324 113.578 347.324C110.564 347.001 107.668 345.972 105.126 344.32"
          fill="#010304"
        />
      </g>
      <mask
        id="mask365_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask365_31_1526)">
        <path
          d="M105.056 344.32L256.766 256.731C256.766 257.255 256.766 289.315 254.112 290.642C253.274 291.061 113.578 347.324 113.578 347.324C110.595 346.96 107.731 345.934 105.196 344.32"
          fill="#020406"
        />
      </g>
      <mask
        id="mask366_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask366_31_1526)">
        <path
          d="M105.091 344.32L256.766 256.731C256.766 257.429 256.591 289.105 253.274 290.852C252.4 291.306 113.578 347.184 113.578 347.184C110.637 346.871 107.813 345.866 105.336 344.25"
          fill="#030608"
        />
      </g>
      <mask
        id="mask367_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask367_31_1526)">
        <path
          d="M105.091 344.32L256.766 256.731C256.766 257.604 256.591 288.896 252.331 291.096C251.213 291.655 113.438 346.974 113.438 346.974C110.529 346.644 107.733 345.652 105.266 344.076"
          fill="#04080A"
        />
      </g>
      <mask
        id="mask368_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask368_31_1526)">
        <path
          d="M105.091 344.32L256.766 256.731C256.766 257.814 256.487 288.756 251.457 291.376C250.13 292.074 113.403 347.254 113.403 347.254C110.509 346.905 107.729 345.915 105.266 344.355"
          fill="#050A0C"
        />
      </g>
      <mask
        id="mask369_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask369_31_1526)">
        <path
          d="M105.091 344.32L256.556 256.731C256.556 257.953 256.242 288.512 250.34 291.655C248.803 292.458 113.124 347.149 113.124 347.149C110.263 346.795 107.518 345.805 105.091 344.25"
          fill="#050B0E"
        />
      </g>
      <mask
        id="mask370_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask370_31_1526)">
        <path
          d="M105.091 344.32L256.521 256.731C256.521 258.093 256.172 288.163 249.537 291.655C247.79 292.563 113.333 346.87 113.333 346.87C110.493 346.567 107.765 345.598 105.371 344.041"
          fill="#060D10"
        />
      </g>
      <mask
        id="mask371_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask371_31_1526)">
        <path
          d="M105.091 344.32L256.487 257.01C256.487 258.582 256.102 288.442 248.559 292.318C246.533 293.401 113.019 347.254 113.019 347.254C110.21 346.91 107.514 345.944 105.126 344.425"
          fill="#070E11"
        />
      </g>
      <mask
        id="mask372_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask372_31_1526)">
        <path
          d="M105.091 344.32L256.452 257.01C256.452 258.722 255.998 288.197 247.581 292.563C245.381 293.75 112.879 347.254 112.879 347.254C110.109 346.886 107.452 345.921 105.091 344.425"
          fill="#081013"
        />
      </g>
      <mask
        id="mask373_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask373_31_1526)">
        <path
          d="M105.091 344.32L256.417 257.01C256.417 258.896 255.928 287.988 246.708 292.807C244.263 294.065 112.809 347.184 112.809 347.184C110.075 346.827 107.452 345.873 105.126 344.39"
          fill="#091114"
        />
      </g>
      <mask
        id="mask374_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask374_31_1526)">
        <path
          d="M105.091 344.32L256.417 257.01C256.417 259.071 255.893 287.778 245.939 293.017C243.285 294.414 112.914 347.114 112.914 347.114C110.195 346.78 107.584 345.85 105.266 344.39"
          fill="#0A1316"
        />
      </g>
      <mask
        id="mask375_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask375_31_1526)">
        <path
          d="M105.091 344.32L256.347 257.01C256.347 259.246 255.788 287.569 244.822 293.261C241.923 294.763 112.635 347.079 112.635 347.079C109.954 346.722 107.382 345.793 105.091 344.355"
          fill="#0B1417"
        />
      </g>
      <mask
        id="mask376_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask376_31_1526)">
        <path
          d="M105.091 344.32C105.51 344.041 256.312 257.01 256.312 257.01C256.312 259.42 255.718 287.359 243.914 293.506C240.806 295.112 112.565 347.044 112.565 347.044C109.905 346.714 107.352 345.795 105.091 344.355"
          fill="#0C1519"
        />
      </g>
      <mask
        id="mask377_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask377_31_1526)">
        <path
          d="M105.091 344.32L256.312 257.01C256.312 259.595 255.613 287.185 243.006 293.785C239.513 295.462 112.425 347.044 112.425 347.044C109.822 346.68 107.331 345.751 105.126 344.32"
          fill="#0D161A"
        />
      </g>
      <mask
        id="mask378_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask378_31_1526)">
        <path
          d="M105.126 344.32L256.312 257.01C256.312 259.769 255.613 286.975 242.133 293.96C238.64 295.811 112.425 346.94 112.425 346.94C109.84 346.614 107.359 345.719 105.161 344.32"
          fill="#0E181B"
        />
      </g>
      <mask
        id="mask379_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask379_31_1526)">
        <path
          d="M105.126 344.32L256.242 257.01C256.242 259.944 255.509 286.766 241.19 294.239C237.418 296.16 112.321 346.905 112.321 346.905C109.756 346.582 107.297 345.687 105.126 344.285"
          fill="#0F191D"
        />
      </g>
      <mask
        id="mask380_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask380_31_1526)">
        <path
          d="M105.126 344.32L256.207 257.01C256.207 260.119 255.439 286.556 240.247 294.484C236.266 296.509 112.216 346.87 112.216 346.87C109.726 346.51 107.343 345.616 105.231 344.25"
          fill="#0F1A1E"
        />
      </g>
      <mask
        id="mask381_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask381_31_1526)">
        <path
          d="M105.126 344.32L256.207 257.01C256.207 260.293 255.369 286.381 239.374 294.658C235.148 296.824 112.181 346.8 112.181 346.8C109.698 346.454 107.318 345.585 105.196 344.25"
          fill="#101B1F"
        />
      </g>
      <mask
        id="mask382_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask382_31_1526)">
        <path
          d="M105.126 344.32L256.207 257.01C256.207 260.503 255.334 286.137 238.466 294.868C234.03 297.208 112.111 346.73 112.111 346.73C109.625 346.421 107.239 345.562 105.126 344.215"
          fill="#111C21"
        />
      </g>
      <mask
        id="mask383_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask383_31_1526)">
        <path
          d="M105.126 344.32L256.137 257.01C256.137 260.503 255.229 285.962 237.523 295.147C232.878 297.557 112.006 346.73 112.006 346.73C109.517 346.433 107.129 345.573 105.021 344.215"
          fill="#121D22"
        />
      </g>
      <mask
        id="mask384_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask384_31_1526)">
        <path
          d="M105.126 344.32L256.102 257.01C256.102 260.817 255.124 285.753 236.615 295.427C231.76 297.941 111.936 346.73 111.936 346.73C109.526 346.402 107.214 345.556 105.161 344.25"
          fill="#131E23"
        />
      </g>
      <mask
        id="mask385_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask385_31_1526)">
        <path
          d="M105.126 344.32L256.102 257.01C256.102 260.957 255.09 285.543 235.707 295.636C230.608 298.29 111.866 346.625 111.866 346.625C109.482 346.299 107.196 345.465 105.161 344.181"
          fill="#131F24"
        />
      </g>
      <mask
        id="mask386_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask386_31_1526)">
        <path
          d="M105.126 344.32L256.032 257.01C256.032 261.131 254.985 285.404 234.764 295.881C229.455 298.64 111.762 346.73 111.762 346.73C109.399 346.426 107.133 345.603 105.126 344.32Z"
          fill="#142025"
        />
      </g>
      <mask
        id="mask387_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask387_31_1526)">
        <path
          d="M105.126 344.32L255.998 257.22C255.998 261.516 254.95 285.159 233.891 296.3C228.338 299.164 111.657 346.73 111.657 346.73C109.338 346.383 107.115 345.562 105.126 344.32Z"
          fill="#152126"
        />
      </g>
      <mask
        id="mask388_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask388_31_1526)">
        <path
          d="M105.126 344.32L255.963 257.22C255.963 261.655 254.81 285.159 232.913 296.544C227.15 299.548 111.552 346.73 111.552 346.73C109.274 346.37 107.09 345.563 105.126 344.355"
          fill="#162227"
        />
      </g>
      <mask
        id="mask389_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask389_31_1526)">
        <path
          d="M105.126 344.32L255.928 257.22C255.939 265.368 253.714 273.362 249.496 280.333C245.278 287.304 239.228 292.984 232.005 296.754C226.033 299.862 111.482 346.66 111.482 346.66C109.222 346.34 107.055 345.542 105.126 344.32Z"
          fill="#172328"
        />
      </g>
      <mask
        id="mask390_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask390_31_1526)">
        <path
          d="M105.161 344.32L255.928 257.22C255.894 265.498 253.556 273.604 249.177 280.629C244.798 287.655 238.55 293.323 231.132 296.998C224.915 300.211 111.447 346.66 111.447 346.66C109.207 346.345 107.062 345.546 105.161 344.32Z"
          fill="#172429"
        />
      </g>
      <mask
        id="mask391_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask391_31_1526)">
        <path
          d="M105.161 344.39L255.928 257.325C255.828 265.735 253.365 273.948 248.82 281.025C244.274 288.102 237.83 293.758 230.224 297.348C223.798 300.84 111.482 346.695 111.482 346.695C109.289 346.346 107.187 345.562 105.301 344.39"
          fill="#18252B"
        />
      </g>
      <mask
        id="mask392_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask392_31_1526)">
        <path
          d="M105.161 344.39L255.928 257.325C256.102 262.493 254.566 284.461 229.351 297.592C222.715 301.084 111.308 346.486 111.308 346.486C109.129 346.141 107.04 345.37 105.161 344.215"
          fill="#19262C"
        />
      </g>
      <mask
        id="mask393_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask393_31_1526)">
        <path
          d="M105.161 344.39L255.893 257.36C255.893 262.703 254.531 284.286 228.443 297.836C221.458 301.329 111.273 346.73 111.273 346.73C109.121 346.389 107.056 345.629 105.196 344.495"
          fill="#1A272D"
        />
      </g>
      <mask
        id="mask394_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask394_31_1526)">
        <path
          d="M105.161 344.39L255.823 257.36C255.998 262.878 254.461 284.076 227.5 298.081C220.515 301.573 111.168 346.59 111.168 346.59C109.053 346.253 107.024 345.506 105.196 344.39"
          fill="#1B282E"
        />
      </g>
      <mask
        id="mask395_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask395_31_1526)">
        <path
          d="M105.161 344.39L255.823 257.395C255.998 263.087 254.356 283.937 226.592 298.325C219.293 302.132 111.098 346.555 111.098 346.555C109.005 346.218 106.999 345.47 105.196 344.355"
          fill="#1B292F"
        />
      </g>
      <mask
        id="mask396_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask396_31_1526)">
        <path
          d="M105.161 344.39L255.753 257.395C255.963 263.262 254.251 283.727 225.649 298.605C218.105 302.516 110.993 346.52 110.993 346.52C108.926 346.208 106.943 345.484 105.161 344.39Z"
          fill="#1C2A30"
        />
      </g>
      <mask
        id="mask397_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask397_31_1526)">
        <path
          d="M105.161 344.39L255.718 257.43C255.928 263.471 254.182 283.553 224.706 298.849C216.953 302.866 110.854 346.486 110.854 346.486C108.835 346.175 106.899 345.462 105.161 344.39Z"
          fill="#1D2B31"
        />
      </g>
      <mask
        id="mask398_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask398_31_1526)">
        <path
          d="M105.161 344.39L255.683 257.43C255.893 263.646 254.112 283.343 223.798 299.094C215.835 303.25 110.784 346.451 110.784 346.451C108.797 346.123 106.889 345.424 105.161 344.39Z"
          fill="#1E2C32"
        />
      </g>
      <mask
        id="mask399_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask399_31_1526)">
        <path
          d="M105.161 344.39L255.648 257.464C255.858 263.855 254.042 283.203 222.855 299.373C214.648 303.634 110.679 346.451 110.679 346.451C108.727 346.114 106.856 345.415 105.161 344.39Z"
          fill="#1F2D33"
        />
      </g>
      <mask
        id="mask400_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask400_31_1526)">
        <path
          d="M105.161 344.39L255.613 257.464C255.823 264.03 253.972 282.994 221.947 299.618C213.53 303.983 110.644 346.416 110.644 346.416C108.716 346.092 106.867 345.405 105.196 344.39"
          fill="#1F2E34"
        />
      </g>
      <mask
        id="mask401_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask401_31_1526)">
        <path
          d="M105.161 344.39L255.579 257.499C255.788 264.205 253.867 282.819 221.039 299.862C212.413 304.332 110.539 346.381 110.539 346.381C108.638 346.06 106.813 345.384 105.161 344.39Z"
          fill="#202E34"
        />
      </g>
      <mask
        id="mask402_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask402_31_1526)">
        <path
          d="M105.196 344.39L255.578 257.499C255.823 264.484 253.832 282.61 220.131 300.107C211.365 304.716 110.47 346.346 110.47 346.346C108.605 346.029 106.816 345.366 105.196 344.39Z"
          fill="#212F35"
        />
      </g>
      <mask
        id="mask403_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask403_31_1526)">
        <path
          d="M105.196 344.39L255.544 257.534C255.823 264.519 253.797 282.435 219.223 300.386C210.142 305.066 110.4 346.346 110.4 346.346C108.555 346.035 106.789 345.371 105.196 344.39Z"
          fill="#213035"
        />
      </g>
      <mask
        id="mask404_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask404_31_1526)">
        <path
          d="M105.196 344.39L255.544 257.534C255.788 264.763 253.693 282.26 218.315 300.63C209.025 305.624 110.365 346.311 110.365 346.311C108.537 346 106.783 345.348 105.196 344.39Z"
          fill="#223036"
        />
      </g>
      <mask
        id="mask405_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask405_31_1526)">
        <path
          d="M105.196 344.39L255.544 257.569C255.788 264.973 253.658 282.016 217.407 300.875C207.872 305.834 110.26 346.276 110.26 346.276C108.469 345.97 106.751 345.33 105.196 344.39Z"
          fill="#233137"
        />
      </g>
      <mask
        id="mask406_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask406_31_1526)">
        <path
          d="M105.196 344.39L255.369 257.569C255.613 265.148 253.448 282.016 216.394 301.119C206.755 306.183 110.085 346.241 110.085 346.241C108.319 345.943 106.625 345.315 105.091 344.39"
          fill="#233137"
        />
      </g>
      <mask
        id="mask407_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask407_31_1526)">
        <path
          d="M105.196 344.39L255.369 257.604C255.648 265.357 253.413 281.702 215.486 301.399C205.567 306.567 110.085 346.241 110.085 346.241C108.348 345.918 106.681 345.291 105.161 344.39"
          fill="#243238"
        />
      </g>
      <mask
        id="mask408_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask408_31_1526)">
        <path
          d="M105.196 344.39L255.369 257.604C255.648 265.532 253.343 281.527 214.613 301.643C204.38 306.917 110.085 346.206 110.085 346.206C108.392 345.901 106.77 345.285 105.301 344.39"
          fill="#253238"
        />
      </g>
      <mask
        id="mask409_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask409_31_1526)">
        <path
          d="M105.196 344.39L255.369 257.639C255.648 265.741 253.308 281.352 213.74 301.888C203.332 307.301 110.085 346.171 110.085 346.171C108.416 345.877 106.817 345.273 105.371 344.39"
          fill="#263339"
        />
      </g>
      <mask
        id="mask410_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask410_31_1526)">
        <path
          d="M105.196 344.425L255.369 257.674C255.613 265.951 253.274 281.178 212.797 302.132C202.319 307.65 109.806 346.136 109.806 346.136C108.182 345.817 106.624 345.227 105.196 344.39"
          fill="#263439"
        />
      </g>
      <mask
        id="mask411_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask411_31_1526)">
        <path
          d="M105.196 344.425L255.369 257.674C255.648 266.125 253.239 280.968 211.958 302.411C200.888 308.034 109.736 346.171 109.736 346.171C108.144 345.82 106.613 345.232 105.196 344.425Z"
          fill="#27343A"
        />
      </g>
      <mask
        id="mask412_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask412_31_1526)">
        <path
          d="M105.196 344.425L255.369 257.674C255.648 266.335 253.169 280.794 211.085 302.656C200.015 308.418 109.806 346.066 109.806 346.066C108.231 345.785 106.718 345.229 105.336 344.425"
          fill="#28353A"
        />
      </g>
      <mask
        id="mask413_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask413_31_1526)">
        <path
          d="M105.231 344.425L255.404 257.744C255.683 266.51 253.169 280.619 210.212 302.935C198.897 308.803 109.736 346.066 109.736 346.066C108.204 345.751 106.731 345.197 105.371 344.425"
          fill="#28353B"
        />
      </g>
      <mask
        id="mask414_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask414_31_1526)">
        <path
          d="M105.231 344.425L255.404 257.744C255.718 266.719 253.169 280.444 209.339 303.145C197.64 309.117 109.527 346.066 109.527 346.066C108.011 345.769 106.559 345.214 105.231 344.425Z"
          fill="#29363C"
        />
      </g>
      <mask
        id="mask415_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask415_31_1526)">
        <path
          d="M105.231 344.425L255.194 257.779C255.509 266.929 252.889 280.27 208.257 303.459C196.522 309.571 109.457 346.066 109.457 346.066C107.973 345.738 106.548 345.184 105.231 344.425Z"
          fill="#2A363C"
        />
      </g>
      <mask
        id="mask416_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask416_31_1526)">
        <path
          d="M105.231 344.425L255.159 257.779C255.474 267.068 252.819 280.06 207.314 303.669C195.335 309.885 109.352 345.962 109.352 345.962C107.899 345.693 106.505 345.173 105.231 344.425Z"
          fill="#2A373D"
        />
      </g>
      <mask
        id="mask417_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask417_31_1526)">
        <path
          d="M105.231 344.425L255.159 257.779C255.474 267.243 252.75 279.92 206.441 303.913C194.252 310.234 109.317 345.822 109.317 345.822C107.895 345.524 106.528 345.005 105.266 344.285"
          fill="#2B383D"
        />
      </g>
      <mask
        id="mask418_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask418_31_1526)">
        <path
          d="M105.231 344.425L255.124 257.779C255.439 267.453 252.68 279.676 205.498 304.158C193.1 310.584 109.212 346.066 109.212 346.066C107.818 345.748 106.477 345.231 105.231 344.53"
          fill="#2C383E"
        />
      </g>
      <mask
        id="mask419_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask419_31_1526)">
        <path
          d="M105.231 344.425L255.09 257.849C255.439 267.627 252.61 279.501 204.59 304.437C191.947 311.003 109.108 345.962 109.108 345.962C107.747 345.641 106.441 345.123 105.231 344.425Z"
          fill="#2C393E"
        />
      </g>
      <mask
        id="mask420_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask420_31_1526)">
        <path
          d="M105.231 344.425L255.055 257.849C255.439 267.837 252.54 279.327 203.682 304.647C190.83 311.352 109.038 345.857 109.038 345.857C107.707 345.601 106.431 345.116 105.266 344.425"
          fill="#2D393F"
        />
      </g>
      <mask
        id="mask421_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask421_31_1526)">
        <path
          d="M105.231 344.425L255.02 257.883C255.369 268.046 252.435 279.117 202.634 304.926C189.572 311.911 108.828 345.857 108.828 345.857C107.53 345.564 106.283 345.082 105.126 344.425"
          fill="#2D3A3F"
        />
      </g>
      <mask
        id="mask422_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask422_31_1526)">
        <path
          d="M105.231 344.425L254.985 257.883C255.334 268.361 252.365 278.838 201.831 305.205C188.525 312.19 108.863 345.857 108.863 345.857C107.636 345.552 106.459 345.069 105.371 344.425"
          fill="#2E3A40"
        />
      </g>
      <mask
        id="mask423_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask423_31_1526)">
        <path
          d="M105.231 344.425L254.95 257.883C255.334 268.361 252.331 278.838 200.923 305.45C187.407 312.435 108.793 345.857 108.793 345.857C107.57 345.54 106.395 345.058 105.301 344.425"
          fill="#2F3B40"
        />
      </g>
      <mask
        id="mask424_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask424_31_1526)">
        <path
          d="M105.231 344.425L254.915 257.883C255.264 268.57 252.191 278.558 199.98 305.659C186.254 312.784 108.688 345.787 108.688 345.787C107.47 345.488 106.295 345.03 105.196 344.425"
          fill="#2F3C41"
        />
      </g>
      <mask
        id="mask425_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask425_31_1526)">
        <path
          d="M105.266 344.425L254.915 257.918C255.264 268.78 252.156 278.384 199.037 305.939C185.067 313.238 108.584 345.787 108.584 345.787C107.361 345.501 106.185 345.043 105.091 344.425"
          fill="#303C41"
        />
      </g>
      <mask
        id="mask426_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask426_31_1526)">
        <path
          d="M105.266 344.425L254.88 257.918C255.264 268.989 252.086 278.209 198.198 306.183C184.019 313.552 108.584 345.717 108.584 345.717C107.358 345.459 106.179 345.011 105.091 344.39"
          fill="#313D42"
        />
      </g>
      <mask
        id="mask427_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask427_31_1526)">
        <path
          d="M105.266 344.425L254.845 257.988C255.229 269.199 252.051 278.069 197.29 306.498C182.867 313.971 108.514 345.752 108.514 345.752C107.386 345.464 106.304 345.017 105.301 344.425"
          fill="#313D43"
        />
      </g>
      <mask
        id="mask428_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask428_31_1526)">
        <path
          d="M105.266 344.425L254.81 257.988C255.194 269.373 251.946 277.86 196.348 306.672C181.714 314.251 108.409 345.682 108.409 345.682C107.312 345.398 106.256 344.976 105.266 344.425Z"
          fill="#323E43"
        />
      </g>
      <mask
        id="mask429_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask429_31_1526)">
        <path
          d="M105.266 344.46L254.81 258.058C255.194 269.618 251.877 277.72 195.439 306.952C180.597 314.67 108.304 345.647 108.304 345.647C107.247 345.344 106.228 344.923 105.266 344.39"
          fill="#333E44"
        />
      </g>
      <mask
        id="mask430_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask430_31_1526)">
        <path
          d="M105.266 344.46L254.775 258.058C255.159 269.793 251.807 277.511 194.531 307.266C179.479 315.089 108.234 345.682 108.234 345.682C107.202 345.388 106.206 344.978 105.266 344.46Z"
          fill="#333F44"
        />
      </g>
      <mask
        id="mask431_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask431_31_1526)">
        <path
          d="M105.266 344.46L254.74 258.093C255.124 269.967 251.737 277.371 193.623 307.545C178.362 315.473 108.165 345.682 108.165 345.682C107.162 345.366 106.192 344.957 105.266 344.46Z"
          fill="#343F44"
        />
      </g>
      <mask
        id="mask432_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask432_31_1526)">
        <path
          d="M105.266 344.46L254.705 258.093C255.124 270.142 251.632 277.161 192.68 307.755C177.174 315.822 108.06 345.612 108.06 345.612C107.093 345.321 106.157 344.935 105.266 344.46Z"
          fill="#344045"
        />
      </g>
      <mask
        id="mask433_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask433_31_1526)">
        <path
          d="M105.266 344.46L254.67 258.128C255.09 270.351 251.562 276.987 191.807 308.034C176.057 316.206 107.99 345.612 107.99 345.612C107.043 345.329 106.129 344.942 105.266 344.46Z"
          fill="#354046"
        />
      </g>
      <mask
        id="mask434_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask434_31_1526)">
        <path
          d="M105.266 344.46L254.67 258.128C255.055 270.526 251.527 276.777 190.864 308.279C174.904 316.556 107.92 345.577 107.92 345.577C106.997 345.289 106.107 344.902 105.266 344.425"
          fill="#364146"
        />
      </g>
      <mask
        id="mask435_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask435_31_1526)">
        <path
          d="M105.266 344.46L254.601 258.128C255.02 270.701 251.423 276.603 189.922 308.523C173.752 316.905 107.815 345.543 107.815 345.543C106.933 345.262 106.08 344.9 105.266 344.46Z"
          fill="#364247"
        />
      </g>
      <mask
        id="mask436_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask436_31_1526)">
        <path
          d="M105.266 344.46L254.566 258.163C254.985 270.91 251.353 276.428 189.013 308.768C172.599 317.289 107.745 345.508 107.745 345.508C106.89 345.23 106.061 344.88 105.266 344.46Z"
          fill="#374247"
        />
      </g>
      <mask
        id="mask437_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask437_31_1526)">
        <path
          d="M105.301 344.46L254.566 258.163C254.985 271.085 251.283 276.219 188.21 309.012C171.586 317.638 107.885 345.473 107.885 345.473C107.052 345.211 106.245 344.872 105.475 344.46"
          fill="#384348"
        />
      </g>
      <mask
        id="mask438_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask438_31_1526)">
        <path
          d="M105.301 344.46L254.566 258.198C255.02 271.294 251.248 276.044 187.232 309.292C170.399 318.023 107.641 345.473 107.641 345.473C106.838 345.19 106.056 344.852 105.301 344.46Z"
          fill="#384348"
        />
      </g>
      <mask
        id="mask439_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask439_31_1526)">
        <path
          d="M105.301 344.46L254.496 258.233C254.95 271.504 251.003 275.695 186.289 309.536C169.212 318.407 107.501 345.438 107.501 345.438C106.741 345.176 106.005 344.849 105.301 344.46Z"
          fill="#394449"
        />
      </g>
      <mask
        id="mask440_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask440_31_1526)">
        <path
          d="M105.301 344.46L254.461 258.233C254.95 271.678 250.969 275.695 185.346 309.78C168.059 318.756 107.396 345.403 107.396 345.403C106.672 345.149 105.971 344.834 105.301 344.46Z"
          fill="#3A4449"
        />
      </g>
      <mask
        id="mask441_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask441_31_1526)">
        <path
          d="M105.301 344.46L254.461 258.233C254.95 271.853 250.969 275.485 184.613 310.025C167.151 319.105 107.501 345.368 107.501 345.368C106.791 345.12 106.102 344.816 105.44 344.46"
          fill="#3A454A"
        />
      </g>
      <mask
        id="mask442_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask442_31_1526)">
        <path
          d="M105.301 344.46L254.461 258.268C254.915 272.237 250.969 275.31 183.6 310.304C165.964 319.594 107.291 345.368 107.291 345.368C106.61 345.107 105.945 344.803 105.301 344.46Z"
          fill="#3B464A"
        />
      </g>
      <mask
        id="mask443_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask443_31_1526)">
        <path
          d="M105.301 344.46L254.391 258.268C254.845 272.237 250.899 275.101 182.622 310.653C164.671 319.978 107.187 345.577 107.187 345.577C106.54 345.341 105.91 345.061 105.301 344.739"
          fill="#3C464B"
        />
      </g>
      <mask
        id="mask444_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask444_31_1526)">
        <path
          d="M105.301 344.46L254.356 258.303C254.845 272.272 250.864 274.961 181.714 310.688C163.554 320.118 107.117 345.193 107.117 345.193C107.117 345.193 105.755 344.634 105.301 344.355"
          fill="#3C474B"
        />
      </g>
      <mask
        id="mask445_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask445_31_1526)">
        <path
          d="M105.301 344.46L254.356 258.303C254.845 272.621 250.864 274.752 180.841 311.038C162.436 320.572 107.047 345.263 107.047 345.263C106.451 345.026 105.868 344.758 105.301 344.46Z"
          fill="#3D474C"
        />
      </g>
      <mask
        id="mask446_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask446_31_1526)">
        <path
          d="M105.301 344.46L254.286 258.338C254.775 272.831 250.794 274.577 179.863 311.317C161.249 320.991 106.942 345.228 106.942 345.228C106.38 345.007 105.831 344.75 105.301 344.46Z"
          fill="#3D484D"
        />
      </g>
      <mask
        id="mask447_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask447_31_1526)">
        <path
          d="M105.301 344.46L254.251 258.338C254.74 272.971 250.584 274.368 178.99 311.527C160.166 321.305 106.907 345.158 106.907 345.158C106.371 344.956 105.846 344.723 105.336 344.46"
          fill="#3E484D"
        />
      </g>
      <mask
        id="mask448_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask448_31_1526)">
        <path
          d="M105.301 344.495L254.251 258.407C254.74 273.215 250.48 274.228 178.047 311.841C158.979 321.724 106.803 345.193 106.803 345.193L105.336 344.495"
          fill="#3F494E"
        />
      </g>
      <mask
        id="mask449_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask449_31_1526)">
        <path
          d="M105.336 344.495L254.216 258.407C254.705 273.39 250.41 274.053 177.139 312.085C157.861 322.109 106.593 345.158 106.593 345.158L105.196 344.495"
          fill="#3F4A4E"
        />
      </g>
      <mask
        id="mask450_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask450_31_1526)">
        <path
          d="M105.336 344.495L254.182 258.442C254.705 273.599 250.34 273.879 176.231 312.365C156.744 322.493 106.593 345.158 106.593 345.158L105.301 344.495"
          fill="#404A4F"
        />
      </g>
      <mask
        id="mask451_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask451_31_1526)">
        <path
          d="M105.336 344.495L254.147 258.442C254.67 273.774 250.27 273.669 175.288 312.574C155.487 322.772 106.593 345.089 106.593 345.089L105.406 344.495"
          fill="#414B4F"
        />
      </g>
      <mask
        id="mask452_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask452_31_1526)">
        <path
          d="M105.336 344.495L254.112 258.477C254.636 273.983 250.2 273.494 174.38 312.854C154.439 323.086 106.593 345.089 106.593 345.089L105.475 344.495"
          fill="#414B50"
        />
      </g>
      <mask
        id="mask453_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask453_31_1526)">
        <path
          d="M105.336 344.495L106.383 345.089C106.383 345.089 153.286 323.575 173.472 313.133C250.13 273.355 254.601 274.193 254.077 258.512L105.336 344.495Z"
          fill="#424C50"
        />
      </g>
      <mask
        id="mask454_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="105"
        y="240"
        width="152"
        height="105"
      >
        <path
          d="M106.593 335.938C105.384 338.557 104.878 341.446 105.126 344.32L256.766 256.731L228.024 240.142L106.593 335.938Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask454_31_1526)">
        <path
          d="M58.363 268.535L146.267 412.038L303.145 315.892L215.276 172.425L58.363 268.535Z"
          fill="url(#paint10_linear_31_1526)"
        />
      </g>
      <mask
        id="mask455_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="256"
        y="240"
        width="153"
        height="105"
      >
        <path
          d="M256.766 256.731L408.406 344.285C408.638 341.48 408.132 338.663 406.939 336.113L285.508 240.142L256.766 256.731Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask455_31_1526)">
        <path
          d="M455.902 270.177L364.821 413.12L209.549 314.251L300.63 171.307L455.902 270.177Z"
          fill="url(#paint11_linear_31_1526)"
        />
      </g>
      <mask
        id="mask456_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="227"
        y="81"
        width="30"
        height="176"
      >
        <path
          d="M252.819 84.2766C251.68 85.2361 250.671 86.3396 249.816 87.5594L227.989 240.142L256.766 256.731V81.6224C255.36 82.3466 254.047 83.2378 252.854 84.2766"
          fill="white"
        />
      </mask>
      <g mask="url(#mask456_31_1526)">
        <path
          d="M228.024 80.6445L262.843 81.8319L256.696 257.709L221.912 256.521L228.024 80.6445Z"
          fill="url(#paint12_linear_31_1526)"
        />
      </g>
      <mask
        id="mask457_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="105"
        y="84"
        width="303"
        height="255"
      >
        <path
          d="M106.593 335.345C106.068 336.464 105.658 337.634 105.371 338.837C105.685 338.628 228.373 250.549 232.633 247.721C235.637 245.695 235.881 245.625 239.025 246.743L230.783 241.714L227.954 240.212L106.593 335.345ZM282.714 241.749C282.714 241.749 259.56 255.998 260.817 255.544C266.413 253.104 272.165 251.039 278.035 249.362C283.727 248.314 287.709 251.842 290.991 254.042C291.585 254.426 407.323 338.488 407.847 338.872C407.565 337.681 407.191 336.513 406.729 335.38L285.299 240.212L282.714 241.749ZM250.969 86.0577L249.781 87.5245L228.058 240.142L240.352 246.254C238.684 245.189 237.447 243.568 236.859 241.679C236.597 240.153 236.597 238.594 236.859 237.069C237.139 233.576 238.326 224.81 252.191 84.5909C252.191 84.5909 251.562 85.1497 250.899 85.918"
          fill="white"
        />
      </mask>
      <g mask="url(#mask457_31_1526)">
        <path
          d="M407.952 84.7305H105.475V338.942H407.952V84.7305Z"
          fill="url(#paint13_radial_31_1526)"
        />
      </g>
      <mask
        id="mask458_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask458_31_1526)">
        <path
          d="M232.913 240.177C232.096 238.865 231.762 237.309 231.97 235.777C232.319 231.097 250.969 86.0927 250.969 86.0927L250.375 86.8261L249.781 87.5595L228.058 239.269C227.954 239.867 227.646 240.41 227.185 240.806L106.593 335.38C106.342 335.95 106.121 336.533 105.929 337.126L230.887 241.853L251.667 253.239L253.518 253.832C253.518 253.832 234.24 241.784 232.913 240.247"
          fill="#545D62"
        />
      </g>
      <mask
        id="mask459_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask459_31_1526)">
        <path
          d="M256.766 287.185L112.635 347.254H113.229H113.578L255.823 290.258C256.098 290.137 256.395 290.074 256.696 290.074C256.997 290.074 257.294 290.137 257.569 290.258L399.954 347.533H400.478H401.002L256.766 287.185Z"
          fill="#4F585D"
        />
      </g>
      <mask
        id="mask460_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask460_31_1526)">
        <path
          d="M285.508 240.142L406.939 335.31C407.208 335.877 407.441 336.46 407.637 337.056C406.939 336.672 287.813 245.451 282.854 241.714L285.508 240.142Z"
          fill="#70777A"
        />
      </g>
      <mask
        id="mask461_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask461_31_1526)">
        <path
          d="M282.819 241.784L274.228 247.197L273.704 246.254C279.92 242.936 283.029 241.295 282.54 237.628C282.156 234.694 263.017 86.5816 263.017 86.5816L263.611 87.3849L285.404 240.002L282.819 241.784Z"
          fill="#5A6469"
        />
      </g>
      <mask
        id="mask462_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask462_31_1526)">
        <path
          d="M105.021 343.342L251.388 257.115L252.191 256.661C252.4 256.661 252.75 256.067 252.191 255.299L254.077 256.836L105.091 344.041L105.021 343.342Z"
          fill="black"
        />
      </g>
      <mask
        id="mask463_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask463_31_1526)">
        <path
          d="M408.441 343.342L261.585 256.906C261.585 256.906 261.027 256.626 260.957 256.242C260.971 255.79 261.144 255.357 261.446 255.02L259.071 256.731L408.441 344.041V343.342Z"
          fill="black"
        />
      </g>
      <mask
        id="mask464_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask464_31_1526)">
        <path
          d="M256.312 81.8668L255.928 82.1113L254.566 252.331C254.622 252.689 254.622 253.054 254.566 253.413C254.251 253.867 253.902 253.832 252.924 253.728L255.578 254.461L256.417 81.8319L256.312 81.8668Z"
          fill="black"
        />
      </g>
      <mask
        id="mask465_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="255"
        y="258"
        width="4"
        height="32"
      >
        <path
          d="M255.439 258.687L256.277 286.975C256.277 286.975 256.277 289.944 256.766 289.944C257.255 289.944 257.15 286.975 257.15 286.975L258.058 258.687H255.439Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask465_31_1526)">
        <path
          d="M258.058 258.687H255.439V289.944H258.058V258.687Z"
          fill="url(#paint14_linear_31_1526)"
        />
      </g>
      <mask
        id="mask466_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask466_31_1526)">
        <path
          d="M273.774 246.254L257.744 254.531H255.648C255.648 254.531 231.202 241.364 230.887 241.714C230.573 242.063 254.391 256.731 254.391 256.731L255.613 258.512H257.849L259.071 256.731L274.228 247.197C277.204 245.545 280.084 243.726 282.854 241.749C279.754 243.097 276.723 244.6 273.774 246.254Z"
          fill="white"
        />
      </g>
      <mask
        id="mask467_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask467_31_1526)">
        <path
          d="M258.687 259.56C257.373 259.455 256.054 259.455 254.74 259.56L105.51 344.6L105.091 344.32V343.761L253.274 257.01C254.096 255.962 254.734 254.781 255.159 253.518L256.172 81.7621L256.766 81.6224L257.22 81.8668L258.198 253.588C258.619 254.867 259.283 256.053 260.154 257.08L408.441 343.727V344.32L407.987 344.6L258.687 259.56Z"
          fill="white"
        />
      </g>
      <mask
        id="mask468_31_1526"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="63"
        y="63"
        width="387"
        height="387"
      >
        <path d="M450 63.4968H63.4969V450H450V63.4968Z" fill="white" />
      </mask>
      <g mask="url(#mask468_31_1526)">
        <path
          d="M257.953 261.69C257.953 261.096 257.953 260.084 258.407 259.839C258.861 259.595 260.014 260.223 260.223 260.363C260.942 259.687 261.441 258.811 261.655 257.849C261.166 257.499 260.188 257.15 260.188 256.556C260.188 255.963 261.166 255.613 261.585 255.299C261.37 254.551 260.974 253.868 260.433 253.308C260.154 253.308 259.071 254.147 258.617 253.867C258.163 253.588 258.233 252.61 258.233 252.121C257.787 251.89 257.301 251.748 256.801 251.702C256.299 251.735 255.805 251.841 255.334 252.016C255.334 252.575 255.334 253.553 254.985 253.797C254.636 254.042 253.274 253.239 253.274 253.239C252.732 253.798 252.336 254.481 252.121 255.229C252.61 255.544 253.448 255.963 253.448 256.521C253.448 257.08 252.575 257.604 252.086 257.849C252.268 258.73 252.678 259.549 253.274 260.223C253.518 260.223 254.566 259.42 255.09 259.665C255.613 259.909 255.544 260.922 255.544 261.446C255.938 261.499 256.337 261.499 256.731 261.446C257.103 261.474 257.477 261.474 257.849 261.446"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_31_1526"
          x1="256"
          y1="0"
          x2="256"
          y2="512"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#050505" />
          <stop offset="0.495" stop-color="#181818" />
          <stop offset="0.775" stop-color="#252525" />
          <stop offset="1" stop-color="#343434" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_31_1526"
          x1="284.231"
          y1="239.99"
          x2="283.295"
          y2="238.369"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#70777A" />
          <stop offset="1" stop-color="#5A6469" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_31_1526"
          x1="145.895"
          y1="101.612"
          x2="417.751"
          y2="373.467"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="0.03" />
          <stop offset="0.17" stop-color="#3B464B" />
          <stop offset="0.5" stop-color="#B1B5B8" />
          <stop offset="0.83" stop-color="#DEDFDC" />
          <stop offset="0.95" stop-color="#FCFBF8" />
          <stop offset="0.96" stop-color="#FCFBF8" />
          <stop offset="1" stop-color="#FCFBF8" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_31_1526"
          x1="145.895"
          y1="101.612"
          x2="417.751"
          y2="373.467"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FCFBF8" />
          <stop offset="0.03" stop-color="#FCFBF8" />
          <stop offset="0.17" stop-color="#EDEEEC" />
          <stop offset="0.4" stop-color="#C2C4C6" />
          <stop offset="0.83" stop-color="#303D43" />
          <stop offset="0.97" stop-color="#485156" />
          <stop offset="1" stop-color="#485156" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_31_1526"
          x1="387.476"
          y1="73.1658"
          x2="387.476"
          y2="457.627"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EDEEEC" />
          <stop offset="0.03" stop-color="#EDEEEC" />
          <stop offset="0.17" stop-color="#6C7276" />
          <stop offset="0.5" stop-color="#162227" />
          <stop offset="0.83" />
          <stop offset="0.97" stop-color="#333E43" />
          <stop offset="1" stop-color="#333E43" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_31_1526"
          x1="70.6583"
          y1="183.868"
          x2="342.513"
          y2="455.723"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#162227" />
          <stop offset="0.17" stop-color="#162227" />
          <stop offset="0.46" stop-color="#424C50" />
          <stop offset="0.83" stop-color="#E2E3DF" />
          <stop offset="1" stop-color="#E2E3DF" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_31_1526"
          x1="183.821"
          y1="81.3764"
          x2="183.821"
          y2="414.421"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EDEEEC" />
          <stop offset="0.03" stop-color="#EDEEEC" />
          <stop offset="0.17" stop-color="#3C464B" />
          <stop offset="0.5" />
          <stop offset="0.57" stop-color="#070E11" />
          <stop offset="0.67" stop-color="#1D2C31" />
          <stop offset="0.78" stop-color="#394449" />
          <stop offset="0.83" stop-color="#485156" />
          <stop offset="0.97" stop-color="#626A6E" />
          <stop offset="1" stop-color="#626A6E" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_31_1526"
          x1="348.9"
          y1="73.2095"
          x2="348.9"
          y2="434.598"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#424C50" />
          <stop offset="0.03" stop-color="#424C50" />
          <stop offset="0.17" stop-color="#333E43" />
          <stop offset="0.5" />
          <stop offset="0.83" stop-color="#3C464B" />
          <stop offset="0.97" stop-color="#DEDFDC" />
          <stop offset="1" stop-color="#DEDFDC" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_31_1526"
          x1="84.0406"
          y1="134.972"
          x2="362.856"
          y2="413.787"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#3C464B" />
          <stop offset="0.03" stop-color="#3C464B" />
          <stop offset="0.04" stop-color="#465055" />
          <stop offset="0.09" stop-color="#626B70" />
          <stop offset="0.14" stop-color="#787F83" />
          <stop offset="0.19" stop-color="#848A8E" />
          <stop offset="0.24" stop-color="#888E91" />
          <stop offset="0.5" stop-color="#6C7276" />
          <stop offset="0.63" stop-color="#6F7679" />
          <stop offset="0.76" stop-color="#7A8185" />
          <stop offset="0.89" stop-color="#8C9296" />
          <stop offset="0.97" stop-color="#999FA3" />
          <stop offset="1" stop-color="#999FA3" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_31_1526"
          x1="426.969"
          y1="370.749"
          x2="154.526"
          y2="98.3062"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#3C464B" />
          <stop offset="0.03" stop-color="#3C464B" />
          <stop offset="0.07" stop-color="#444E53" />
          <stop offset="0.21" stop-color="#5A6266" />
          <stop offset="0.36" stop-color="#676E72" />
          <stop offset="0.5" stop-color="#6C7276" />
          <stop offset="0.63" stop-color="#6F7679" />
          <stop offset="0.76" stop-color="#7A8185" />
          <stop offset="0.89" stop-color="#8C9296" />
          <stop offset="0.97" stop-color="#999FA3" />
          <stop offset="1" stop-color="#999FA3" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_31_1526"
          x1="132.269"
          y1="277.719"
          x2="147.497"
          y2="302.576"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="0.5" stop-color="white" />
          <stop offset="0.61" stop-color="#FCFCFC" />
          <stop offset="0.72" stop-color="#F2F2F2" />
          <stop offset="0.83" stop-color="#E1E3E2" />
          <stop offset="0.94" stop-color="#CACCCB" />
          <stop offset="1" stop-color="#CACCCB" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_31_1526"
          x1="369.172"
          y1="306.217"
          x2="353.364"
          y2="331.029"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="0.35" stop-color="white" />
          <stop offset="0.48" stop-color="#FCFCFC" />
          <stop offset="0.62" stop-color="#F2F2F2" />
          <stop offset="0.76" stop-color="#E1E3E2" />
          <stop offset="0.9" stop-color="#CACCCB" />
          <stop offset="1" stop-color="#CACCCB" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_31_1526"
          x1="230.968"
          y1="169.175"
          x2="260.234"
          y2="170.197"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="0.5" stop-color="white" />
          <stop offset="0.61" stop-color="#FCFCFC" />
          <stop offset="0.72" stop-color="#F2F2F2" />
          <stop offset="0.83" stop-color="#E1E3E2" />
          <stop offset="0.94" stop-color="#CACCCB" />
          <stop offset="1" stop-color="#CACCCB" />
        </linearGradient>
        <radialGradient
          id="paint13_radial_31_1526"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(263.11 229.13) scale(181.505 181.505)"
        >
          <stop stop-color="#D7D8D6" />
          <stop offset="1" stop-color="#CACCCB" />
        </radialGradient>
        <linearGradient
          id="paint14_linear_31_1526"
          x1="262.973"
          y1="292.308"
          x2="262.973"
          y2="260.276"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#485156" />
          <stop offset="0.04" stop-color="#485156" />
          <stop offset="0.76" stop-color="white" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function MercedesBenzBkkBackground({
  className,
  width = "512",
}: {
  className?: string;
  width?: string;
}) {
  return (
    <svg
      width={width}
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <linearGradient
        id="paint0_linear_31_1526"
        x1="256"
        y1="0"
        x2="256"
        y2="512"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#050505" />
        <stop offset="0.495" stop-color="#181818" />
        <stop offset="0.775" stop-color="#252525" />
        <stop offset="1" stop-color="#343434" />
      </linearGradient>
    </svg>
  );
}

export const MercedesBenzBkk: InsuranceCorporateIdentity = {
  id: "mercedes-benz-bkk",
  name: "Mercedes-Benz BKK",
  logo: MercedesBenzBkkLogo,
  backgroundColor: "#000000",
  textColor: "#FFFFFF",
  wildcard: { and: ["mercedes", "benz"] },
  type: "statutory",
};
